import { Component, DestroyRef, ElementRef, HostListener, OnDestroy, TemplateRef, signal, ViewChild } from '@angular/core';
import { Subscription, lastValueFrom } from 'rxjs';
import * as Blockly from 'blockly';
import '@blockly/toolbox-search';
import { CrossTabCopyPaste } from '@blockly/plugin-cross-tab-copy-paste';
import { SiteService } from 'src/app/shared/services/site.service';
import BlocklyToolBox from 'src/assets/constants/cloud/blockly-toolbox';
import { BLOCKS, dynamicBlockBuilder } from 'src/assets/constants/cloud/predefined';
import { CodeGenerate } from 'src/assets/constants/cloud/predefined-code-generator';
import { javascriptGenerator } from 'blockly/javascript';
import { MatDialog } from '@angular/material/dialog';
import { MatTabGroup } from '@angular/material/tabs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastMessageComponent } from 'src/app/shared/components/toast-message/toast-message.component';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { SiteSequencerService } from './services/site-sequencer.service';
import { KeyboardShortcutService } from 'src/app/services/keyboard-shortcut.service';
import {
  SequenceStatus, BuilderMode, BlockType, DefaultTabName, CustomCategory,
  Category, DefaultCategoryTabName, scope, componentType, DeviceRunBlockType,
  toolBoxContentKind, BlockIdentifier, BlockFieldName, XMLEnum, BlocksLimitOnWorkspace
} from 'src/app/shared/enums/SequenceKeys.enum';
import { HostRoute } from 'src/app/shared/enums/Host.enum';
import { QuickFilterKey } from 'src/app/shared/enums/quick-filter.enum';
import { ConfirmModalComponent } from 'src/app/shared/components/confirm-modal/confirm-modal.component';
import { EditAndDeleteConfirmationModalComponent } from 'src/app/shared/components/edit-and-delete-confirmation-modal/edit-and-delete-confirmation-modal.component';
import { ObjectUtil } from 'src/app/shared/utils/object-util';
import { SEQUENCE_TEMPLATES } from 'src/assets/constants/cloud/sequence-templates';
import { CUSTOM_FUNCTIONS } from 'src/assets/constants/cloud/custom-functions';
import { UNIT_CONVERSION_BLOCKS } from 'src/assets/constants/cloud/unit-conversions';
import { BlocklyValidators } from 'src/assets/constants/cloud/validators';
import { SequenceValidationPopupComponent } from 'src/app/shared/components/sequence-validation-popup/sequence-validation-popup.component';
import { MatMenuTrigger } from '@angular/material/menu';
import { SequenceScopeSelectionModalComponent } from 'src/app/shared/components/sequence-scope-selection-modal/sequence-scope-selection-modal.component';
import DEVICE_TOOLBOX from 'src/assets/constants/device/blockly-toolbox-device';
import { DEVICE_BLOCKS } from 'src/assets/constants/device/predefined-device';
import { DeviceCodeGenerate, runContinuousPythonFun, runStartupPythonFun, sequenceRunRateMs } from 'src/assets/constants/device/predefined-code-generator-device';
import { pythonGenerator } from 'blockly/python';
import { CanvasTabs } from 'src/app/shared/interfaces/interfaces';
import { DEFAULT_TEMPLATE } from 'src/assets/constants/device/default-template';
import { Device } from './services/webusbdevice';
import { DFU } from './services/dfu-helper';
import { FeatureToggleService } from 'src/app/services/feature-toggle.service';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import { CcuLogsModalComponent } from 'src/app/shared/components/ccu-logs-modal/ccu-logs-modal.component';
import { CommonService } from 'src/app/services/common.service';
import { PushDevicePopupComponent } from 'src/app/shared/components/push-device-popup/push-device-popup.component';
import { dynamicDeviceModelBlockBuilder, MODEL_POINTS_BLOCKS } from 'src/assets/constants/device/model-points-blocks';
import { ModalListDialogComponent } from 'src/app/shared/components/modal-list-dialog/modal-list-dialog.component';
import { CommonSearchComponent } from 'src/app/shared/components/common-search/common-search.component';
import { DeliveryDebugInfoModalComponent } from 'src/app/shared/components/delivery-debug-info-modal/delivery-debug-info-modal.component';
import { PushToDeviceService } from 'src/app/services/push-to-device.service';
import { ConfettiService } from '../../services/confetti.service';

enum SiteSequencerCategory {
  SYSTEM = 'SITE_SEQUENCER_CCU',
  DEVICE = 'SITE_SEQUENCER_DEVICE',
  DEFAULT = 'SITE_SEQUENCER'
}

import { SubscriptionManagementService } from 'src/app/services/subscription-management.service';
import { RestrictionTypes, subscribedFeatures } from 'src/app/shared/enums/subscription.enum';
import { ANIMATION_DURATIONS } from 'src/assets/constants/common-pool';
import { COMMENTS_LAYOUT_MODE, COMMON_TOOL_WIDGETS } from '@75f/comments';
import { ToolTipType } from 'src/assets/constants/common-tooltip-data';
import { environment } from 'src/environments/environment.qa';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { PythonExecutionBatchResult, PythonExecutorService } from './services/python-executor.service';
import { AddPointModelComponent } from 'src/app/shared/components/add-point-model/add-point-model.component';
import { singlesiteSelectionDropdownConfig } from 'src/app/shared/constants/site-selection-dropdown.constants';
import { BlocklyWorkspaceBuilderService } from 'src/app/services/blockly-wokspace-builder.service';
dayjs.extend(utc);
declare var navigator: any;

@Component({
  selector: 'app-site-sequencer',
  templateUrl: './site-sequencer.component.html',
  styleUrls: ['./site-sequencer.component.scss'],
  standalone: false
})

/**
 * Represents the Site Sequencer component.
 */
export class SiteSequencerComponent implements OnDestroy {
  sites!: any[];
  languages!: any[];
  blocklyWorkSpace!: any;
  placeholderMessage: string = '';
  showToolBox: boolean = false;
  showToolBoxToggleButton: boolean = false;
  readOnlyMode = true;
  isCodeBlockVisible: boolean = false;
  codeBlockTooltipText = "Expand Code Snippet"
  codeSnippetHeight = 195;
  codeSnippetMaxHeight = 0;
  private isResizingCodeSnippet = false;
  private codeSnippetResizeStartY = 0;
  private codeSnippetResizeStartHeight = 195;
  code: string = '';
  categories = {
    CREATED_BY_ME: 'Created by Me',
    SHARED_BY_OTHERS: 'Shared by Others'
  }
  subscriptions!: Subscription;
  initSiteName = 'Select Site';
  initLanguageName = 'Select a language';
  selectedSite: any = null;
  selectedSiteId: any = '';
  singlesiteSelectionDropdownConfig = singlesiteSelectionDropdownConfig;
  selectedLanguageId: any = '';
  siteId: any = '';
  isInternalPortal: boolean = false;
  isSitesLoading = true;
  isLoading = false;
  sequences: any[] = [];
  sequencerBlock: any = null;
  tooltip: boolean = false;
  sequencerFunctionCollection: any[] = [];
  deviceTypeRestrictedBlocks: string[] = ['conn_mod_universal_input_number', 'conn_mod_relay_output_number'];
  porBusRestrictedBlocks: string[] = ['conn_mod_get_por_bus_value', 'por_bus_sensor_type', 'conn_mod_por_sensor_number'];
  deviceTypeFieldMap: Record<string, string> = {
    'conn_mod_universal_input_number': 'channel_number',
    'conn_mod_relay_output_number': 'relay_output_number',
  };
  bacnetBlockTypes: string[] = [
    'bacnet_object_instance',
    'bacnet_units',
    'conn_mod_configure_custom_bacnet_ai_object',
    'conn_mod_configure_custom_bacnet_av_object',
    'conn_mod_configure_custom_bacnet_bi_object',
    'conn_mod_configure_custom_bacnet_bv_object',
    'conn_mod_configure_custom_bacnet_msi_object',
    'conn_mod_configure_custom_bacnet_msv_object',
    'conn_mod_write_custom_bacnet_ai_object',
    'conn_mod_write_custom_bacnet_av_object',
    'conn_mod_read_custom_bacnet_av_object',
    'conn_mod_write_custom_bacnet_bi_object',
    'conn_mod_write_custom_bacnet_bv_object',
    'conn_mod_read_custom_bacnet_bv_object',
    'conn_mod_write_custom_bacnet_msi_object',
    'conn_mod_write_custom_bacnet_msv_object',
    'conn_mod_read_custom_bacnet_msv_object'
  ];
  isLoadingSequence: boolean = false;
  showSequenceActionButtons: boolean = false;
  isUpdatingExistingMarker: boolean = false;
  isLoadingAllSequences: boolean = false;
  workspaceXML: any = null;
  errorBlocks: any = [];
  alertHystersisValidationSummary: {
    blockId: string;
    name: string;
    errors: string[];
    upperLimitEnabled: boolean;
    lowerLimitEnabled: boolean;
    upperLimit: number | null;
    upperLimitFix: number | null;
    lowerLimit: number | null;
    lowerLimitFix: number | null;
  }[] = [];
  breadcrumbs: any[] = [];
  sequenceTabs: any[] = [];
  isSequenceTabSelected: boolean = false;
  selectedSequenceTab: any = null;
  sequenceTohighlight: any = null;
  activeTabIndex: number = 0;
  sequenceLogs: any[] = [];
  sequenceLogstableData: any[] = [];
  sequenceLogsHeaderColumns: any[] = [];
  sequenceLogsSubscription: any;
  sequenceLogsRefreshTime: number = 60000;
  dryRunLogsRefreshTime: number = 5000;
  defaultTabLabel: any = DefaultTabName.SITE_SEQUENCES;
  previousRunStatus = SequenceStatus.DISABLE;
  featureAccessible: boolean = true;
  // Prevent a response from a cleared AI search from restoring stale recommendations.
  private aiSearchRequestId = 0;
  builderMode: any = BuilderMode.SEQUENCE_BUILDER;
  blocklyContainerId: any = 'blockly-container';
  hideBlockCategory = ['API Integration'];
  hideBlockTypes = ['point_write_null'];

  @ViewChild('saveSeqFunctionDialog') saveSeqFunctionDialogTpl!: TemplateRef<any>;
  pendingProcedureBlock: any = null;
  pendingProcedureSourceFunctionId: string = '';
  pendingProcedureFunctionId: string = '';
  saveSeqFunctionForm: { name: string; why: string; what: string } = { name: '', why: '', what: '' };
  saveSeqFunctionError: string = '';
  isSavingSeqFunctionFromProcedure: boolean = false;
  readonly haystackQueryBuilderBlockType = 'haystack_query_builder';
  selectedHaystackQueryPreview: string = '';

  //Declaring the dropdown list for functions

  dropdownFunctionsList: any = {
    createdByMeFunctions: [],
    createdByOtherFunctions: []
  }

  dropdownAccordion: any = {
    createdByMeFunctions: false,
    createdByOtherFunctions: false
  };

  duplicateFunctionBlock: any = {
    createdByMeFunctions: [],
    createdByOtherFunctions: [false]
  }

  selectedQuickFilters: QuickFilterKey[] = [];
  customBlocksSearchText: string = '';

  // Flag indicating if data refresh is triggered by like/bookmark action, to prevent search text retention
  isLikeUnlikeRefresh: boolean = false;

  hoveredFunctionBlock: any;
  enableTableEdit: boolean = false;
  isDraggingFunctionBlock: boolean = false;
  dragPointerOffset: { x: number; y: number } = { x: 0, y: 0 };
  lastDragPointerPosition: { x: number; y: number } | null = null;
  modifiedFunctionBlocks: any = [];

  loadingText = 'Loading';
  loadingInterval: any;

  recommendedAIItems: any = [];
  isAISearchLoading: boolean = false;
  isAISearchActive: boolean = false;
  hoveredOnRecommendedItem: boolean = false;


  @ViewChild('showHideButton', { read: ElementRef }) showHideButton!: ElementRef;
  @ViewChild('sequenceTabGroup') sequenceTabGroup!: MatTabGroup;
  @ViewChild(MatMenuTrigger) menuTrigger!: MatMenuTrigger;
  @ViewChild('renameInput') renameInput!: ElementRef;
  @ViewChild(CommonSearchComponent) commonSearch!: CommonSearchComponent;
  toolBox: any;
  blocksToInit: any;
  skipDeleteFunctionEvent: boolean = false;
  isFunctionBlockClicked: boolean = false;
  selectedFunctionToView: any = null;
  isBuildingNewSequenceFunction: boolean = false;
  isDuplicatingSequenceFunction: boolean = false;
  isDeletingSequenceFunction: boolean = false;
  previousMode: any = null;
  activeSequencerBlockRef: any = null;
  isSearchActive: boolean = false;
  @ViewChild('workspaceTabsSearchInput') workspaceTabsSearchInputRef?: ElementRef<HTMLInputElement>;
  searchText: string = '';
  tempCanvasTabs: any = [];
  tempSequenceTab: any = [];
  isCreateCanvasLoading: boolean = false;
  isSwitchingCategoryTab: boolean = false;
  isSiteSelectionInProgress: boolean = false;
  clickTimer: any;
  blocklyInitRetryTimer: any = null;
  blocklyInitRetryCount: number = 0;
  readonly blocklyInitRetryLimit: number = 20;
  pendingWorkspaceCreateAfterBlocklyReady: boolean = false;
  canvasTabToSwitch: any = null;
  searchedSequenceLogsValue: any = null;
  isCreatingNewDeviceCanvas: boolean = false;
  selectedModelConfig: any = null;
  allModelsCollection: any = [];

  categoryMenu: any = {
    tabs: [
      { 'label': 'cloud', 'id': 'CLOUD' },
      { 'label': 'system', 'id': 'CCU' },
      { 'label': 'device', 'id': 'DEVICE' }
    ],
    activeTabIndex: 0,
    selectedCategory: { 'label': 'cloud', 'id': 'CLOUD' }
  }

  canvasTabs: CanvasTabs = {
    tabs: [],
    activeTabIndex: 0,
    selectedCanvasTab: null
  }
  deviceRunBlocksOnWorkspace: any[] = [];
  originalToolBoxContents: any;
  contextMenuPostion: {
    x: number,
    y: number
  } = { x: 0, y: 0 };
  showAlertWithOffsetBlocks: boolean = false;
  showSystemCategory: boolean = false;
  previousCCULogsRef: any = {};
  isPasteEventTriggered: boolean = false;
  noChangesInWorkspace: boolean = true;
  deprecatedBlocks: any = ['getHistorizedValue', 'getHistorizedValueFromDateRange', 'gethistorizedNVariant', 'gethistorizedDateTimeVariant', 'getAggregatedValues', 'getAggregatedValuesFromDateRange', 'getAggregatedValuesFromDateTimeVariant', 'getHistorizedValueExcludeMins', 'compare_date_inbetween'];
  modelPointBlocks: any[] = [];
  modelOptions: any[] = [];
  createdPointsCollection: any[] = [];
  blockDropdownClickSubscription!: Subscription;
  billingAdminDetails: any = {};
  userInfo: any = {};
  restrictionType: any = RestrictionTypes;

  cloudSequenceBlocks: any[] = [BlockType.SEQUENCE, BlockType.MQTT_SUBSCRIBE];
  mqttEnabled: boolean = false;
  lokiLogs: boolean = false;
  setterBlocksToinitialize: any = [];
  pointBlocksToInitialize: any = [];
  allModelsWithPoints: any = null;
  isLoadingSavedState: boolean = false;
  selectedModel: any = null;
  private _keyboardCopyPasteHandler: any;
  sequenceLastUpdatedTime: any = null;
  showWorkspaceWarningText: boolean = false;
  isListRefreshInProgress = false;
  isDryRunModalOpened: boolean = false;
  functionIdForDuplication: string | null = null;
  private pythonExecutionIntervalRef: any = null;
  private isPythonCycleInProgress = false;
  isPythonExecutionLoading = false;

  commentsPanelView: boolean = false;
  activeCommentsPanelConfig = {
    componentType: COMMON_TOOL_WIDGETS.SITE_SEQUENCER,
    layoutMode: COMMENTS_LAYOUT_MODE.PANEL,
    componentId: '',
    componentName: '',
    componentOwnerId: ''
  };
  sequencerTypeMap = {
    CLOUD: COMMON_TOOL_WIDGETS.SITE_SEQUENCER,
    CCU: COMMON_TOOL_WIDGETS.SITE_SEQUENCER_CCU,
    DEVICE: COMMON_TOOL_WIDGETS.SITE_SEQUENCER_DEVICE,
  }
  tooltipData!: any;
  pasteDelayTimer: any = null; // Timer to manage paste event delays
  pastedBlockIds = new Set<string>(); // Set to track pasted block IDs and avoid duplicates

  virtualFunctionsBlockList: any[] = [];
  isPersonalAccordionOpen: boolean = false;
  isSharedAccordionOpen: boolean = false;
  viewportHeight = signal(0);
  delayTimer: number = 0;
  siteDelayTimer: number = 0;

  @HostListener('window:click', ['$event'])
  onClick(event: MouseEvent) {
    const clickedElement = event.target as HTMLElement;
    const customBlocksDropdown: HTMLElement | null = document.getElementById('custom-blocks-dropdown');

    // Checking if the clicked element is not a descendant of the element with id "custom-blocks-dropdown"
    if (!customBlocksDropdown?.contains(clickedElement)) {
      if (this.menuTrigger) {
        this.menuTrigger.closeMenu();
      }
    }
  }

  constructor(public locaStorageService: LocalStorageService, private siteSequencerService: SiteSequencerService,
    private siteService: SiteService, private toastMessage: MatSnackBar,
    private dialog: MatDialog, public featureToggleService: FeatureToggleService,
    public commonService: CommonService, private pushToDeviceService: PushToDeviceService,
    private subscriptionManagementService: SubscriptionManagementService,
    public confettiService: ConfettiService,
    private configService: ConfigurationService,
    private pythonExecutorService: PythonExecutorService,
    private blocklyWorkspaceBuilderService: BlocklyWorkspaceBuilderService,
    private keyboardShortcutService: KeyboardShortcutService,
    private destroyRef: DestroyRef) {
    this.dropdownAccordion = {
      createdByMeFunctions: false,
      createdByOtherFunctions: false
    };
  }

  ngOnInit(): void {
    try {
      this.sequencerBlock = null;
      this.parseUrl();
      this.placeholderMessage = 'Select Site';
      this.getLanguages();
      this.modifiedFunctionBlocks = [];
      this.featureToggleService.flagChange.subscribe((flags) => {
        this.setFlags(flags);
      });
      this.useFeatureToggles();
      this.handleSubscriptions();
      this.subscriptions = this.subscriptionManagementService.data$.subscribe((subscriptionData: any) => {
        if (subscriptionData)
          this.checkIfSiteIsSubscribed(subscriptionData)
      });
      this.subscribeToSlashSearchFocus();
    } catch (error) {
      this.isLoading = false;
    }

  }

 // Method to register the '/' keyboard shortcut for focusing the workspace tabs search input.
  subscribeToSlashSearchFocus() {
    this.keyboardShortcutService.register({
      getSearchInput: () => this.workspaceTabsSearchInputRef,
      toggleHiddenSearchInput: () => {
        if (!this.isSearchActive) {
          this.searchbtnClicked();
        }
      }
    }, this.destroyRef);
  }

  useFeatureToggles() {
    let sub = this.featureToggleService.featureFlagsSubject.subscribe((flags) => {
      this.setFlags(flags);
      sub.unsubscribe();

    });
    this.featureToggleService.getFlags();
  }

  handleSubscriptions() {
    this.blockDropdownClickSubscription = this.commonService.blockDropdownClickEvent$.subscribe(data => {
      if (data && data.targetBlock && data.targetFieldName) {
        if (data.targetBlock && data.targetBlock.type) {
          if (data.targetFieldName === 'scope' && data.targetBlock.type === BlockType.SEQUENCE_SYSTEM) {
            this.showScopeSelectionDialog(data.targetBlock);
          }
          if (data.targetFieldName === BlockFieldName.SELECTED_MODEL && data.targetBlock.type === BlockType.MODEL_BLOCK) {
            this.showExternalOrPointsDialog(data.targetBlock, false)
          }
          if (data.targetFieldName === BlockFieldName.SELECTED_POINT_NAME && data.targetBlock.type === BlockType.POINT_SETTER) {
            this.showExternalOrPointsDialog(data.targetBlock, true)
          }
        }
      }
    });
  }

  setFlags(flags: any) {
    this.showAlertWithOffsetBlocks = flags.hasOwnProperty('alert-offset-blocks') ? flags['alert-offset-blocks']?.value : false;
    this.showSystemCategory = flags.hasOwnProperty('sequencer-on-ccu') ? flags['sequencer-on-ccu']?.value : false;
    this.mqttEnabled = flags.hasOwnProperty('mqtt') ? flags['mqtt']?.value : false;
    this.lokiLogs = flags.hasOwnProperty('lokilogs') ? flags['lokilogs']?.value : false;
    this.delayTimer = flags.hasOwnProperty('delay-timer-seq') ? flags['delay-timer-seq']?.value : 0;

    // Hiding the system category tab if the showSystemCategory is disabled
    if (!this.showSystemCategory) {
      this.categoryMenu.tabs = this.categoryMenu.tabs.filter((tab: any) => tab.id !== 'CCU');
    }
  }

  async parseUrl() {
    // Query params (token, userId, portal, selectedSiteId, etc.) are parsed once in AppComponent.
    this.isInternalPortal = this.locaStorageService.getPortal() === HostRoute.INTERNAL;
    if (environment.multiregion) {
      try {
        const regions = await lastValueFrom(this.siteSequencerService.getRegions())
        this.configService.setRegionList(regions.regions);
      } catch (error) {
        console.error('Error fetching regions:', error);
        this.configService.setRegionList(environment.regions);
      }
    } else {
      this.configService.setRegionList(environment.regions);
    }
    this.getAllSites(); // Fetch all the sites once we know the portal type
  }

  // Toast Message 
  showToast(type: string, message: string) {
    this.toastMessage.openFromComponent(ToastMessageComponent, {
      duration: 5000,
      panelClass: 'toast-snackbar-panel',
      data: {
        type: type,
        message: message
      },
    });
  }

  /**
   * Reinitializing the workspace for different tabs on toggling level tabs. 
   * @param event {any} - the event with the selected tab index and label.
   * @param initWorkspace {boolean} - the flag to initialize the workspace.
   */
  toggleCategoryLevelTab(event: any, initWorkspace?: boolean) {
    if (this.isSwitchingCategoryTab) {
      // Reverting activeTabIndex below re-triggers this same handler via the mat-tab-group's
      // two-way [(selectedIndex)] binding - skip that re-entrant call so validation doesn't run twice.
      this.isSwitchingCategoryTab = false;
      return;
    }
    this.isLoading = true;

    this.sequenceTabs = []; // Clearing the existing sequence tabs
    this.deviceRunBlocksOnWorkspace = []; // Clearing the existing device run blocks on workspace
    // Clearing the existing canvas tabs and selected canvas tab
    if (initWorkspace) {
      setTimeout(() => {
        this.canvasTabs.selectedCanvasTab = null;
        this.canvasTabs.tabs = [];
      }, 500);
    }
    const allBlocks = this.blocklyWorkSpace ? this.blocklyWorkSpace.getAllBlocks() : [];
    const switchTab = () => {
      this.categoryMenu.selectedCategory = this.categoryMenu.tabs[event.index];

      // Updating comment panel config component type on changing the tab
      this.activeCommentsPanelConfig.componentType = this.sequencerTypeMap[this.categoryMenu.selectedCategory.id as keyof typeof this.sequencerTypeMap];

      initWorkspace ? '' : this.toggleWorkspace('delete'); // Deleting the existing workspace
      setTimeout(() => {
        this.builderMode = BuilderMode.SEQUENCE_BUILDER; // Setting the builder mode
        this.previousMode = null;

        // Get the list of workspaces for the selected category level and add them as tabs.
        this.getWorkspacesForSelectedCategoryType();
      }, 500);
    };

    if (allBlocks.length === 0 || this.noChangesInWorkspace) {
      // If the Blockly workspace is empty, switch the tab immediately
      switchTab();
    } else {
      // If the Blockly workspace is not empty, check if blocks are valid
      const isSequencesValid = this.checkAndReturnErrorStatus();
      if (isSequencesValid) {
        // If blocks are valid, switch the tab after saving and deleting the ccurrent workspace
        this.isLoading = true;
        this.saveSequenceOnTabChange();

        switchTab();
      } else {
        // If blocks are not valid, fall back to the previous tab
        const previousTabIndex = this.categoryMenu.tabs.findIndex((tab: any) => tab.label === this.categoryMenu.selectedCategory.label);
        this.isSwitchingCategoryTab = true;
        this.categoryMenu.activeTabIndex = previousTabIndex;
        this.categoryMenu.selectedCategory = this.categoryMenu.tabs[previousTabIndex];
        this.isLoading = false;
      }
    }
  }

  /**
   * Fetching the workspaces for selected category level type and adding them as tabs.
   * @param selectedCategoryLevel {string} - the selected category level type. // Possible values: CLOUD, CCU, DEVICE
  */
  getWorkspacesForSelectedCategoryType() {
    const selectedCategoryLevel = this.categoryMenu.selectedCategory.id;

    const fetchWorkspaces = () => {
      // Get the list of workspaces for the selected category level and add them as tabs.
      this.siteSequencerService.getWorkspacesListForCategory(this.selectedSiteId, selectedCategoryLevel)
        .subscribe((res: any) => {
          if (res && res.length > 0) {
            // Adding the workspaces as canvas tabs

            res.forEach((canvasObj: any) => {
              canvasObj['tempName'] = canvasObj.name;
              canvasObj['isCanvasNameEdit'] = false;
              canvasObj['showMenu'] = false
            });

            this.canvasTabs.tabs = res;
            this.tempCanvasTabs = JSON.parse(JSON.stringify(res));
            if (this.canvasTabToSwitch) {
              this.canvasTabs.selectedCanvasTab = this.canvasTabToSwitch;
              this.activeTabIndex = this.canvasTabs.tabs.findIndex((tab: any) => tab.id === this.canvasTabToSwitch.id);
            } else {
              this.canvasTabToSwitch = null;
              this.canvasTabs.selectedCanvasTab = this.canvasTabs.tabs[0];
              this.activeTabIndex = 0;
            }

            this.switchToSelectedTab(this.canvasTabs.selectedCanvasTab);
          } else {
            const initWorkspace = true;
            this.createNewCanvasTab(initWorkspace);
          }
        }, (err: any) => {
          this.isLoading = false;
          this.showToast('error', `${err.message}`);
        });
    };

    const siteTimerDelayMs = Math.max(Number(this.siteDelayTimer) || 0, 0) * 1000;
    if (siteTimerDelayMs > 0) {
      setTimeout(() => fetchWorkspaces(), siteTimerDelayMs);
    } else {
      fetchWorkspaces();
    }
  }

  // Method to handle the tooltip display and update its position in align with dropdown menu
  hoveredFunction(event: Event) {
    this.tooltip = true;
    const toolTipPostionX = document.getElementsByClassName('cdk-overlay-pane')[0].getBoundingClientRect().x;
    let selectedRow = event?.target as HTMLHtmlElement;
    let toolTipPostionY = selectedRow.parentElement?.getBoundingClientRect().top || 0;
    const element = document.getElementById('custom-block-tooltip');
    setTimeout(() => {
      if (element) {
        const tooltipWidth = element?.getBoundingClientRect().width;
        element.style.left = toolTipPostionX - tooltipWidth + 'px';
        const tooltipHeight = element?.getBoundingClientRect().height;
        const totalHeight = toolTipPostionY + tooltipHeight;
        if (totalHeight > window.innerHeight) {
          toolTipPostionY = window.innerHeight - tooltipHeight - 20;
        }
        element.style.top = toolTipPostionY + 'px';
      }
    }, 1);
  }

  // Method to handle the tooltip hide
  unhoveredFunction() {
    this.tooltip = false;
  }

  /** method to initialize blockly workspace and show default blocks */
  async initializeBlockly() {
    if (this.categoryMenu.selectedCategory.id === Category.DEVICE) {
      this.toolBox = DEVICE_TOOLBOX;
      this.blocksToInit = DEVICE_BLOCKS;
      this.blocksToInit = this.blocksToInit.concat(MODEL_POINTS_BLOCKS);
    } else {
      this.toolBox = ObjectUtil.deepClone(BlocklyToolBox);
      this.blocksToInit = BLOCKS;
      this.blocksToInit = this.blocksToInit.concat(UNIT_CONVERSION_BLOCKS);
      this.blocksToInit = this.blocksToInit.concat(SEQUENCE_TEMPLATES);
      this.blocksToInit = this.blocksToInit.concat(CUSTOM_FUNCTIONS);
    }


    // Backup the original toolBox contents
    this.originalToolBoxContents = [...this.toolBox.contents];

    if (this.builderMode === BuilderMode.SEQUENCE_BUILDER) {
      if (this.categoryMenu.selectedCategory.id === Category.DEVICE || this.categoryMenu.selectedCategory.id === Category.SYSTEM) {
        this.toolBox.contents = this.toolBox.contents.filter((category: any) => !this.hideBlockCategory.includes(category.name));
        if (this.categoryMenu.selectedCategory.id === Category.SYSTEM) {
          this.hideBlocksInSystemCategory();
        }
      } else {
        this.toolBox.contents = [...this.originalToolBoxContents];
      }
      await this.getAndCreateSequenceFunctions();
    } else {
      this.toolBox.contents = this.toolBox.contents.filter((category: any) => !this.hideBlockCategory.includes(category.name));
      if (this.categoryMenu.selectedCategory.id === Category.SYSTEM) {
        this.hideBlocksInSystemCategory();
      }
      await this.initializeBlocklyWorkspace();
    }
  }

  // Method to hide the blocks in system category based on the feature toggle
  hideBlocksInSystemCategory() {
    const alertBlocksToHideForCCU = ['alertWithOffset', 'alertHystersis'];
    if (!this.showAlertWithOffsetBlocks) {
      this.toolBox.contents = this.toolBox.contents.map((category: any) => {
        category.contents = category.contents.filter((block: any) => !alertBlocksToHideForCCU.includes(block.type));
        return category;
      });
    }
  }


  async initializeBlocklyWorkspace() {

    this.toggleBlocksByBuilderMode();
    this.toggleCategoriesByBuilderMode();

    this.blocklyWorkspaceBuilderService.registerBlockDefinitions(this.blocksToInit);
    if (this.categoryMenu.selectedCategory.id === Category.DEVICE) {
      DeviceCodeGenerate.addCodeGenerators();
    } else {
      if (this.categoryMenu.selectedCategory.id === Category.CLOUD) {
        dynamicBlockBuilder.httpHeaderBlocksInit();
        dynamicBlockBuilder.httpRequestBlocksInit();
        dynamicBlockBuilder.httpRequestBodyBlocksInit();
        CodeGenerate.mqttTemplates();
      }
      CodeGenerate.addCodeGenerators();
      CodeGenerate.sequenceTemplates();
      CodeGenerate.customFunctions();
      CodeGenerate.unitConversionTemplates();
      CodeGenerate.externalAPIItegrattionTemplates();
      BlocklyValidators.addValidators();
    }


    if (!this.blocklyWorkSpace) {
      this.blocklyWorkSpace = await this.blocklyWorkspaceBuilderService.createWorkspaceWithRetry({
        existingWorkspace: this.blocklyWorkSpace,
        selectedSite: this.selectedSite,
        blocklyContainerId: this.blocklyContainerId,
        toolbox: this.toolBox,
        themeName: 'customTheme',
        retryLimit: this.blocklyInitRetryLimit,
        retryDelayMs: 50
      });

      if (!this.blocklyWorkSpace) {
        this.isLoading = false;
        this.isCreateCanvasLoading = false;
        return;
      }

      this.initCrossTabCopyPaste();
      this.blocklyWorkSpace.getToolbox()?.setVisible(false);
      this.formatCategoryNames();
      this.initializeToolboxSearch();

      setTimeout(() => {
        this.subscribeToBlocklyEvents();
      }, 500);
    }

    this.tryCreateWorkspaceAfterBlocklyReady();
  }

  // Getting sequence functions from API and creating the minimal function blocks for the functions in sequence builder dropdown
  getAndCreateSequenceFunctions() {
    this.sequencerFunctionCollection = [];
    this.isLoading = true;

    this.pendingWorkspaceCreateAfterBlocklyReady =
      (!!this.selectedSite && !this.previousMode) ||
      this.previousMode === BuilderMode.LIBRARY_BUILDER;

    this.initializeBlocklyWorkspace();
  }

  private tryCreateWorkspaceAfterBlocklyReady() {
    if (!this.pendingWorkspaceCreateAfterBlocklyReady || !this.blocklyWorkSpace) {
      return;
    }

    this.pendingWorkspaceCreateAfterBlocklyReady = false;

    if (!this.previousMode && this.selectedSite) {
      this.toggleWorkspace('create');
      return;
    }

    if (this.previousMode === BuilderMode.LIBRARY_BUILDER) {
      this.toggleWorkspace('create');
      this.previousMode = null;
    }
  }

  /**
  * Adding the function as a miniature block that is dragged and dropped from custom blocks dropdown to workspace. 
  * @param blockConfig {any} - the function block object that is dragged from the Custom blocks dropdown.
  */
  addSelectedFunctionBlockInWorkspace(event: any, blockConfig: any) {
    const blocksXml = this.extractFunctionBlocksXml(blockConfig?.xml);
    if (!blocksXml) {
      this.addEmptyProcedureAtDropPoint(event, blockConfig);
      return;
    }
    this.addFunctionBlocksWithFunctionWrapperAtDropPoint(event, blocksXml, blockConfig);
  }

  private extractFunctionBlocksXml(xml: any): string {
    if (!xml || typeof xml !== 'string') {
      return '';
    }
    const trimmed = xml.trim();
    if (!trimmed) {
      return '';
    }
    const wrappedXml = trimmed.startsWith('<xml')
      ? trimmed
      : `<xml xmlns="https://developers.google.com/blockly/xml">${trimmed}</xml>`;
    try {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(wrappedXml, 'text/xml');
      const root = xmlDoc.documentElement;
      if (!root) {
        return '';
      }
      // Find the top-level container block and extract the blocks inside its CODE statement.
      const containerTypes = [
        BlockType.SEQUENCER,
        BlockType.SEQUENCE,
        BlockType.SEQUENCE_SYSTEM,
        BlockType.SEQUENCE_DEVICE
      ];
      const containerBlock = Array.from(root.children).find((el: any) =>
        el?.tagName?.toLowerCase() === 'block' && containerTypes.includes(el.getAttribute('type') || '')
      ) as Element | undefined;
      const variablesNode = Array.from(root.children).find((el: any) =>
        el?.tagName?.toLowerCase() === 'variables'
      ) as Element | undefined;
      if (!containerBlock) {
        return trimmed;
      }
      const statement = Array.from(containerBlock.children).find((child: any) =>
        child?.tagName?.toLowerCase() === 'statement' && child.getAttribute('name') === 'CODE'
      ) as Element | undefined;
      if (!statement) {
        return '';
      }
      const firstBlock = Array.from(statement.children).find((child: any) =>
        child?.tagName?.toLowerCase() === 'block'
      ) as Element | undefined;
      if (!firstBlock) {
        return '';
      }
      const dependentProcedureBlocks = Array.from(root.children).filter((child: any) =>
        child?.tagName?.toLowerCase() === 'block' &&
        child !== containerBlock &&
        this.isProcedureDefinitionBlock({ type: child.getAttribute('type') || '' })
      ) as Element[];
      const serializer = new XMLSerializer();
      const variablesXml = variablesNode ? serializer.serializeToString(variablesNode) : '';
      const blockXml = serializer.serializeToString(firstBlock);
      const dependentProcedureXml = dependentProcedureBlocks
        .map((procedureBlock: Element) => serializer.serializeToString(procedureBlock))
        .join('');
      return `<xml xmlns="https://developers.google.com/blockly/xml">${variablesXml}${blockXml}${dependentProcedureXml}</xml>`;
    } catch {
      return '';
    }
  }

  private async addFunctionBlocksWithFunctionWrapperAtDropPoint(event: any, blocksXml: string, blockConfig: any): Promise<void> {
    if (!blocksXml || !this.blocklyWorkSpace) {
      return;
    }
    const procedureName = (blockConfig?.seqFunctionName || '').trim();
    if (!procedureName) {
      return;
    }
    if (this.isProcedureNameDuplicate(procedureName)) {
      this.showToast('error', `Function name "${procedureName}" already exists.`);
      return;
    }
    const workspaceXml = blocksXml.trim().startsWith('<xml')
      ? blocksXml
      : `<xml xmlns="https://developers.google.com/blockly/xml">${blocksXml}</xml>`;
    const parser = new DOMParser();
    const xmlDoc: any = parser.parseFromString(workspaceXml, 'text/xml');

    const beforeBlockIds = new Set(this.blocklyWorkSpace.getAllBlocks(false).map((b: any) => b.id));
    await Blockly.Xml.domToWorkspace(xmlDoc.documentElement, this.blocklyWorkSpace);
    const newBlocks = this.blocklyWorkSpace.getAllBlocks(false).filter((b: any) => !beforeBlockIds.has(b.id));
    this.prepareHaystackQueryBuilderBlocks(newBlocks);
    if (!newBlocks.length) {
      return;
    }

    // Create wrapper Blockly procedure block and set name.
    const functionBlock = this.blocklyWorkSpace.newBlock('procedures_defnoreturn');
    functionBlock.initSvg();
    if (blockConfig?.seqFunctionName) {
      functionBlock.setFieldValue(blockConfig.seqFunctionName, 'NAME');
    }
    this.setProcedureDescription(functionBlock, blockConfig);
    this.setProcedureLibraryMetadata(functionBlock, blockConfig);

    // Find the top block of the inserted chain and connect it to the procedure stack.
    const topInsertedBlock = newBlocks.find((block: any) => !block.getParent() && !this.isProcedureDefinitionBlock(block)) ||
      newBlocks.find((block: any) => !block.getParent()) ||
      newBlocks[0];
    const stackInput = functionBlock.getInput('STACK');
    if (stackInput?.connection && topInsertedBlock?.previousConnection) {
      stackInput.connection.connect(topInsertedBlock.previousConnection);
    }
    functionBlock.render();

    const dropPoint = this.getDropPoint(event);
    if (!dropPoint) {
      return;
    }
    const adjustedX = dropPoint.x - (this.dragPointerOffset?.x || 0);
    const adjustedY = dropPoint.y - (this.dragPointerOffset?.y || 0);
    const pointX = adjustedX / this.blocklyWorkSpace.scale;
    const pointY = adjustedY / this.blocklyWorkSpace.scale;
    const metrics = this.blocklyWorkSpace.getMetricsManager().getAbsoluteMetrics(true);
    const workspaceX = pointX - metrics.left - (this.blocklyWorkSpace.scrollX / this.blocklyWorkSpace.scale);
    const workspaceY = pointY - metrics.top - (this.blocklyWorkSpace.scrollY / this.blocklyWorkSpace.scale);

    // Move wrapper (and connected blocks) to the drop point.
    const blockPosition = functionBlock.getRelativeToSurfaceXY();
    functionBlock.moveBy(workspaceX - blockPosition.x, workspaceY - blockPosition.y);
  }

  private addEmptyProcedureAtDropPoint(event: any, blockConfig: any): void {
    if (!this.blocklyWorkSpace) {
      return;
    }
    const procedureName = (blockConfig?.seqFunctionName || '').trim();
    if (!procedureName) {
      return;
    }
    if (this.isProcedureNameDuplicate(procedureName)) {
      this.showToast('error', `Function name "${procedureName}" already exists.`);
      return;
    }
    const functionBlock = this.blocklyWorkSpace.newBlock('procedures_defnoreturn');
    functionBlock.initSvg();
    functionBlock.setFieldValue(procedureName, 'NAME');
    this.setProcedureDescription(functionBlock, blockConfig);
    this.setProcedureLibraryMetadata(functionBlock, blockConfig);
    functionBlock.render();

    const dropPoint = this.getDropPoint(event);
    if (!dropPoint) {
      return;
    }
    const adjustedX = dropPoint.x - (this.dragPointerOffset?.x || 0);
    const adjustedY = dropPoint.y - (this.dragPointerOffset?.y || 0);
    const pointX = adjustedX / this.blocklyWorkSpace.scale;
    const pointY = adjustedY / this.blocklyWorkSpace.scale;
    const metrics = this.blocklyWorkSpace.getMetricsManager().getAbsoluteMetrics(true);
    const workspaceX = pointX - metrics.left - (this.blocklyWorkSpace.scrollX / this.blocklyWorkSpace.scale);
    const workspaceY = pointY - metrics.top - (this.blocklyWorkSpace.scrollY / this.blocklyWorkSpace.scale);

    const blockPosition = functionBlock.getRelativeToSurfaceXY();
    functionBlock.moveBy(workspaceX - blockPosition.x, workspaceY - blockPosition.y);
  }

  private setProcedureDescription(functionBlock: any, blockConfig: any): void {
    if (!functionBlock) {
      return;
    }

    const description = this.buildProcedureDescription(blockConfig);
    if (!description) {
      return;
    }

    functionBlock.setTooltip?.(description);
    functionBlock.setCommentText?.(description);
  }

  private setProcedureLibraryMetadata(functionBlock: any, blockConfig: any): void {
    if (!functionBlock) {
      return;
    }

    const functionId = (blockConfig?.functionId || '').trim();
    const sourceFunctionId = (blockConfig?.sourceFunctionId || '').trim();
    const why = (blockConfig?.why || '').trim();
    const what = (blockConfig?.what || '').trim();
    const xml = (blockConfig?.xml || '').trim();
    const snippet = (blockConfig?.snippet || '').trim();

    if (!functionId && !sourceFunctionId && !why && !what && !xml && !snippet) {
      functionBlock.data = null;
      return;
    }

    functionBlock.data = JSON.stringify({ functionId, sourceFunctionId, why, what, xml, snippet });
  }

  private getProcedureLibraryMetadata(procedureBlock: any): { functionId: string; sourceFunctionId: string; why: string; what: string; xml: string; snippet: string } {
    const emptyMetadata = { functionId: '', sourceFunctionId: '', why: '', what: '', xml: '', snippet: '' };
    const rawData = procedureBlock?.data;

    if (!rawData || typeof rawData !== 'string') {
      return emptyMetadata;
    }

    try {
      const parsed = JSON.parse(rawData);
      if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
        return emptyMetadata;
      }

      return {
        functionId: (parsed.functionId || '').trim(),
        sourceFunctionId: (parsed.sourceFunctionId || '').trim(),
        why: (parsed.why || '').trim(),
        what: (parsed.what || '').trim(),
        xml: (parsed.xml || '').trim(),
        snippet: (parsed.snippet || '').trim()
      };
    } catch {
      return {
        ...emptyMetadata,
        functionId: rawData.trim()
      };
    }
  }

  private upsertSequenceFunctionInCollection(functionObj: any): void {
    if (!functionObj?.functionId) {
      return;
    }

    const collection = this.sequencerFunctionCollection || [];
    const existingIndex = collection.findIndex((item: any) => item?.functionId === functionObj.functionId);
    const existingFunction = existingIndex >= 0 ? collection[existingIndex] : null;
    const mergedFunction = this.mergeSequenceFunctionWithExisting(
      functionObj,
      new Map(existingFunction ? [[functionObj.functionId, existingFunction]] : []),
      functionObj.category || existingFunction?.category || this.categories.CREATED_BY_ME
    );

    if (existingIndex >= 0) {
      this.sequencerFunctionCollection[existingIndex] = {
        ...this.sequencerFunctionCollection[existingIndex],
        ...mergedFunction
      };
      return;
    }

    this.sequencerFunctionCollection = [...collection, mergedFunction];
  }

  private buildProcedureDescription(blockConfig: any): string {
    const why = (blockConfig?.why || '').trim();
    const what = (blockConfig?.what || '').trim();

    return [
      why ? `Why: ${why}` : '',
      what ? `What: ${what}` : ''
    ].filter(Boolean).join('\n');
  }

  private isProcedureNameDuplicate(name: string): boolean {
    const normalized = name.trim();
    if (!normalized) {
      return false;
    }
    const allBlocks = this.blocklyWorkSpace?.getAllBlocks(false) || [];
    const procedureDefs = allBlocks.filter((block: any) =>
      block?.type === 'procedures_defnoreturn' || block?.type === 'procedures_defreturn'
    );
    return procedureDefs.some((block: any) => {
      const existingName = (block.getFieldValue('NAME') || '').trim();
      return existingName === normalized;
    });
  }

  moveDynamicBlock(event: any, dynamicBlock: any) {
    //Converting the x,y pixel coordinates to workspace coordinates
    const pointX = event.dropPoint.x / this.blocklyWorkSpace.scale;
    const pointY = event.dropPoint.y / this.blocklyWorkSpace.scale;
    const metrics = this.blocklyWorkSpace.getMetricsManager().getAbsoluteMetrics(true);
    let workspaceX = pointX - metrics.left - (this.blocklyWorkSpace.scrollX / this.blocklyWorkSpace.scale);
    let workspaceY = pointY - metrics.top - (this.blocklyWorkSpace.scrollY / this.blocklyWorkSpace.scale);
    const allBlocks = this.blocklyWorkSpace.getAllBlocks();
    while (!this.isPositionEmpty(workspaceX, workspaceY, allBlocks)) {
      workspaceX += 10;
      workspaceY += 20;
    }
    dynamicBlock.moveBy(workspaceX, workspaceY);
  }

  isPositionEmpty(x: any, y: any, allBlocks: any[]) {
    for (let i = 0; i < allBlocks?.length; i++) {
      const block = allBlocks[i];
      const blockPosition = block.getRelativeToSurfaceXY();
      if (blockPosition.x === x && blockPosition.y === y) {
        return false; // not empty
      }
    }
    return true; // is empty
  }

  // Removing the Sequence block from the category in the toolbox when navigated from the Sequence builder to the library builder and vice versa.
  toggleBlocksByBuilderMode() {
    const targetCategory = this.categoryMenu.selectedCategory.id === Category.DEVICE ? CustomCategory.PREDEFINED_DEVICE : CustomCategory.PREDEFINED;
    const toolBox = JSON.parse(JSON.stringify(this.toolBox));
    const targetCategoriesToHide: any = [];
    const targetBlocksToHide: any[] = [];

    // Pushing the blocks to hide into the targetBlocksToHide array based on the builder mode
    if (this.builderMode === BuilderMode.SEQUENCE_BUILDER) {
      targetBlocksToHide.push(BlockType.SEQUENCER);
      if (this.categoryMenu.selectedCategory.id === Category.CLOUD) {
        targetBlocksToHide.push(BlockType.SEQUENCE_SYSTEM);
        if (!this.mqttEnabled) {
          targetCategoriesToHide.push('MQTT');
        }
      } else if (this.categoryMenu.selectedCategory.id === Category.SYSTEM) {
        this.hideDeprecatedBlocksFromToolbox(toolBox);
        targetBlocksToHide.push(BlockType.SEQUENCE);
        targetCategoriesToHide.push('MQTT');
      } else {
        targetCategoriesToHide.push('MQTT');
      }
    } else if (this.builderMode === BuilderMode.LIBRARY_BUILDER) {
      targetBlocksToHide.push(BlockType.SEQUENCE);
      targetBlocksToHide.push(BlockType.SEQUENCE_SYSTEM);
      targetBlocksToHide.push(BlockType.SEQUENCE_DEVICE);
      targetCategoriesToHide.push('MQTT');
      if (this.categoryMenu.selectedCategory.id === Category.SYSTEM) {
        this.hideDeprecatedBlocksFromToolbox(toolBox);
      }
      if (this.categoryMenu.selectedCategory.id === Category.DEVICE) {
        targetBlocksToHide.push(BlockType.MODEL_BLOCK);
        targetCategoriesToHide.push(CustomCategory.MODEL_POINTS);
      }
    }

    // Looping through the toolbox contents and removing the blocks based on the targetBlocksToHide array
    toolBox.contents = toolBox.contents
      .map((category: any) => {
        if (!category.contents || typeof category.contents !== 'object') return category;
        category.contents = category.contents.filter((block: any) => !targetBlocksToHide.includes(block.type));
        return category;
      })
      .filter((category: any) => !targetCategoriesToHide.includes(category.name));
    this.toolBox = toolBox;
  }

  hideDeprecatedBlocksFromToolbox(toolBox: any) {
    toolBox.contents.forEach((item: any) => {
      if (item.name === "Custom Primitives") {
        item.contents = item.contents.filter((block: any) =>
          !this.deprecatedBlocks.includes(block.type)
        );
      }
      if (item.name === "Custom Functions") {
        item.contents = item.contents.filter((block: any) =>
          !this.deprecatedBlocks.includes(block.type)
        );
      }
    });
  }

  toggleCategoriesByBuilderMode() {
    if (this.builderMode === BuilderMode.LIBRARY_BUILDER) {
      const toolBox = JSON.parse(JSON.stringify(this.toolBox));
      const categoriesToHide = ['Created by Me', 'Shared by Others'];
      categoriesToHide.forEach((categoryNameToHide: any) => {
        const targetCategoryIndex = toolBox.contents.findIndex((category: any) => category.name === categoryNameToHide);
        if (targetCategoryIndex >= 0) {
          targetCategoryIndex >= 0 ? toolBox.contents.splice(targetCategoryIndex, 1) : '';
        }
      })
      this.toolBox = toolBox;
    }
  }

  initCrossTabCopyPaste() {
    const options = {
      contextMenu: true,
      shortcut: true,
    };
    const isPlugInExist = Blockly.ContextMenuRegistry.registry.getItem('blockCopyToStorage')
    if (!isPlugInExist) {
      const copyPlugin = new CrossTabCopyPaste();
      copyPlugin.init(options);
    }
    this.overrideCopyPasteInContextMenu();
    this.registerSaveAsSequenceFunctionContextMenu();
    this.subscribeTokeyboardCopyPasteEvents();
  }

  /*
  * Method to subscribe to keyboard copy and paste shortcuts events (Ctrl+C and Ctrl+V).
  */
  subscribeTokeyboardCopyPasteEvents() {

    // Prevent duplicate subscriptions
    if (this._keyboardCopyPasteHandler) {
      return;
    }

    // Create and store the handler so it can be tracked or removed later
    this._keyboardCopyPasteHandler = (event: any) => {
      if (event.ctrlKey || event.metaKey) {
        const keyType = event.key.toLowerCase();
        switch (keyType) {
          case 'c':
            this.handleCopyPasteOnKeyboardEvent('copy');
            break;
          case 'v':
            this.isPasteEventTriggered = true; // Set the flag to true when paste event is triggered
            // Don't call your paste logic
            // Let Blockly handle this one
            break;
          default:
            break;
        }
      }
    };

    document.addEventListener('keydown', this._keyboardCopyPasteHandler);
  }


  /*
  * Method to handle copy and paste actions on keyboard events.
  * @param {string} eventType - The type of event to perform (copy or paste).
  */
  handleCopyPasteOnKeyboardEvent(eventType: any) {
    const blockCopyToStorageObj = Blockly.ContextMenuRegistry.registry.getItem('blockCopyToStorage');
    const blocklyStash = JSON.parse(localStorage.getItem('blocklyStash') || '{}');
    if (blocklyStash) {
      if (eventType === 'copy') {
        if (blockCopyToStorageObj) {
          const scope = { 'block': this.blocklyWorkSpace.getBlockById(blocklyStash.blockState.id) }; // setting the copied block object as scope
          blockCopyToStorageObj?.callback(scope); // Perform actual copy action by calling the copy function callback with the scope as argument.
        }
      }
    }
  }

  private mergeSequenceFunctionListWithExisting(functionList: any[] = [], category: string, existingCollection?: any[]): any[] {
    const existingFunctionMap = new Map(
      (existingCollection || this.sequencerFunctionCollection || [])
        .filter((item: any) => item?.functionId)
        .map((item: any) => [item.functionId, item])
    );

    return (functionList || []).map((functionObj: any) =>
      this.mergeSequenceFunctionWithExisting(functionObj, existingFunctionMap, category)
    );
  }

  private mergeSequenceFunctionWithExisting(functionObj: any, existingFunctionMap: Map<string, any>, category: string): any {
    const existingFunction = functionObj?.functionId ? existingFunctionMap.get(functionObj.functionId) : null;
    const mergedFunction = {
      ...(existingFunction || {}),
      ...(functionObj || {}),
      category
    };

    if (!this.hasSequenceFunctionText(mergedFunction?.xml) && this.hasSequenceFunctionText(existingFunction?.xml)) {
      mergedFunction.xml = existingFunction.xml;
    }
    if (!this.hasSequenceFunctionText(mergedFunction?.snippet) && this.hasSequenceFunctionText(existingFunction?.snippet)) {
      mergedFunction.snippet = existingFunction.snippet;
    }
    if (!this.hasSequenceFunctionText(mergedFunction?.why) && this.hasSequenceFunctionText(existingFunction?.why)) {
      mergedFunction.why = existingFunction.why;
    }
    if (!this.hasSequenceFunctionText(mergedFunction?.what) && this.hasSequenceFunctionText(existingFunction?.what)) {
      mergedFunction.what = existingFunction.what;
    }

    return this.normalizeSequenceFunctionForLibraryBuilder(mergedFunction);
  }

  private hasSequenceFunctionText(value: any): boolean {
    return typeof value === 'string' ? !!value.trim() : !!value;
  }

  private normalizeSequenceFunctionForLibraryBuilder(functionObj: any): any {
    const wrappedXml = this.wrapProcedureXmlForLibraryBuilder(
      functionObj?.xml,
      functionObj?.seqFunctionName,
      functionObj?.why,
      functionObj?.what
    );

    if (!wrappedXml || wrappedXml === functionObj?.xml) {
      return functionObj;
    }

    return {
      ...functionObj,
      xml: wrappedXml
    };
  }

  private wrapProcedureXmlForLibraryBuilder(xml: string, name: string, why: string, what: string): string {
    const trimmedXml = (xml || '').trim();
    if (!trimmedXml) {
      return trimmedXml;
    }

    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(
      trimmedXml.startsWith('<xml')
        ? trimmedXml
        : `<xml xmlns="https://developers.google.com/blockly/xml">${trimmedXml}</xml>`,
      'text/xml'
    );
    const sourceBlock = xmlDoc.querySelector('block');
    if (!sourceBlock) {
      return trimmedXml;
    }

    if (sourceBlock.getAttribute('type') === this.getSequencerFunctionBlockType()) {
      return trimmedXml;
    }

    if (!this.isProcedureDefinitionBlock({ type: sourceBlock.getAttribute('type') })) {
      return trimmedXml;
    }

    const sourceName = (name || sourceBlock.querySelector('field[name="NAME"]')?.textContent || '').trim();
    const sourceWhy = (why || '').trim();
    const sourceWhat = (what || '').trim();
    const stackDom = sourceBlock.querySelector('statement[name="STACK"] > block');
    const additionalProcedureBlocks = Array.from(xmlDoc.documentElement.children || [])
      .filter((child: Element) => child !== sourceBlock && this.isProcedureDefinitionBlock({ type: child.getAttribute('type') }));

    return this.buildSequencerXmlDocument(
      sourceName,
      sourceWhy,
      sourceWhat,
      stackDom as Element | null,
      additionalProcedureBlocks as Element[]
    );
  }

  /**
  * Method to override the default copy and paste actions in the context menu to support cross tab copy and paste functionality.
  */
  overrideCopyPasteInContextMenu() {
    const blockPasteFromStorageObj = Blockly.ContextMenuRegistry.registry.getItem('blockPasteFromStorage');
    const blockCopyToStorageObj = Blockly.ContextMenuRegistry.registry.getItem('blockCopyToStorage');
    if (blockCopyToStorageObj) {
      Blockly.ContextMenuRegistry.registry.unregister('blockCopyToStorage');
      const _this = this;
      const copyFunction = blockCopyToStorageObj.callback;
      Blockly.ContextMenuRegistry.registry.register({
        displayText: function () { return 'Copy'; },
        preconditionFn: function (scope) { return 'enabled'; },
        callback: function (scope) {
          copyFunction(scope);
          _this.addAdditionalParamsForCopiedBlockConfig();
        },
        scopeType: Blockly.ContextMenuRegistry.ScopeType.BLOCK,
        id: 'blockCopyToStorage',
        weight: 20
      });
    }

    if (blockPasteFromStorageObj) {
      Blockly.ContextMenuRegistry.registry.unregister('blockPasteFromStorage');
      const _this = this;
      const pasteFunction = blockPasteFromStorageObj.callback;

      Blockly.ContextMenuRegistry.registry.register({
        displayText: function () { return 'Paste'; },
        preconditionFn: function (scope) { return 'enabled'; },
        callback: function (scope) {
          const restrictPaste = false;
          if (_this.shouldRejectCopiedDeviceRunBlockPaste()) {
            _this.showInvalidDeviceRunBlockPasteToast();
            _this.isPasteEventTriggered = false;
            return;
          } else if (restrictPaste) {
            return; // Stop the paste action
          } else {
            pasteFunction(scope); // Perform actual paste action
            _this.isPasteEventTriggered = true;
          }
        },
        scopeType: Blockly.ContextMenuRegistry.ScopeType.WORKSPACE,
        id: 'blockPasteFromStorage',
        weight: 20
      });
    }
  }

  registerSaveAsSequenceFunctionContextMenu() {
    const id = 'saveAsSequenceFunctionFromProcedure';
    const existing = Blockly.ContextMenuRegistry.registry.getItem(id);
    if (existing) {
      Blockly.ContextMenuRegistry.registry.unregister(id);
    }

    Blockly.ContextMenuRegistry.registry.register({
      displayText: (scope: any) => {
        const block = scope?.block;
        return this.getProcedureLibraryActionLabel(block);
      },
      preconditionFn: (scope: any) => {
        const block = scope?.block;
        if (!block || this.isWorkspaceReadOnly) return 'hidden';
        return this.isSupportedSequenceFunctionSourceBlock(block) ? 'enabled' : 'hidden';
      },
      callback: (scope: any) => {
        const block = scope?.block;
        if (block) {
          this.openSaveProcedureAsSequenceFunctionDialog(block);
        }
      },
      scopeType: Blockly.ContextMenuRegistry.ScopeType.BLOCK,
      id,
      weight: 21
    });
  }

  private getProcedureLibraryActionLabel(procedureBlock: any): string {
    const procedureMetadata = this.getProcedureLibraryMetadata(procedureBlock);
    const linkedFunctionId = procedureMetadata.functionId;
    const sourceFunctionId = procedureMetadata.sourceFunctionId || linkedFunctionId;

    if (linkedFunctionId) {
      return this.isSequenceFunctionOwnedByLoggedInUser(linkedFunctionId)
        ? 'Update Sequence Library Function'
        : 'Create As New Sequence Library Function';
    }

    if (sourceFunctionId) {
      return this.isSequenceFunctionOwnedByLoggedInUser(sourceFunctionId)
        ? 'Update Sequence Library Function'
        : 'Create As New Sequence Library Function';
    }

    return 'Save to Sequence Library';
  }

  private getLoggedInUserId(): string {
    return String(this.locaStorageService?.getUserId?.() || '').trim();
  }

  isSequenceFunctionCreatedByLoggedInUser(sequenceFunction: any): boolean {
    if (!sequenceFunction) {
      return false;
    }

    const loggedInUserId = this.getLoggedInUserId();
    const createdByUserId = String(sequenceFunction?.createdBy?.userId ||
      sequenceFunction?.createdByUserId ||
      sequenceFunction?.userId ||
      '').trim();

    if (loggedInUserId && createdByUserId) {
      return loggedInUserId === createdByUserId;
    }

    if (sequenceFunction?.category) {
      return sequenceFunction.category === this.categories.CREATED_BY_ME;
    }

    return !loggedInUserId && !createdByUserId;
  }

  private getSequenceFunctionById(functionId: string): any {
    if (!functionId) {
      return null;
    }

    return this.sequencerFunctionCollection.find((functionObj: any) => functionObj.functionId === functionId) || null;
  }

  private isSequenceFunctionOwnedByLoggedInUser(functionId: string): boolean {
    return this.isSequenceFunctionCreatedByLoggedInUser(this.getSequenceFunctionById(functionId));
  }

  private isSupportedSequenceFunctionSourceBlock(block: any): boolean {
    if (!block) {
      return false;
    }

    if (this.isProcedureDefinitionBlock(block)) {
      return true;
    }

    if (this.builderMode !== BuilderMode.SEQUENCE_BUILDER) {
      return false;
    }

    const isCloudOrSystemCategory =
      this.categoryMenu.selectedCategory.id === Category.CLOUD ||
      this.categoryMenu.selectedCategory.id === Category.SYSTEM;

    if (!isCloudOrSystemCategory) {
      return false;
    }

    return block.type === BlockType.SEQUENCE || block.type === BlockType.SEQUENCE_SYSTEM;
  }

  clearWorkspace() {
    this.blocklyWorkSpace.clear();
    !this.isWorkspaceReadOnly ? this.sequencerBlock = null : '';
  }

  addAdditionalParamsForCopiedBlockConfig() {
    const blocklyStash = JSON.parse(localStorage.getItem('blocklyStash') || '{}');
    if (blocklyStash && blocklyStash.blockState) {
      blocklyStash['category'] = this.categoryMenu.selectedCategory.id;
      blocklyStash['builderMode'] = this.builderMode;
      localStorage.setItem('blocklyStash', JSON.stringify(blocklyStash));
    }
  }

  private getCopiedBlockConfig(): any {
    try {
      return JSON.parse(localStorage.getItem('blocklyStash') || '{}');
    } catch {
      return {};
    }
  }

  private getCopiedRootBlockType(): string {
    return this.getCopiedBlockConfig()?.blockState?.type || '';
  }

  private isDeviceRunBlockType(blockType: string): boolean {
    return blockType === DeviceRunBlockType.RUN_BLOCK_STARTUP || blockType === DeviceRunBlockType.RUN_BLOCK_CONTINUOUS;
  }

  private shouldRejectCopiedDeviceRunBlockPaste(): boolean {
    const copiedRootBlockType = this.getCopiedRootBlockType();
    if (!this.isDeviceRunBlockType(copiedRootBlockType)) {
      return false;
    }

    return this.builderMode !== BuilderMode.SEQUENCE_BUILDER || this.categoryMenu.selectedCategory.id !== Category.DEVICE;
  }

  private showInvalidDeviceRunBlockPasteToast(): void {
    this.showToast('error', 'Run startup and run continuous blocks can only be pasted in a Device Sequence workspace.');
  }


  subscribeToBlocklyEvents() {
    this.blocklyWorkSpace.addChangeListener((event: any) => {
      // Handling the blockly events only when the paste event is triggered
      if (this.isPasteEventTriggered && event.type === Blockly.Events.BLOCK_CREATE) {
        this.handlePasteEvent(event);
      }
      // Handling the blockly events if the builder mode is sequence builder
      if (this.builderMode === BuilderMode.SEQUENCE_BUILDER) {
        // skippping the sequence blocks event handles when the selected category is device
        if (this.categoryMenu.selectedCategory.id !== Category.DEVICE) {
          this.handleSequenceBlockEvents(event);
          if (this.categoryMenu.selectedCategory.id === Category.CLOUD && event['blockId']) {
            this.updateSubscribeBlockFields();
          }
        } else {
          this.handleDeviceRunBlockEvents(event);
          this.handleDeviceTypeRestrictedBlockEvents(event);
          this.handleBacnetBlockEvents(event);
          if (event && event['blockId']) {
            this.handleModelBlockEvents(event)
            this.handleSetterBlockEvents(event);
          }
        }
        
      } else {
        // Handling the blockly events if the builder mode is library builder
        this.handleFunctionBlockEvents(event);
      }
      this.handleHaystackQueryBuilderBlockEvents(event);
      this.handleQueryBlockConnections(event);
      this.validateOnBlockEvents(event);
      this.validateBlocklyLogic();
    });
  }

  /**
   * Method to handle the paste event and track pasted block IDs.
   * @param event {any} - The Blockly event object.
   */
  handlePasteEvent(event: any) {
    const blockIdsInPasteEvent: string[] = event?.ids || (event?.blockId ? [event.blockId] : [])

    // If paste event contains block ids, add them to the set and start/reset the cleanup timer
    // (using the set to avoid duplicate ids, as paste event will result in multiple events for each block (create, move, etc.))
    if (blockIdsInPasteEvent.length) {
      blockIdsInPasteEvent.forEach(id => this.pastedBlockIds.add(id));

      clearTimeout(this.pasteDelayTimer);
      // Wait for the complete paste operation to finish before validating and disposing invalid blocks
      this.pasteDelayTimer = setTimeout(() => {
        this.processPastedBlocks();
      }, 50);
    }

  }

  /**
   * Method to process the pasted blocks after the paste operation is complete.
   */
  processPastedBlocks() {
    const ids = Array.from(this.pastedBlockIds); // Iterate the set by converting it to array
    this.pastedBlockIds.clear(); // Clear the set for future paste events

    if (!ids.length) {
      this.isPasteEventTriggered = false;
      return;
    }

    const blocks = ids
      .map(id => this.blocklyWorkSpace.getBlockById(id)) // fetching the actual block objects from the ids
      .filter(Boolean); // Filter out any null/undefined blocks

    if (this.shouldRejectCopiedDeviceRunBlockPaste()) {
      const topBlocks = blocks.filter(b => !b.getParent());
      Blockly.Events.disable();
      try {
        topBlocks.forEach((block: any) => block.dispose(false));
      } finally {
        Blockly.Events.enable();
        this.blocklyWorkSpace.render();
        this.isPasteEventTriggered = false;
      }
      this.showInvalidDeviceRunBlockPasteToast();
      return;
    }

    // A pasted procedure keeps its library link only when no sibling procedure in the
    // workspace already points at the same functionId.
    this.removeDuplicateProcedureFunctionIds(blocks);

    const topBlocks = blocks.filter(b => !b.getParent());

    Blockly.Events.disable(); // Disable events to prevent firing of events during dispose/unplug
    try {
      topBlocks.forEach(block => this.disposeInvalidBlockTree(block));
    } finally {
      Blockly.Events.enable(); // Re-enable events after dispose/unplug operations
      this.blocklyWorkSpace.render();
      this.isPasteEventTriggered = false;
      this.applyDeviceTypeRulesAfterPaste();
    }
  }

  private removeDuplicateProcedureFunctionIds(blocks: any[]): void {
    if (!this.blocklyWorkSpace || !blocks?.length) {
      return;
    }

    blocks.forEach((block: any) => {
      if (!this.isProcedureDefinitionBlock(block)) {
        return;
      }

      const procedureMetadata = this.getProcedureLibraryMetadata(block);
      if (!procedureMetadata.functionId) {
        return;
      }

      // Ignore the newly pasted block itself and look for an existing procedure already
      // mapped to the same library function.
      const hasMatchingProcedureInWorkspace = this.blocklyWorkSpace.getAllBlocks(false).some((workspaceBlock: any) => {
        if (!workspaceBlock || workspaceBlock.id === block.id || !this.isProcedureDefinitionBlock(workspaceBlock)) {
          return false;
        }

        const workspaceMetadata = this.getProcedureLibraryMetadata(workspaceBlock);
        return workspaceMetadata.functionId === procedureMetadata.functionId;
      });

      if (hasMatchingProcedureInWorkspace) {
        this.setProcedureLibraryMetadata(block, {
          why: procedureMetadata.why,
          what: procedureMetadata.what,
          functionId: ''
        });
      }
    });
  }

  private isProcedureDefinitionBlock(block: any): boolean {
    return this.blocklyWorkspaceBuilderService.isProcedureDefinitionBlock(block);
  }

  /**
   * Ensure device-type dependent options and validations are applied after a paste operation.
   * This fixes cases where pasted blocks don't trigger DEVICE_TYPE change events.
   */
  applyDeviceTypeRulesAfterPaste() {
    if (this.builderMode !== BuilderMode.SEQUENCE_BUILDER || this.categoryMenu.selectedCategory.id !== Category.DEVICE) return;
    const deviceType = this.getRunStartupDeviceType() || 'CONNECT_MODULE';
    this.updateDeviceTypeOptionsForDeviceBlocks(deviceType);
    this.validateBacnetBlocksOnWorkspace();
  }

  /**
   * Method to dispose the invalid blocks and its children from the block tree.
   * @param block {any} - The Blockly block object.
   */
  disposeInvalidBlockTree(block: any) {
    if (!block) return;

    const isValid = this.isBlockValidInCurrentWorkspace(block); // check if the block is supported in the current category and builder mode.
    const children = block.getChildren(true);

    if (!isValid) {
      children.forEach((child: any) => child.unplug(false));
      block.dispose(false);

      // validate unplugged/detached children (still in workspace)
      children.forEach((child: any) => this.disposeInvalidBlockTree(child));
      return;
    }

    children.forEach((child: any) => this.disposeInvalidBlockTree(child));
  }

  disposeDeprecatedBlocks() {
    const allBlocks = this.blocklyWorkSpace.getAllBlocks().filter((block: any) => this.deprecatedBlocks.includes(block.type));

    if (allBlocks && allBlocks.length > 0) {
      allBlocks.forEach((block: any) => {
        const children = block.getChildren(true);
        if (children && children.length > 0) {
          children.forEach((child: any) => {
            child.unplug(); // Disconnect the child from the invalid block
          });
        }
        block.dispose();
      });
    }
  }

  /* Method to check if the block is valid in the current category and builder mode. 
  * @param {block} - The Blockly block object.
  */
  isBlockValidInCurrentWorkspace(block: any) {
    const toolbox = JSON.parse(JSON.stringify(this.toolBox));
    // if the block is not a custom (sequencer function) block - check if the block type exists in the toolbox
    const isTypeInToolbox = (type: any) =>
      toolbox.contents.some((toolboxItem: any) =>
        toolboxItem.kind === toolBoxContentKind.CATEGORY && toolboxItem.contents && toolboxItem.contents.length &&
        toolboxItem.contents.some((contentItem: any) => contentItem.kind === toolBoxContentKind.BLOCK && contentItem.type === type)
      );
    const hasProcedureCategory = toolbox.contents.some((toolboxItem: any) =>
      toolboxItem.kind === toolBoxContentKind.CATEGORY && toolboxItem.custom === 'PROCEDURE'
    );

    // if the block is a custom (sequencer function) block - check if the block type exists in the sequencer functions collection array.
    const isTypeInSeqFunctionsCollection = (type: any) => this.sequencerFunctionCollection.some((blockObj: any) => blockObj.type === type);

    const blockType = block.type;
    let isBlockValid;

    if (blockType.startsWith(BlockType.CUSTOM_BLOCK)) {
      // Skipping the function blocks from the disposal check in Library builder (as we don't have function blocks (miniature blocks) in library builder).
      isBlockValid = this.builderMode === BuilderMode.SEQUENCE_BUILDER ? isTypeInSeqFunctionsCollection(blockType) : false;
    } else if (blockType.startsWith(BlockType.VARIABLES)) {
      // if the block type is variable, check if the variable exists.
      const allVariables = this.blocklyWorkSpace.getAllVariableNames(); // Get all the variable names that are created dynamically in toolbox
      const variableFieldOfBlock = block.getField(BlockFieldName.VARIABLE);
      const currentVariableNameOfblock = variableFieldOfBlock.variable.name; // Get the selected variable name of the block
      if (allVariables && allVariables.length) {
        isBlockValid = allVariables.includes(currentVariableNameOfblock); // check if the selected variable name is matching with the existing variable names
      } else {
        isBlockValid = false;
      }
    } else if (blockType.startsWith(BlockType.MATH_CHANGE)) { // variable change by block is not part of the toolbox, so we will not dispose them during paste, as they can be connected to the valid variable getter blocks and become valid blocks in that case.
      isBlockValid = true;
    } else if (hasProcedureCategory && blockType.startsWith('procedures_')) {
      // Procedures are provided via a custom toolbox category and won't appear in contents.
      isBlockValid = true;
    } else {
      // Check if the block type exists in the toolbox
      isBlockValid = isTypeInToolbox(blockType);
    }
    return isBlockValid;
  }

  getBlockIdentifiers(block: any) {
    if (block.type.startsWith(BlockType.CUSTOM_BLOCK)) {
      return block.getFieldValue(BlockFieldName.SEQUENCE_FUNCTION_NAME);
    } else if (block.type === BlockType.SEQUENCE) {
      return BlockIdentifier.SEQUENCE;
    } else if (block.type === BlockType.MQTT_SUBSCRIBE) {
      return BlockIdentifier.MQTT_SUBSCRIBE;
    } else {
      return block.type;
    }
  }

  validateBlocklyLogic() {
    if (this.categoryMenu.selectedCategory.id !== Category.DEVICE) {
      const jsCode = javascriptGenerator.workspaceToCode(this.blocklyWorkSpace);
      this.code = this.formatCodeForFunctionBlock(jsCode);
      if (this.categoryMenu.selectedCategory.id == Category.CLOUD) {
        this.code = `var timeFormatEnum = Java.type('io.seventyfivef.seq.enumeration.TimeFormat');\nvar dateFormatEnum = Java.type('io.seventyfivef.seq.enumeration.DateFormat');\nvar dateTimeFormatEnum = Java.type('io.seventyfivef.seq.enumeration.DateTimeFormat');\n` + this.code;
      }
    } else {
      let pyCode = pythonGenerator.workspaceToCode(this.blocklyWorkSpace);
      pyCode = this.pythonToMicropython(pyCode);
      const preambleCode = `######## Preamble Section ########\nimport connmod\nimport uniInputMapping\n`;
      const superloopCode = '######## Superloop Section ########\n' +
        'connmod.EnterSequence()\n' +
        runStartupPythonFun + '()\n' +
        'connmod.ExitSequence()\n' +
        'while True:\n' +
        '  connmod.DelayMs(' + sequenceRunRateMs + ')\n' +
        '  connmod.EnterSequence()\n' +
        '  ' + runContinuousPythonFun + '()\n' +
        '  connmod.ExitSequence()';
      const formattedPyCode = this.formatCodeForFunctionBlock(pyCode);
      const formatmodelPointInitCode = this.formatmodelPointInitCode();
      this.code = this.builderMode === BuilderMode.SEQUENCE_BUILDER ? `${preambleCode}\n${formattedPyCode}\n${superloopCode}` : `${formattedPyCode}`;
    }

    let currentXml = this.parseXMLForSequence();
    currentXml === XMLEnum.DEFAULT_XML ? currentXml = '' : '';
    let savedWorkspaceXml = this.workspaceXML;
    savedWorkspaceXml === XMLEnum.DEFAULT_XML ? savedWorkspaceXml = '' : '';
    this.noChangesInWorkspace = savedWorkspaceXml === currentXml;
  }

  formatCodeForFunctionBlock(jsCode: any) {
    let code = jsCode;
    const allBlocks = this.blocklyWorkSpace.getAllBlocks(true);
    const functionBlocksInWorkspace = allBlocks.filter((blockObj: any) => blockObj.type.includes('fn_'));

    if (functionBlocksInWorkspace.length > 0) {
      functionBlocksInWorkspace.forEach((block: any) => {
        const functionBlockCode = block.getFieldValue('snippet');
        code = `${functionBlockCode}\n${code}`;
      });
    }
    return code;
  }

  /** Method to format the code for appending the initializations for model points that are used on the workspace */
  formatmodelPointInitCode() {
    const modelPointBlocks = this.blocklyWorkSpace.getAllBlocks(true).filter((blockObj: any) => blockObj.type.includes('model_point'));
    const pointSetterBlocks = this.blocklyWorkSpace.getAllBlocks(true).filter((blockObj: any) => blockObj.type.includes(BlockType.POINT_SETTER));
    let modelPointInitCode = '';
    const pointsToinitialize: any = [];

    const initializePoint = (modelPointName: string) => {
      if (!pointsToinitialize.includes(modelPointName)) {
        const port = modelPointName.slice(modelPointName.lastIndexOf('_') + 1);
        modelPointInitCode += `\n${modelPointName} = ['None', ${port}']\n`;
        pointsToinitialize.push(modelPointName);
      }
    }

    // Method to format the code for initializing the model points from the model point blocks
    if (modelPointBlocks.length > 0) {
      modelPointBlocks.forEach((block: any) => {
        const modelPointName = block.getFieldValue('pointName');
        initializePoint(modelPointName);
      });
    }

    // Method to format the code for initializing the model points from the point setter blocks
    if (pointSetterBlocks.length > 0) {
      pointSetterBlocks.forEach((block: any) => {
        const selectedModalId = block.getFieldValue(BlockFieldName.SELECTED_POINT_NAME);
        const selectedModelPointName = block.getField(BlockFieldName.SELECTED_POINT_NAME).selectedOption[0];
        if (selectedModalId !== 'DEFAULT_MODAL') {
          initializePoint(selectedModelPointName);
        }
      });
    }

    return modelPointInitCode;
  }

  /** Method to format the category names to append the blocks count to the category names */
  formatCategoryNames() {
    const toolboxBlocks = this.blocklyWorkSpace?.getToolbox().getToolboxItems();
    toolboxBlocks.forEach((blockObj: any) => {
      if (blockObj.toolboxItemDef_?.kind == 'category') {
        const target = blockObj['rowDiv_'].querySelector('.blocklyTreeLabel');
        if (target) {
          let catergoryName = blockObj.getName();
          let count = (catergoryName != 'Variables' && catergoryName != 'Functions') ? `(${blockObj.flyoutItems_.length})` : '';
          target.textContent = `${catergoryName} ${count}`;
        }
      }
    });
  }

  /** Method to add a placeholder in the searchbox in toolbox */
  initializeToolboxSearch() {
    const toolboxBlocks = this.blocklyWorkSpace?.getToolbox().getToolboxItems();
    const searchObj = toolboxBlocks[0]['rowDiv_'].querySelector('input');
    searchObj.placeholder = 'Search for Blocks/Sequence';
  }

  /** Method to change the placeholder message on the page */
  togglePlaceholderMessage() {
    const allBlocks = this.blocklyWorkSpace?.getAllBlocks();
    if (this.selectedSiteId) {
      this.placeholderMessage = allBlocks.length > 0 ? '' : (this.categoryMenu.selectedCategory.id !== Category.CLOUD ?
        `This site does not have any ${this.categoryMenu.selectedCategory.label} sequences applied` : 'This site does not have any sequences applied');
    } else {
      this.placeholderMessage = 'Select Site';
    }
  }

  /** Method to sort the breadcrumbs based on the relative coordinates of the sequence blocks*/
  sortBreadCrumbs() {
    this.breadcrumbs = [];
    this.sequenceTabs = [];
    const allBlocks = this.blocklyWorkSpace.getAllBlocks(true);
    const sequenceBlocks = allBlocks.filter((blockObj: any) => this.sequenceBlockType.includes(blockObj.type));
    if (sequenceBlocks.length > 0) {
      // Sorting sequence by x value of it's relative coordinates
      const sortedSequences = sequenceBlocks.sort((obj1: any, obj2: any) => obj1.relativeCoords.x - obj2.relativeCoords.x);
      sortedSequences.forEach((seqObj: any) => {
        const seqName = seqObj.getFieldValue('markername');
        const seqId = seqObj.getFieldValue('sequenceId');
        const breadcrumbObj: any = { 'seqName': seqName, 'seqId': seqId };
        this.breadcrumbs.push(breadcrumbObj);
        seqObj.getFieldValue('RUN_STATUS') === SequenceStatus.ENABLE_WITH_LOGS ||
          seqObj.getFieldValue('RUN_STATUS') === SequenceStatus.DISABLE_WITH_LOGS ? this.toggleSequenceTab(seqObj, 'create') : '';
      });
    }
  }

  validateOnBlockEvents(event: any) {
    if (event && event.blockId && !this.isFunctionBlockClicked) {
      const restrictedEvents = ['click', 'drag', 'move', 'selected', 'viewport_change', 'toolbox_item_select', 'viewport_change', 'trashcan_open', 'finished_loading'];
      const allBlocks = this.blocklyWorkSpace.getAllBlocks();
      const targetBlock = event.blockId ? this.blocklyWorkSpace.getBlockById(event.blockId) : null;
      this.togglePlaceholderMessage();
      if (allBlocks.length > 0) {
        // Validating the blocks with input fields when change event is triggered for input field.
        if (event.type == "block_field_intermediate_change" || event.type == "change") {
          if (this.sequenceBlockType.includes(targetBlock.type)) {
            this.validateSequenceBlock(targetBlock);
          } else if (targetBlock.type === BlockType.SEQUENCER) {
            this.validateSequencerBlock(targetBlock);
          } else {
            // Validating the block with input fields and associated Sequence block. 
            const rootBlock = targetBlock.getRootBlock();
            if (this.sequenceBlockType.includes(rootBlock.type)) {
              this.validateSequenceBlock(rootBlock);
            } else if (targetBlock.type === BlockType.SEQUENCER) {
              this.validateSequencerBlock(targetBlock);
            }
            this.validateInputField(targetBlock);
          }
        }
        if (!this.isLoadingAllSequences && (event['newCoordinate'] && event['oldCoordinate']) || event['newParentId']) {
          // Validating the input fields of the block when the block's coordinates are changed or when block is connected to another block.
          this.validateInputField(targetBlock);
        }

        // Validating the alert hystersis block only for the events related to it.
        const alertBlockType = 'alertHystersis';
        const isChangeOrMoveEvent = ['block_field_intermediate_change', 'change', 'move'].includes(event.type);
        const alertLimitInputNames = ['ALERT_TRIGGER_UPPER_LIMIT', 'ALERT_FIX_UPPER_LIMIT', 'ALERT_TRIGGER_LOWER_LIMIT', 'ALERT_FIX_LOWER_LIMIT'];
        const isAlertHystersisBlock = targetBlock?.type === alertBlockType;

        // Limit value block changed: it is plugged into one of the limit inputs of an alert block.
        const targetBlockInputName = targetBlock?.outputConnection?.targetConnection?.getParentInput()?.name;
        const isInsideAlertHystersisBlock = targetBlock?.getParent?.()?.type === alertBlockType && alertLimitInputNames.includes(targetBlockInputName);

        // if Limit value block removed/added: the move event has the parent block and the input name it was removed from/added to.
        const oldParentBlock = event.oldParentId ? this.blocklyWorkSpace.getBlockById(event.oldParentId) : null;
        const newParentBlock = event.newParentId ? this.blocklyWorkSpace.getBlockById(event.newParentId) : null;
        const isRemovedFromAlertLimitInput = oldParentBlock?.type === alertBlockType && alertLimitInputNames.includes(event.oldInputName);
        const isAddedToAlertLimitInput = newParentBlock?.type === alertBlockType && alertLimitInputNames.includes(event.newInputName);
        const isConnectedToAlertHystersisBlock = isRemovedFromAlertLimitInput || isAddedToAlertLimitInput;

        if (isChangeOrMoveEvent && (isAlertHystersisBlock || isInsideAlertHystersisBlock || isConnectedToAlertHystersisBlock)) {
          this.validateAlertHysteresisBlock(event, targetBlock);
        }
      }

    }
  }

  /**
   * Validates the alertHystersis blocks on block events.

   * @param event - The Blockly event.
   * @param targetBlock - The block the event is triggered for.
   */
  validateAlertHysteresisBlock(event: any, targetBlock: any) {
    const isChangeEvent = event.type === 'change';
    const isAlertHystersisBlock = targetBlock !== null && targetBlock !== undefined && targetBlock.type === 'alertHystersis';
    const limitToggleFields = ['SHOW_UPPER_LIMIT', 'SHOW_LOWER_LIMIT'];
    const isLimitToggleChange = limitToggleFields.includes(event.name);

    // validating the inputs again to validate the updated field again when the enable limit toggles are changed.
    if (isChangeEvent && isAlertHystersisBlock && isLimitToggleChange) {
      setTimeout(() => {
        const blockInWorkspace = this.blocklyWorkSpace.getBlockById(targetBlock.id);
        if (blockInWorkspace !== null) {
          this.validateInputField(targetBlock);
        }
      }, 0);
    }

    if (this.errorBlocks.length > 0) {
      const blocksToCheck: any[] = [];
      blocksToCheck.push(targetBlock);
      if (event.oldParentId) {
        const oldParentBlock = this.blocklyWorkSpace.getBlockById(event.oldParentId);
        blocksToCheck.push(oldParentBlock);
      }
      if (event.newParentId) {
        const newParentBlock = this.blocklyWorkSpace.getBlockById(event.newParentId);
        blocksToCheck.push(newParentBlock);
      }

      const alertBlocksToValidate = new Set<any>();
      blocksToCheck.forEach((blockToCheck: any) => {
        let currentBlock = blockToCheck;
        while (currentBlock !== null && currentBlock !== undefined) {
          const isAlertBlock = currentBlock.type === 'alertHystersis';
          const isAlertBlockInError = this.errorBlocks.includes(currentBlock.id);
          const isTargetBlock = targetBlock !== null && targetBlock !== undefined && currentBlock.id === targetBlock.id;

          if (isAlertBlock && isAlertBlockInError && isTargetBlock === false) {
            alertBlocksToValidate.add(currentBlock);
          }
          currentBlock = currentBlock.getParent();
        }
      });

      // Validating those alert blocks again, so the error goes away if it is corrected.
      alertBlocksToValidate.forEach((alertBlock: any) => {
        this.validateInputField(alertBlock);
      });
    }
  }

  /** Method to fetch all sites from API and populates to sites dropdown menu */
  async getAllSites() {
    this.isLoading = true;
    this.isSitesLoading = true;
    let portal = this.locaStorageService.getPortal() || '';

    this.subscriptions = this.siteService.getSitesForSupportPortal()
      .subscribe({
        next: (sites: any[]) => {
          this.isLoading = false;
          this.isSitesLoading = false;
          this.sites = sites.map((site: any) => {
            const location = site.locationDetails;
            return {
              ...site,
              id: 'r:' + site.siteId,
              dis: site.siteName,
              createdDateTime: site.createdAt,
              address: `${location?.geoAddr ?? ''}, ${location?.geoCity ?? ''}, ${location?.geoState ?? ''}, ${location?.geoCountry ?? ''} - ${location?.geoPostalCode ?? ''}`
            };
          }).reverse();
          if (portal == HostRoute.FACILISIGHT) {
            this.sites.map((site: any) => {
              site.isOnlyBillingAdmin = site.role === 'billingAdmin' && site.isPrimary === 0 && site.isBillingAdmin === 1;
            });
          }
          this.checkAndGetSelectedSiteFromFacApp();
        },
        error: (err) => {
          this.isLoading = false;
          this.isSitesLoading = false;
          this.sites = [];
          this.showToast('error', `${err.message}`);
        }
      });
  }

  onSiteSelectionDropdownChange(selected: Record<string, any> | Record<string, any>[] | null): void {
    const item = Array.isArray(selected) ? selected[0] : selected;
    if (!item) {
      return;
    }

    this.getSelectedSite([item]);
  }

  get hostApp() {
    return sessionStorage.getItem('portal');
  }

  getLanguages() {
    this.languages = [
      { "name": "JavaScript", "id": "javascript" }
    ];
    this.getSelectedLanguage();
  }

  /** Method to get the selected options from the languages dropdown menu in the code snippet section */
  getSelectedLanguage() {
    this.selectedLanguageId = this.languages[0].id;
  }

  /** Method to get the selected site from the session storage and to set the selected option for sites dropdown menu in facilisight */
  checkAndGetSelectedSiteFromFacApp() {
    let portal = this.locaStorageService.getPortal();
    const userSelectedSiteInternal = sessionStorage.getItem('selectedSiteId') || '';
    if (portal == HostRoute.FACILISIGHT || userSelectedSiteInternal?.length) {
      let selectedSiteId = userSelectedSiteInternal?.length ? userSelectedSiteInternal : sessionStorage.getItem("siteNameFromFacPortal");
      selectedSiteId = selectedSiteId ? this.stripHaystackTypeMapping(selectedSiteId) : '';
      if (selectedSiteId) {
        const selectedSiteArray = this.sites.filter(siteObj => this.stripHaystackTypeMapping(siteObj.id) == selectedSiteId);
        this.getSelectedSite(selectedSiteArray);
      }
    }
  }

  /** Method to strip the haystack type mapping from the response */
  stripHaystackTypeMapping(response: any) {
    return (response) ? JSON.parse(JSON.stringify(response).replace(/"r:|"c:|"n:|"t:|"b:|"m:|"z:|"s:|"d:/g, '"')) : '';
  }

  /** Method to show or hide toolbox in blockly workspace on button click in UI */
  showHideToolBox(value: boolean) {
    this.showToolBox = value;
    !value ? this.blocklyWorkSpace?.getFlyout()?.setVisible(value) : '';
    this.blocklyWorkSpace?.getToolbox()?.setVisible(value);
  }

  /** Method to show or hide generated code block in bottom section on button click in UI */
  showHideCodeSnippetBlock() {
    this.isCodeBlockVisible = !this.isCodeBlockVisible;
    if (this.isCodeBlockVisible && !this.codeSnippetHeight) {
      this.codeSnippetHeight = 195;
    }
    this.codeBlockTooltipText = this.isCodeBlockVisible ? "Collapse Code Snippet" : "Expand Code Snippet";
    if (this.isCodeBlockVisible) {
      this.updateCodeSnippetMaxHeight();
      this.codeSnippetHeight = Math.min(this.codeSnippetHeight, this.codeSnippetMaxHeight);
      this.attachCodeSnippetWindowListeners();
    } else {
      this.codeSnippetHeight = 195;
      this.detachCodeSnippetWindowListeners();
    }
  }

  startCodeSnippetResize(event: MouseEvent) {
    if (!this.isCodeBlockVisible) return;
    event.preventDefault();
    this.updateCodeSnippetMaxHeight();
    this.isResizingCodeSnippet = true;
    this.codeSnippetResizeStartY = event.clientY;
    this.codeSnippetResizeStartHeight = this.codeSnippetHeight || 195;
  }

  private onWindowMouseMove(event: MouseEvent) {
    if (!this.isResizingCodeSnippet) return;
    const delta = this.codeSnippetResizeStartY - event.clientY;
    const maxHeight = this.codeSnippetMaxHeight || this.getCodeSnippetMaxHeight();
    const minHeight = 120;
    const nextHeight = this.codeSnippetResizeStartHeight + delta;
    this.codeSnippetHeight = Math.max(minHeight, Math.min(maxHeight, nextHeight));
  }

  private onWindowMouseUp() {
    this.isResizingCodeSnippet = false;
  }

  private isCodeSnippetWindowListenersAttached = false;
  private readonly boundCodeSnippetMouseMove = (event: MouseEvent) => this.onWindowMouseMove(event);
  private readonly boundCodeSnippetMouseUp = () => this.onWindowMouseUp();

  private attachCodeSnippetWindowListeners() {
    if (this.isCodeSnippetWindowListenersAttached) return;
    window.addEventListener('mousemove', this.boundCodeSnippetMouseMove);
    window.addEventListener('mouseup', this.boundCodeSnippetMouseUp);
    this.isCodeSnippetWindowListenersAttached = true;
  }

  private detachCodeSnippetWindowListeners() {
    if (!this.isCodeSnippetWindowListenersAttached) return;
    window.removeEventListener('mousemove', this.boundCodeSnippetMouseMove);
    window.removeEventListener('mouseup', this.boundCodeSnippetMouseUp);
    this.isCodeSnippetWindowListenersAttached = false;
    this.isResizingCodeSnippet = false;
  }

  private updateCodeSnippetMaxHeight() {
    this.codeSnippetMaxHeight = this.getCodeSnippetMaxHeight();
  }

  private getCodeSnippetMaxHeight() {
    const viewportHeight = window.visualViewport?.height || window.innerHeight || document.documentElement?.clientHeight || 0;
    return Math.round(viewportHeight * 0.9);
  }

  /** Method to perform operations after a site is selected from sites dropdown menu 
  * @param {any} site - Selected site data from sites dropdown menu.
  */
  async getSelectedSite(site: any) {
    if (site && site?.length > 0 && this.selectedSiteId != site?.[0]?.id.replace('r:', '')) {
      window.parent.postMessage(JSON.stringify(site), '*');
      this.isSequenceTabSelected = false;
      this.activeTabIndex = 0;
      // Disable Category-level tab clicks while site selection is in progress to prevent tab switching until the timezone-fetching API (based on the selected site's region) completes.
      this.isSiteSelectionInProgress = true; 
      this.selectedSite = site[0];
      this.siteId = this.selectedSite.id;
      this.selectedSiteId = this.selectedSite.id.replace('r:', '');

      const loggedInUserName = `${this.commonService.userDetails?.firstName ? this.commonService.userDetails?.firstName : ''} ${this.commonService.userDetails?.lastName ? this.commonService.userDetails?.lastName : ''}`;
      this.userInfo = { siteName: this.selectedSite?.dis, userName: loggedInUserName };

      if (!this.selectedSite?.region?.regionCode && environment.multiregion) {
        try {
          const sitesregionMap: any = await lastValueFrom(this.siteSequencerService.getSiteRegion(this.selectedSiteId));
          this.configService.setSelectedRegion(sitesregionMap.regionMap.find((site: any) => {
            return site.siteId === site?.id
          })?.regionId || '1');

        } catch (error) {
          console.error('Error fetching site region:', error);
        }

      } else {
        this.configService.setSelectedRegion(this.selectedSite?.region?.regionId || '1');
      }
      // The site list API (caretaker's /user/{userId}/sites) response does not include the timezone information, 
      // so we need to fetch the timezone separately for the selected site in both the portals.
      await this.fetchTimeZone(this.selectedSiteId);
      this.isSiteSelectionInProgress = false;

      this.siteId = this.selectedSite.id;
      this.selectedSiteId = this.selectedSite.id.replace('r:', '');
      this.featureAccessible = true;
      this.siteDelayTimer = 0; // Resetting the site delay timer to 0 when a new site is selected.
      const singaporeCountryNames = new Set(['singapore', 'vietnam', 'malaysia', 'thailand', 'philippines']);
      const isSingaporeSites = this.sites.some(
        building => this.stripHaystackTypeMapping(building.id) == this.selectedSiteId
          && singaporeCountryNames.has((building.geoCountry || building?.locationDetails?.geoCountry || "").toLowerCase().replace(/\s+/g, ''))
      );
      if (isSingaporeSites) {
        this.siteDelayTimer = this.delayTimer;
      }


      this.resetCategoryTabs();
      // clearing the blocklyworkspace when switching from one site to another.
      this.blocklyWorkSpace ? this.toggleWorkspace('delete') : '';
      const selectedCategoryTabConfig = { 'index': this.categoryMenu.activeTabIndex, tab: { 'textLabel': this.categoryMenu.selectedCategory.label } };
      this.toggleCategoryLevelTab(selectedCategoryTabConfig, true);
      const subscriptionData = {
        siteId: this.stripHaystackTypeMapping(this.selectedSite?.id),
        tierId: this.selectedSite?.tierId,
        isBillingAdmin: this.selectedSite?.isBillingAdmin,
        isPrimary: this.selectedSite?.isPrimary,
        addOns: this.selectedSite?.addOns
      }
      this.showSubscriptionReminder(subscriptionData);
    } else if (site.length == 0 && !this.selectedSiteId) {

      this.isLoadingAllSequences = false;
      this.selectedSite = null;
      this.showSequenceActionButtons = false;

    }
  }

  // shows subscription reminder, if the subscription billing is within 15days
  showSubscriptionReminder(subscriptionData: any) {
    const isFacPortal = this.locaStorageService.getPortal()?.toUpperCase() === HostRoute.FACILISIGHT;
    if (isFacPortal) {
      // Set subscription data to service
      this.subscriptionManagementService.resetSubscriptionData();
      this.subscriptionManagementService.setSubscriptionData(subscriptionData).then(() => {
        this.subscriptionManagementService.showSubscriptionReminder(subscriptionData?.siteId);
      }).catch((error) => {
        this.subscriptionManagementService.showSubscriptionReminder(subscriptionData?.siteId);
      });
    }
  }

  async fetchTimeZone(siteId: string) {
    try {
      if (!siteId?.includes('@')) siteId = '@' + siteId;
      const res: any = await this.siteService.getSiteById(siteId).toPromise();
      const timezone = res.rows?.[0]?.tz;
      if (timezone) {
        this.selectedSite.tz = timezone;
      } else {
        this.showToast('error', 'Timezone not found for the selected site.');
      }
    } catch (err: any) {
      this.showToast('error', `Failed to fetch timezone`);
    }
  }

  resetCategoryTabs() {
    this.categoryMenu.activeTabIndex = 0;
    this.categoryMenu.selectedCategory = this.categoryMenu.tabs[0];
  }

  /** Method to perform operations by creating or deleting (re-initializing) the blockly workspace based on builder mode 
  * @param {string} eventType - The event type to create or delete the blockly workspace.
  * create - To create the blockly workspace and populate the blocks in workspace from XML.
  * delete - To delete the blockly workspace and clear the blocks from the workspace.
  */

  toggleWorkspace(eventType: string): Promise<void> {
    return new Promise((resolve) => {
      if (eventType == 'create') {
        this.pendingWorkspaceCreateAfterBlocklyReady = false;
        clearTimeout(this.blocklyInitRetryTimer);
        this.blocklyInitRetryTimer = null;
        this.blocklyInitRetryCount = 0;
        this.isLoadingAllSequences = true;
        this.modifiedFunctionBlocks = [];
        this.blocklyWorkSpace?.clear();
        if (this.builderMode === BuilderMode.LIBRARY_BUILDER) {
          this.defaultTabLabel = DefaultTabName.LIBRARY_BUILDER;
          setTimeout(async () => {
            await this.buildAndLoadFunctionFromXml();
            this.toggleWorkspaceReadOnlyMode(this.isWorkspaceReadOnly);
            this.showSequenceActionButtons = true;
            resolve(); // Resolve the promise here.
          }, 500);

        } else {
          this.buildAndLoadSequencesFromXml();
          this.toggleWorkspaceReadOnlyMode(this.isWorkspaceReadOnly); // To enable/disable the workspace read-only mode.
          this.showSequenceActionButtons = true;
        }
      } else {
        this.pendingWorkspaceCreateAfterBlocklyReady = false;
        clearTimeout(this.blocklyInitRetryTimer);
        this.blocklyInitRetryTimer = null;
        this.blocklyInitRetryCount = 0;
        this.isLoadingAllSequences = true;
        this.showHideToolBox(false);
        this.showToolBoxToggleButton = false;
        this.showSequenceActionButtons = false;
        if (this.blocklyWorkSpace) {
          this.blocklyWorkSpace.clear();
          this.blocklyWorkSpace.dispose();
          this.blocklyWorkSpace = null;
        }
        this.breadcrumbs = [];
        this.isLoadingAllSequences = false;
      }
    });
  }

  getWorkSpaceBySite() {
    this.isLoading = true;
    return this.siteSequencerService.getWorkspaceBySite(this.selectedSiteId, this.canvasTabs.selectedCanvasTab?.id);
  }

  async saveWorkspaceXML(showToastMessage?: boolean, skipStoringXML?: boolean) {
    this.closeOnlyTextEditor();
    let xml = Blockly.Xml.workspaceToDom(this.blocklyWorkSpace);
    var xmlString = new XMLSerializer().serializeToString(xml);
    xmlString = xmlString
      .replace(/deletable="false"/g, 'deletable="true"')
      .replace(/movable="false"/g, 'movable="true"')
      .replace(/editable="false"/g, 'editable="true"');
    let workspaceRef: any = {
      "siteRef": this.selectedSiteId,
      "workspaceXml": xmlString || '',
      "category": this.categoryMenu.selectedCategory.id,  // "category": "CLOUD" or "CCU" or "DEVICE"
      "name": this.canvasTabs.selectedCanvasTab?.name,
      "id": this.canvasTabs.selectedCanvasTab?.id
    }

    try {
      const res: any = await lastValueFrom(this.siteSequencerService.saveWorkspace(workspaceRef));
      !skipStoringXML ? this.workspaceXML = xmlString : '';
      if (showToastMessage) {
        this.isLoading = false;
        if (this.canvasTabs.selectedCanvasTab) {
          this.canvasTabs.selectedCanvasTab.workspaceXml = xmlString;
          this.updateWorkspaceXMLInCanvasTab(this.canvasTabs.selectedCanvasTab, workspaceRef);
        }
        this.showToast('success', 'Workspace saved successfully');
        if (this.categoryMenu.selectedCategory.id == Category.DEVICE) {
          this.sequenceLastUpdatedTime = res?.modifiedBy ? res.modifiedBy.dateTime : '';
          this.toggleWorkspaceErrorMessage();
        }
      }
    } catch (e: any) {
      this.showToast('error', `${e.message}`);
    }
  }

  saveSequence(sequence: any) {
    const quartzCronRequest = this.getQuartzCronRequestValue(sequence);
    let payload: any = {
      "siteRef": this.selectedSiteId,
      "seqName": sequence.seqName.trim(),
      "blocklyXml": sequence.blocklyXml || '',
      "snippet": sequence.snippet || '',
      "quartzCronRequest": quartzCronRequest,
      'enabled': sequence.isEnabled,
      'workspaceId': this.canvasTabs.selectedCanvasTab?.id,
    }
    sequence.seqId ? payload['seqId'] = sequence.seqId : '';
    if (this.categoryMenu.selectedCategory.id === Category.SYSTEM) {
      payload['scope'] = sequence.selectedScopeValue || [null];
    }
    return this.siteSequencerService.saveOrUpdateSequence(payload);
  }

  getQuartzCronRequestValue(sequence: any) {
    if (!sequence['frequency']) sequence['frequency'] = 'EVERY_MINUTE';
    const currentUTCTime = new Date(Date.now());
    const daysOfWeek = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
    const dayIndex = currentUTCTime.getDay();
    const dayUTC = daysOfWeek[dayIndex];
    const hoursUTC = currentUTCTime.getHours();
    const minutesUTC = currentUTCTime.getMinutes();
    let payload: any = {
      "frequency": sequence['frequency']
    };
    if (sequence['frequency'] == 'DAILY' || sequence['frequency'] == 'EVERY_MONTH') {
      payload['hour'] = hoursUTC;
      payload['minute'] = minutesUTC;
    } else if (sequence['frequency'] == 'HOURLY') {
      payload['minute'] = minutesUTC;
    } else if (sequence['frequency'] == 'EVERY_MINUTE') {
      payload['minute'] = 1;
    } else if (sequence['frequency'] == 'WEEKLY') {
      payload['hour'] = hoursUTC;
      payload['minute'] = minutesUTC;
      payload['dayOfWeek'] = dayUTC;
    }
    return payload;
  }

  updateAllSequences(payload: any) {
    const selectedCanvasTabId: string = this.canvasTabs.selectedCanvasTab?.id || '';
    return this.siteSequencerService.updateAllSequences(this.selectedSiteId, selectedCanvasTabId, payload);
  }

  loadSavedState() {
    this.isLoading = true;
    let currentWorkspaceXml = this.parseXMLForSequence();
    currentWorkspaceXml === XMLEnum.DEFAULT_XML ? currentWorkspaceXml = '' : '';
    this.sequences = [];
    this.breadcrumbs = [];
    this.sequenceTabs = [];
    this.deviceRunBlocksOnWorkspace = []; // Clearing the existing device run blocks on workspace
    this.errorBlocks = [];
    this.blocklyWorkSpace.clear();
    this.isLoadingAllSequences = true;
    this.isLoadingSavedState = true;
    this.workspaceXML === XMLEnum.DEFAULT_XML ? this.workspaceXML = '' : '';
    this.noChangesInWorkspace = this.workspaceXML === currentWorkspaceXml; // Comparing the current workspace XML with the saved workspace XML to enable/disable the save button.
    this.extractPointBlocksFromXml(this.workspaceXML);
    if (this.categoryMenu.selectedCategory.id === Category.DEVICE) {
      this.buildDeviceSequenceCollectionWithCallback(() => {
        this.loadBlocksFromXmlForSavedState(); // Load only after buildDeviceSequenceCollection is done
      });
    } else {
      this.loadBlocksFromXmlForSavedState(); // Load blocks from XML after building the sequence collection
    }
  }

  loadBlocksFromXmlForSavedState() {
    const savedWorkspaceXml = this.workspaceXML; // Saved XML string when blocks are loaded into the workspace during initial load.
    const loadedBlocksFromXml: any = this.addBlocksToCanvasFromXML(savedWorkspaceXml);
    loadedBlocksFromXml.then((blocks: any) => {
      if (blocks && blocks.length > 0) {
        if (this.categoryMenu.selectedCategory.id === Category.DEVICE) {
          this.blocklyWorkSpace?.scrollCenter(); // Scroll the workspace to center after loading blocks
        } else {
          if (this.categoryMenu.selectedCategory.id === Category.SYSTEM) this.blocklyWorkSpace?.scrollCenter();
          this.buildSequenceCollection();
        }
        // To avoid triggering create event handler after populating all blocks to workspace. 
        setTimeout(() => {
          this.resetToViewMode();
        }, 3000)
      } else {
        this.resetToViewMode();
      }
    }).catch((err: any) => {
      this.resetToViewMode();
    })
  }

  // resets the workspace to view mode
  resetToViewMode() {
    this.isLoadingAllSequences = false;
    this.isLoadingSavedState = false;
    this.isLoading = false;
  }

  // Load default blocks in to the workspace and save the sequence
  loadDefaultDeviceBlocks(isDeletingWorkspace: boolean = false) {
    this.isLoadingAllSequences = true;
    const json = this.canvasTabs.tabs.length < 2 && !isDeletingWorkspace ? JSON.parse(JSON.stringify(DEFAULT_TEMPLATE)) : {};
    Blockly.serialization.workspaces.load(json, this.blocklyWorkSpace); // Loading default blocks to workspace
    const newSequence: any = this.deviceSequenceConfig;
    this.blocklyWorkSpace?.scrollCenter();
    // Saving the sequence without sequence id
    this.saveSequence(newSequence).subscribe((sequenceObj: any) => {
      if (sequenceObj && sequenceObj['seqId']) {
        newSequence['seqId'] = sequenceObj.seqId;  // Setting the created sequence Id to the sequence object
        this.sequences.push(newSequence);  // Adding sequence block to the collection
      }
      this.saveWorkspaceXML();
      this.noChangesInWorkspace = true; // Setting the flag to true after loading the default blocks to avoid the save button to be enabled.
    });
  }

  buildAndLoadSequencesFromXml(isDeletingWorkspace = false) {
    this.sequences = [];
    this.breadcrumbs = [];
    this.sequenceTabs = [];
    this.deviceRunBlocksOnWorkspace = []; // Clearing the existing device run blocks on workspace
    this.togglePlaceholderMessage();
    this.getWorkSpaceBySite()
      .subscribe((res) => {
        if (res && res.workspaceXml) {
          this.workspaceXML = res.workspaceXml;
          this.extractPointBlocksFromXml(this.workspaceXML);
          if (this.categoryMenu.selectedCategory.id === Category.DEVICE) {
            this.buildDeviceSequenceCollectionWithCallback(() => {
              this.loadBlocksFromXml(); // Load only after buildDeviceSequenceCollection is done
              this.isLoading = false;
            });
          } else {
            this.loadBlocksFromXml();
            this.isLoading = false;
          }
        } else {
          if (this.categoryMenu.selectedCategory.id === Category.DEVICE && this.isCreatingNewDeviceCanvas) {
            this.loadDefaultDeviceBlocks(isDeletingWorkspace);
            this.isCreatingNewDeviceCanvas = false;
          } else {
            this.workspaceXML = '';
          }
          this.isLoadingAllSequences = false;
          this.isLoading = false;
        }

        // Setting the noChangesInWorkspace flag to true after loading the blocks from XML to avoid the save button to be enabled.
        this.noChangesInWorkspace = true;

      }, (err: any) => {
        this.showToast('error', `${err.message}`);
        this.isLoading = false;
        this.isLoadingAllSequences = false;
        this.workspaceXML = '';
        this.noChangesInWorkspace = true;
      });
  }


  buildDeviceSequenceCollectionWithCallback(callback: () => void) {
    const defaultSequence = JSON.parse(JSON.stringify(this.deviceSequenceConfig));
    const selectedCanvasTabId: string = this.canvasTabs.selectedCanvasTab?.id || '';
    this.siteSequencerService.getAllSequencesPerWorkspace(this.selectedSiteId, selectedCanvasTabId).subscribe({
      next: (res) => {
        this.sequences = [...res];
        this.modelOptions = res[0]?.metadata ? res[0].metadata : [];
        this.sequenceLastUpdatedTime = res[0]?.modifiedBy ? res[0].modifiedBy.dateTime : '';
        this.toggleWorkspaceErrorMessage();
        if (!res?.length) {
          this.saveSequence(defaultSequence).subscribe((sequenceObj: any) => {
            if (sequenceObj?.seqId) {
              defaultSequence.seqId = sequenceObj.seqId;
              this.sequences.push(defaultSequence);
            }
            this.saveWorkspaceXML();
            callback();
          });
        } else {
          callback();
        }
      },
      error: () => {
        this.sequences = [defaultSequence];
        callback();
      }
    });
  }

  loadBlocksFromXml() {
    const loadedBlocksFromXml = this.addBlocksToCanvasFromXML(this.workspaceXML);
    loadedBlocksFromXml.then((blocks: any) => {
      if (blocks?.length > 0) {
        if (this.categoryMenu.selectedCategory.id === Category.DEVICE) {
          this.blocklyWorkSpace?.scrollCenter();
        } else {
          if (this.categoryMenu.selectedCategory.id === Category.SYSTEM) {
            this.blocklyWorkSpace?.scrollCenter();
            this.disposeDeprecatedBlocks();
          }
          this.buildSequenceCollection();
          if (this.sequenceTohighlight) {
            this.getBlockIntoView(this.sequenceTohighlight, true);
            this.sequenceTohighlight = null;
          }
        }

        this.modifiedFunctionBlocks = [];
        this.getUpdatesForFunctionBlocks();
        this.togglePlaceholderMessage();

        setTimeout(() => {
          this.isLoadingAllSequences = false;
        }, 3000);
      } else {
        if (this.categoryMenu.selectedCategory.id === Category.DEVICE) {
          if (this.isCreatingNewDeviceCanvas) {
            this.loadDefaultDeviceBlocks();
            this.isCreatingNewDeviceCanvas = false;
          } else {
            this.saveWorkspaceXML();
          }
        }
        this.isLoadingAllSequences = false;
      }
      this.togglePlaceholderMessage();
    }).catch(() => {
      this.isLoadingAllSequences = false;
    });
  }


  /** Method to open the push to device modal */
  async openPushToDeviceModal() {
    const canProceedToPush = await this.validateBeforeDeviceAction();
    if (!canProceedToPush) return;

    const uniqueModelIds = this.blocklyWorkspaceBuilderService.getUniqueModelIdsFromWorkspace(this.blocklyWorkSpace);
    const deviceType = this.blocklyWorkspaceBuilderService.getRunStartupDeviceType(this.blocklyWorkSpace) || 'CONNECT_MODULE';

    this.closeOnlyTextEditor();
    const dialogRef = this.dialog.open(PushDevicePopupComponent, {
      panelClass: 'fs-push-to-device-dialog',
      width: '340px',
      maxWidth: '340px',
      disableClose: false,
      autoFocus: false
    });
    dialogRef.componentInstance.siteRef = this.selectedSiteId;
    dialogRef.componentInstance.sequenceId = this.sequences[0].seqId;
    dialogRef.componentInstance.sequenceName = this.sequences[0]?.seqName ?? '';
    dialogRef.componentInstance.createdPointsCollection = this.createdPointsCollection;
    dialogRef.componentInstance.modelIds = uniqueModelIds;
    dialogRef.componentInstance.deviceType = deviceType;
    dialogRef.updatePosition({ top: '60px' });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.toggleWorkspaceErrorMessage();
      }
    });
  }



  // Extracting the model point blocks and setter blocks from the XML and adding to the workspace.
  /**
   * Method to extract the model point blocks and setter blocks from the XML string.
   * @param workspace - The XML string of the workspace.
   */
  extractPointBlocksFromXml(workspace: any) {
    if (this.categoryMenu.selectedCategory.id === Category.DEVICE) {
      this.setterBlocksToinitialize = [];
      this.pointBlocksToInitialize = [];

      const extractedBlocks = this.blocklyWorkspaceBuilderService.extractPointAndSetterBlocksFromXml(workspace);
      this.pointBlocksToInitialize = extractedBlocks.pointBlocksToInitialize;
      this.setterBlocksToinitialize = extractedBlocks.setterBlocksToInitialize;

      if (this.pointBlocksToInitialize.length > 0) {
        this.createDynamicBlocks(this.pointBlocksToInitialize);
        this.pointBlocksToInitialize = []; // Clearing the point blocks after creating point blocks.
      }

    }
  }

  // get the sequence block config for device category
  get deviceSequenceConfig() {
    const deviceSequenceName = this.canvasTabs.selectedCanvasTab?.name;
    const deviceSequence = {
      "seqName": deviceSequenceName,
      'blocklyXml': this.parseXMLForSequence(this.blocklyWorkSpace),
      'snippet': this.getJSCodeForSequence('', deviceSequenceName),
      'frequency': 'EVERY_MINUTE',
      'isEnabled': true,
      'alertBlocks': [],
      'functionIds': []
    }
    return deviceSequence;
  }

  // Building the device sequence collection from the populated blocks in the workspace.
  buildDeviceSequenceCollection() {
    // Getting all sequences of the workspace
    const defaultSequence = JSON.parse(JSON.stringify(this.deviceSequenceConfig));
    const selectedCanvasTabId: string = this.canvasTabs.selectedCanvasTab?.id || '';
    this.siteSequencerService.getAllSequencesPerWorkspace(this.selectedSiteId, selectedCanvasTabId)
      .subscribe((res) => {
        this.sequences = [];
        if (res && res.length > 0) {
          this.sequences = [...res]; // Adding sequence to the sequence collection
          this.modelOptions = res[0]?.metadata;
        } else {
          // Creating a new sequence If WorkspaceXML has value but no sequences found for workspace.
          this.sequences = [];
          // Saving the sequence withouth sequence id
          this.saveSequence(defaultSequence).subscribe((sequenceObj: any) => {
            if (sequenceObj && sequenceObj['seqId']) {
              defaultSequence['seqId'] = sequenceObj.seqId;  // Setting the created sequence Id to the sequence object
              this.sequences.push(defaultSequence);  // Adding sequence block to the collection
            }
            this.saveWorkspaceXML();
          });
        }
      }, err => {
        this.sequences = [defaultSequence];

      });
  }

  buildSequenceCollection() {
    const allBlocks = this.blocklyWorkSpace.getAllBlocks(true);

    // Building sequence collection by filtering the sequence blocks from all blocks in workspace.
    const sequenceBlocks = allBlocks.filter((blockObj: any) => this.sequenceBlockType.includes(blockObj.type));
    sequenceBlocks.forEach((sequenceBlock: any) => {
      let sequenceName = sequenceBlock.getFieldValue('markername') || '';
      const sequenceId = sequenceBlock.getFieldValue('sequenceId');

      // Building breadcrumb from each sequence and pushing into breadcrumb collection.
      let breadcrumbObj: any = {
        "seqName": sequenceName,
        "seqId": sequenceId
      };
      this.breadcrumbs.push(breadcrumbObj);

      // Checking the Run status of each sequence and creating a sequence tab if the run status is either 'Enable with logs' or 'Disable with logs'
      const seqTabEventType = sequenceBlock.getFieldValue('RUN_STATUS') === SequenceStatus.ENABLE_WITH_LOGS ||
        sequenceBlock.getFieldValue('RUN_STATUS') === SequenceStatus.DISABLE_WITH_LOGS ? 'create' : '';
      this.toggleSequenceTab(sequenceBlock, seqTabEventType);

      const isEnabled = sequenceBlock.getFieldValue('RUN_STATUS') === SequenceStatus.ENABLE ? true : false;
      const sequenceObj: any = {
        'seqId': sequenceBlock.getFieldValue('sequenceId'),
        'seqName': sequenceName,
        'blocklyXml': this.parseXMLForSequence(sequenceBlock),
        'snippet': this.getJSCodeForSequence(sequenceBlock, sequenceName),
        'isEnabled': isEnabled
      }
      if (sequenceBlock.type === BlockType.SEQUENCE || sequenceBlock.type === BlockType.SEQUENCE_SYSTEM) {
        sequenceObj['frequency'] = sequenceBlock.getFieldValue('Occurance');
      } else if (sequenceBlock.type === BlockType.MQTT_SUBSCRIBE) {
        sequenceObj['brokerUrl'] = javascriptGenerator.valueToCode(sequenceBlock, 'brokerUrl', javascriptGenerator.ORDER_ATOMIC).trim().replace(/^['"]|['"]$/g, '');
        sequenceObj['topic'] = javascriptGenerator.valueToCode(sequenceBlock, 'topic', javascriptGenerator.ORDER_ATOMIC).replace(/^['"]|['"]$/g, '');
        sequenceObj['username'] = javascriptGenerator.valueToCode(sequenceBlock, 'username', javascriptGenerator.ORDER_ATOMIC).replace(/^['"]|['"]$/g, '');
        sequenceObj['password'] = javascriptGenerator.valueToCode(sequenceBlock, 'password', javascriptGenerator.ORDER_ATOMIC).replace(/^['"]|['"]$/g, '');
      }

      if (sequenceBlock.type === BlockType.SEQUENCE_SYSTEM) {
        this.setScopeLabelForSystemSequences(sequenceBlock);
        sequenceObj['scope'] = this.getSelectedScopeIdsOfSequence(sequenceBlock);
      }
      this.sequences.push(sequenceObj);
      sequenceBlock.getField('sequenceId').setVisible(false);
      this.blocklyWorkSpace.render();
    });
  }

  /**
 * fetching the miniature blocks that are used in the workspace, when the corresponding function definition gets updated.
 */

  getUpdatesForFunctionBlocks() {
    const allBlocks = this.blocklyWorkSpace.getAllBlocks(true);
    const sequenceBlocksInCanvas = allBlocks.filter((blockObj: any) => this.sequenceBlockType.includes(blockObj.type));
    const selectedCanvasTabId: string = this.canvasTabs.selectedCanvasTab?.id || '';
    const isDeviceCategorySelected = this.categoryMenu.selectedCategory.id === Category.DEVICE;

    this.siteSequencerService.getAllSequencesPerWorkspace(this.selectedSiteId, selectedCanvasTabId).subscribe((res: any) => {
      if (res && res.length > 0) {
        const allSequencesOfSite = res;

        const processFunctionBlocks = (functionBlocks: any[], targetSequenceObj: any, sequenceName: string) => {
          functionBlocks.forEach((functionBlockObj: any) => {
            const targetFunctionObj = this.sequencerFunctionCollection.find((fnObj: any) => fnObj.functionId === functionBlockObj.getFieldValue('functionId'));
            if (targetFunctionObj) {
              const functionUpdatedDate = new Date(targetFunctionObj.createdBy.dateTime);
              const sequenceUpdatedDate = new Date(targetSequenceObj.modifiedBy.dateTime);
              if (functionUpdatedDate > sequenceUpdatedDate) {
                this.buildModifiedFunctionBlocksCollection('update', functionBlockObj, sequenceName);
              }
            }
          });
        };

        if (!isDeviceCategorySelected) {
          sequenceBlocksInCanvas.forEach((sequenceBlockObj: any) => {
            const sequenceName = sequenceBlockObj.getFieldValue('markername');
            const childBlocksOfSequence = sequenceBlockObj.getDescendants('ordered');
            const functionBlocksInSequence = childBlocksOfSequence?.filter((blockObj: any) => blockObj.type.includes('fn_')) || [];
            const targetSequenceObj = allSequencesOfSite.find((sequenceObj: any) => sequenceObj.seqId === sequenceBlockObj.getFieldValue('sequenceId'));
            processFunctionBlocks(functionBlocksInSequence, targetSequenceObj, sequenceName);
          });
        } else {
          const sequenceName = allSequencesOfSite[0].seqName;
          const functionBlocks = allBlocks.filter((blockObj: any) => blockObj.type.includes('fn_'));
          processFunctionBlocks(functionBlocks, allSequencesOfSite[0], sequenceName);
        }
        if (this.modifiedFunctionBlocks.length > 0) {
          this.showSeqFunctionUpdatesInPopup();
        }
      }
    });
  }

  /**
   * creating the modified or deleted miniature sequence function collection to display them in a popup.
   * @param {string} eventType - The event type to identify whether the function block is updated or deleted. 
   * @param {any} updatedFunctionBlock - The updated function block object.
   * @param {any} sequenceName - The name of the sequence to which the function block is associated.
   */

  buildModifiedFunctionBlocksCollection(eventType: string, updatedFunctionBlock: any, sequenceName: any) {
    const keyName = eventType ? eventType === 'delete' ? 'deletedFunctions' : 'updatedFunctions' : '';
    const updatedSeqFunctionName = updatedFunctionBlock.getFieldValue('seqFunctionName');
    const existingSequenceIndex = this.modifiedFunctionBlocks.findIndex((item: any) => item.sequence === sequenceName);

    if (existingSequenceIndex >= 0) {
      const isExistingFunction = this.modifiedFunctionBlocks[existingSequenceIndex][keyName].includes(updatedSeqFunctionName);
      if (!isExistingFunction) {
        this.modifiedFunctionBlocks[existingSequenceIndex][keyName].push(updatedSeqFunctionName);
      }
    } else {
      let updatedSequenceObj: any = {
        "sequence": sequenceName,
      }
      updatedSequenceObj[keyName] = [updatedSeqFunctionName]
      this.modifiedFunctionBlocks.push(updatedSequenceObj);
    }
  }

  /**
   * Displaying the modified or deleted sequence function names in a popup along with corresponding sequence name.
   */

  showSeqFunctionUpdatesInPopup() {
    const dialogRef = this.dialog.open(SequenceValidationPopupComponent, {
      panelClass: 'fs-mat-dialog-container',
      minWidth: '480px',
      // Keep Escape behavior consistent: child overlays close first, then the top dialog.
      disableClose: false
    });
    const title = 'Sequence Function Updates';
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.htmlContent = this.modifiedFunctionBlocks;
    dialogRef.componentInstance.type = 'dialog';
    dialogRef.componentInstance.showConfirmIcon = true;
    dialogRef.updatePosition({ top: '60px' });
    dialogRef.afterClosed().subscribe(result => { });
  }

  formatXml(workspaceXml: any) {
    return this.blocklyWorkspaceBuilderService.normalizeWorkspaceXml(workspaceXml);
  }

  buildAndLoadFunctionFromXml(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.isLoading = true;
      this.sequencerBlock = null;
      if (this.selectedFunctionToView && this.selectedFunctionToView.xml) {
        this.selectedFunctionToView = this.normalizeSequenceFunctionForLibraryBuilder(this.selectedFunctionToView);
        const workspaceXML = this.formatXml(this.selectedFunctionToView.xml);
        const loadedBlocksFromXml: any = this.addBlocksToCanvasFromXML(workspaceXML);
        loadedBlocksFromXml.then((blocks: any) => {
          if (blocks && blocks.length > 0) {
            const allBlocks = this.blocklyWorkSpace.getAllBlocks(true);
            const sequencerBlock = allBlocks.find((blockObj: any) => blockObj.type === BlockType.SEQUENCER);
            this.hydrateSequencerBlockMetadata(sequencerBlock, this.selectedFunctionToView);
            sequencerBlock.getField('functionId').setVisible(false);
            this.blocklyWorkSpace.render();
            this.sequencerBlock = {
              "seqFunctionName": sequencerBlock.getFieldValue('seqFunctionName'),
              "xml": this.parseXMLForSequence(sequencerBlock),
              "snippet": this.getJSCodeForSequence(sequencerBlock, ''),
              "functionId": sequencerBlock.getFieldValue('functionId'),
              "why": sequencerBlock.getFieldValue('why'),
              "what": sequencerBlock.getFieldValue('what')
            }
            this.defaultTabLabel = this.sequencerBlock.seqFunctionName ? this.sequencerBlock.seqFunctionName : DefaultTabName.LIBRARY_BUILDER;
            // Bringing the sequencer to the center of the canvas.
            const blockToHighlight = { "id": sequencerBlock.id };
            this.getBlockIntoView(blockToHighlight, false);
            // To avoid triggering create event handler after populating all blocks to workspace. 
            setTimeout(() => {
              this.isLoadingAllSequences = false;
              this.isLoading = false;
              resolve();
            }, 3000)
          } else {
            this.isLoadingAllSequences = false;
            this.isLoading = false;
            resolve();
          }
        }).catch((err: any) => {
          this.isLoadingAllSequences = false;
          this.isLoading = false;
          reject(err);
        })
      } else {
        this.isLoadingAllSequences = false;
        this.isLoading = false;
        resolve();
      }
    });
  }

  /** Method to add blocks to the canvas from the workspaceXml 
   * @param {any} workspaceXML - The workspaceXml to populate the blocks in the canvas.
   */
  async addBlocksToCanvasFromXML(workspaceXML: any) {
    const loadedBlocks = await this.blocklyWorkspaceBuilderService.loadXmlIntoWorkspace(this.blocklyWorkSpace, workspaceXML, true);
    const allBlocks = this.blocklyWorkSpace.getAllBlocks(true);
    this.prepareHaystackQueryBuilderBlocks(allBlocks);
    return loadedBlocks;
  }

  private hydrateSequencerBlockMetadata(sequencerBlock: any, sequenceFunction: any) {
    if (!sequencerBlock || !sequenceFunction) return;

    [
      { fieldName: BlockFieldName.SEQUENCE_FUNCTION_ID, value: sequenceFunction.functionId },
      { fieldName: 'why', value: sequenceFunction.why },
      { fieldName: 'what', value: sequenceFunction.what }
    ].forEach(({ fieldName, value }) => {
      const field = sequencerBlock.getField(fieldName);
      const currentValue = sequencerBlock.getFieldValue(fieldName);
      if (field && (!currentValue || currentValue.trim() === '') && value) {
        sequencerBlock.setFieldValue(value, fieldName);
      }
    });
  }

  /** Method to update the sequence block with the updated sequence name 
   * @param {any} blockId - The block id of the sequence block to find in workspace.
   * @param {any} fieldName - Field name in sequencer block.
   * @param {any} fieldValue - Field value to update in targetField on sequence block.
  */
  setAndHideFieldsinBlock(blockId: any, fieldName: any, fieldValue: any) {
    this.isUpdatingExistingMarker = true;
    const block = this.blocklyWorkSpace.getBlockById(blockId);
    let field = block.getField(fieldName);
    field.setValue(fieldValue);
    field.setVisible(false);
    this.blocklyWorkSpace.render();
  }

  /**
   * Method to handle function block events on workspace. (create, delete, input field change)
   * @param {any} event - event object from blockly. 
  */
  handleFunctionBlockEvents(event: any) {
    const targetBlock = this.blocklyWorkSpace.getBlockById(event.blockId);
    const currentBlockType = event.type === 'create' ? event.json?.type : (event.type === 'delete' ? event.oldJson?.type : '');
    if ((targetBlock && targetBlock.type === BlockType.SEQUENCER) || currentBlockType === BlockType.SEQUENCER) {
      if (event.type === 'create') {
        this.handleFunctionCreation(event, targetBlock);
      } else if (event.type === 'delete') {
        this.handleFunctionDeletion(event);
      } else if (event.type === 'block_field_intermediate_change') {
        this.handleFunctionInputFieldChange(event, targetBlock);
      } else if (event.type === 'change' && event.element === 'collapsed' && !event.newValue) {
        // When the sequencer block is expanded, we need to hide the functionId field.
        this.hideBlockFields(targetBlock, [BlockFieldName.SEQUENCE_FUNCTION_ID]);
      }
    }
  }

  handleFunctionCreation(event: any, targetBlock: any) {
    if (!this.isLoadingAllSequences) {
      if (!this.isWorkspaceReadOnly) {
        if (!this.sequencerBlock) {
          const defaultFunctionName = this.getUniqueValueWithCopySuffix(DefaultTabName.LIBRARY_BUILDER, 'seqFunctionName', this.sequencerFunctionCollection);
          const existingName = targetBlock.getFieldValue('seqFunctionName');
          this.sequencerBlock = {
            "seqFunctionName": existingName ? existingName : defaultFunctionName,
            "why": '.',
            "what": '.',
            "xml": this.parseXMLForSequence(targetBlock),
            "snippet": this.getJSCodeForSequence(targetBlock, ''),
          }
          this.activeSequencerBlockRef = targetBlock.id;
          targetBlock.setFieldValue(this.activeSequencerBlockRef, 'functionId');
          targetBlock.getField('functionId').setVisible(false);
        } else {
          this.isLoadingAllSequences = true;
          targetBlock.dispose();
          this.showToast('error', `Sequencer definition should not contain multiple sequencer blocks.`);
          setTimeout(() => {
            this.isLoadingAllSequences = false;
          }, 500);
        }

      } else {
        const allBlocks = this.blocklyWorkSpace.getAllBlocks(true);
        const existingSequencerBlock = allBlocks.find((blockObj: any) => blockObj.getFieldValue('functionId') === this.sequencerBlock.functionId);
        if (!existingSequencerBlock) {
          targetBlock.setFieldValue(this.sequencerBlock.functionId, 'functionId');
          targetBlock.getField('functionId').setVisible(false);
        } else {
          this.isLoadingAllSequences = true;
          targetBlock.dispose();
          this.showToast('error', `Sequencer definition should not contain multiple sequencer blocks.`);
          setTimeout(() => {
            this.isLoadingAllSequences = false;
          }, 500);
        }
      }
    }
  }

  handleFunctionDeletion(event: any) {
    if (!this.isLoadingAllSequences && !this.isWorkspaceReadOnly) {
      this.sequencerBlock = null;
      this.defaultTabLabel = DefaultTabName.LIBRARY_BUILDER;
    }
  }

  formatDate(date: any) {
    return dayjs.utc(date).local().format('MMM D, YYYY | h:mm A');
  }

  handleFunctionInputFieldChange(event: any, targetBlock: any) {
    if (event.name === 'seqFunctionName') {
      this.sequencerBlock.seqFunctionName = event.newValue;
      this.defaultTabLabel = event.newValue ? event.newValue : DefaultTabName.LIBRARY_BUILDER;
      this.updateSequencerBlockConfig(targetBlock);
    }
  }

  /**
   * Method to handle device run block events on workspace.
   * @param {any} event - event object from blockly.
   */

  handleDeviceRunBlockEvents(event: any) {
    if (event.blockId) {
      const allowedDeviceRunBlockTypes = [DeviceRunBlockType.RUN_BLOCK_STARTUP, DeviceRunBlockType.RUN_BLOCK_CONTINUOUS];
      const targetBlock = this.blocklyWorkSpace.getBlockById(event.blockId);
      const currentBlockType = event.type === 'create' ? event.json?.type : (event.type === 'delete' ? event.oldJson?.type : '');
      const blockType = targetBlock && targetBlock.type ? targetBlock.type : currentBlockType;
      const runBlocksOnWorkspace = this.blocklyWorkSpace.getAllBlocks(true).filter((blockObj: any) => allowedDeviceRunBlockTypes.includes(blockObj.type));
      if (allowedDeviceRunBlockTypes.includes(blockType)) {
        if (event.type === 'create' && !this.isLoadingAllSequences) {
          const targetRunBlocksOnCanvas = runBlocksOnWorkspace.filter((blockObj: any) => blockObj.type === blockType);
          if (targetRunBlocksOnCanvas.length > 1) {
            // Showing error when the run block is already exists in the workspace
            this.isLoadingAllSequences = true;
            targetBlock.dispose();
            this.showToast('error', `Workspace should not contain more than one ${blockType} block.`);
            setTimeout(() => {
              this.isLoadingAllSequences = false;
            }, 500);
          }
          if (blockType === DeviceRunBlockType.RUN_BLOCK_STARTUP && targetBlock) {
            const deviceType = targetBlock.getFieldValue('DEVICE_TYPE');
            this.updateDeviceTypeOptionsForDeviceBlocks(deviceType);
          }
        }
        if ((event.type === 'change' || event.type === 'block_field_intermediate_change')
          && blockType === DeviceRunBlockType.RUN_BLOCK_STARTUP
          && event.name === 'DEVICE_TYPE') {
          this.updateDeviceTypeOptionsForDeviceBlocks(event.newValue);
          this.validateBacnetBlocksOnWorkspace();
        }

      }
    }

  }

  handleDeviceTypeRestrictedBlockEvents(event: any) {
    if (this.builderMode !== BuilderMode.SEQUENCE_BUILDER || this.categoryMenu.selectedCategory.id !== Category.DEVICE) return;
    if (!event?.blockId || event.type !== 'create') return;
    const targetBlock = this.blocklyWorkSpace.getBlockById(event.blockId);

    if (targetBlock && this.porBusRestrictedBlocks.includes(targetBlock.type)) {
      const parentBlock = targetBlock.getParent ? targetBlock.getParent() : null;
      const isNestedUnderPorBlock = parentBlock && this.porBusRestrictedBlocks.includes(parentBlock.type);
      if (!isNestedUnderPorBlock && !this.isPorBusBlockAllowed(targetBlock)) {
        this.isLoadingAllSequences = true;
        targetBlock.dispose();
        this.showToast('error', 'POR bus blocks are supported only for Smart Node device type');
        setTimeout(() => {
          this.isLoadingAllSequences = false;
        }, 500);
        return;
      }
    }

    if (targetBlock && this.deviceTypeRestrictedBlocks.includes(targetBlock.type)) {
      const deviceType = this.getRunStartupDeviceType() || 'CONNECT_MODULE';
      this.updateDeviceTypeOptionsForDeviceBlocks(deviceType);
    }
  }

  handleBacnetBlockEvents(event: any) {
    if (this.builderMode !== BuilderMode.SEQUENCE_BUILDER || this.categoryMenu.selectedCategory.id !== Category.DEVICE) return;
    if (!event?.blockId || event.type !== 'create') return;
    const targetBlock = this.blocklyWorkSpace.getBlockById(event.blockId);
    if (targetBlock && this.bacnetBlockTypes.includes(targetBlock.type) && this.isSmartNodeDeviceType()) {
      // Prevent adding BACnet blocks in Smart Node device type
      this.isLoadingAllSequences = true;
      targetBlock.dispose();
      this.showToast('error', 'BACnet blocks are not supported for Smart Node');
      setTimeout(() => {
        this.isLoadingAllSequences = false;
      }, 500);
    }
  }

  getBlockTypeFromEvent(event: any) {
    return this.blocklyWorkspaceBuilderService.getBlockTypeFromEvent(this.blocklyWorkSpace, event);
  }

  handleSequenceBlockEvents(event: any) {
    const targetBlock = this.blocklyWorkSpace.getBlockById(event.blockId);
    const currentBlockType = event.type === 'create' ? event.json?.type : (event.type === 'delete' ? event.oldJson?.type : '');
    if (targetBlock && this.sequenceBlockType.includes(targetBlock.type) || this.sequenceBlockType.includes(currentBlockType)) {
      if (event.type === 'create') {
        if (this.cloudSequenceBlocks.includes(targetBlock.type) || this.cloudSequenceBlocks.includes(currentBlockType)) {
          this.handleSequenceCreation(event, targetBlock);
        } else if (targetBlock.type === BlockType.SEQUENCE_SYSTEM || currentBlockType === BlockType.SEQUENCE_SYSTEM) {
          this.handleSystemSequenceBlockCreateEvent(event, targetBlock);
        } else {
          this.handleDeviceSequenceBlockCreateEvent(event, targetBlock);
        }
      } else if (event.type === 'delete') {
        this.handleSequenceDeletion(event);
      } else if (event.type === 'block_field_intermediate_change') {
        event.newValue ? this.handleSequenceInputFieldChange(event, targetBlock) : '';
      } else if (event.type === 'change') {
        this.handleSequenceDropdownChange(event, targetBlock);
        if (event.element === 'collapsed' && !event.newValue) {
          // Hiding the sequence block fields ('sequenceId', 'selectedScopeValue') when the block is expanded from collapsed state
          this.hideBlockFields(targetBlock, [BlockFieldName.SEQUENCE_ID, BlockFieldName.SELECTED_SCOPE_VALUE]);
        }
      } else if (event.type === 'move') {
        // Handling the move events of sequence blocks.
        this.sortBreadCrumbs();
      }
    }
  }

  handleSystemSequenceBlockCreateEvent(event: any, targetBlock: any) {
    this.handleSequenceCreation(event, targetBlock);
    this.commonService.subcribeToScopeDropdownClick(targetBlock, 'scope', true);
    this.subscribeTodeliveryLogsButtonClick(targetBlock);
  }

  handleDeviceSequenceBlockCreateEvent(event: any, targetBlock: any) {
    if (!this.isUpdatingExistingMarker && !this.isLoadingAllSequences && !targetBlock['isCreated']) {
      if (this.sequences.length >= 1) {
        //show error
        this.isLoadingAllSequences = true;
        targetBlock.dispose();
        this.showToast('error', `Workspace should not contain more than one device sequences`);
        setTimeout(() => {
          this.isLoadingAllSequences = false;
        }, 500);
      } else {
        this.handleSequenceCreation(event, targetBlock);
      }
    }
  }


  /**
   * Method to invoke different functions based on events triggered for model blocks.
   * @param event - The event object from blockly.
   */
  handleModelBlockEvents(event: any) {
    const targetBlock = this.blocklyWorkSpace.getBlockById(event.blockId);
    const currentBlockType = event.type === 'create' ? event.json?.type : (event.type === 'delete' ? event.oldJson?.type : '');
    if ((targetBlock && targetBlock.type === BlockType.MODEL_BLOCK) || currentBlockType === BlockType.MODEL_BLOCK) {
      const isBlockInFlyout = event.type !== 'delete' ? targetBlock.isInFlyout : true; // Flag to check if the event is triggered when the block is in toolbox..
      if (event.type === 'create') {
        this.handleModelBlockCreation(targetBlock);
      } else if (event.type === 'delete') {
        this.syncPointBlocksWithSelectedModels();
      } else if (event.type === Blockly.Events.CHANGE && !isBlockInFlyout) {
        if (event.newValue) {
          this.handleModelBlockDropdownChange(event, targetBlock);
        } else {
          // Hiding the model block fields ('selectedModelId', 'modelVersion') when the block is expanded from collapsed state
          event.element === 'collapsed' ? this.hideBlockFields(targetBlock, [BlockFieldName.SELECTED_MODEL_ID, BlockFieldName.MODEL_VERSION]) : '';
        }
      } else if ((event['newCoordinate'] && event['oldCoordinate']) || event['newParentId']) {
        this.syncPointBlocksWithSelectedModels();
      }
    } else {
      // Method to check if any block has a model block as child or not.
      this.handleNestedModelBlockEvents(event, targetBlock);
    }
  }


  /**
   * Method to trigger when the created block has Model block as child blocks  
   * @param event 
   * @param targetBlock 
   */
  handleNestedModelBlockEvents(event: any, targetBlock: any) {
    // Blockly only triggers the create event for the top level blocks. 
    // If the model block is a child or nested block, For every block creation, we need to check if the block has a model block as it's child or not.
    // If yes, then we need to manually call the appropriate methods for each child with type model_block.
    if (event.type === 'create' && targetBlock) {
      if (targetBlock) {
        const childModelBlocks = targetBlock.getDescendants('ordered').filter((blockObj: any) => blockObj.type === BlockType.MODEL_BLOCK);
        const currentBlockType = event.type === 'create' ? event.json?.type : (event.type === 'delete' ? event.oldJson?.type : '');
        const modelBlockIdsInWorkspace = this.blocklyWorkSpace.getAllBlocks(true).filter((blockObj: any) => blockObj.type === BlockType.MODEL_BLOCK).map((blockObj: any) => blockObj.id);
        if (childModelBlocks.length > 0) {
          childModelBlocks.forEach((childBlock: any) => {
            childBlock['isCreated'] || (modelBlockIdsInWorkspace.includes(childBlock.id)) ? this.handleModelBlockCreation(childBlock) : '';
          });
        }
      }
    } else if (event.type === 'delete' && !this.isLoadingSavedState) {
      if (event.oldXml) {
        const deletedBlockXml = event.oldXml;
        const childBlocks = [...deletedBlockXml.getElementsByTagName('block')];
        if (childBlocks.length > 0) {
          const childBlockTypes = childBlocks.map(block => block.getAttribute('type'));
          if (childBlockTypes.includes(BlockType.MODEL_BLOCK)) {
            this.syncPointBlocksWithSelectedModels();
          }
        }
      }
    }
  }


  /**
   * Method to handle the create event when a point setter block is dragged from the toolbox to the workspace,
   * or when point setter blocks are populated from the workspace XML.
   * @param {any} targetBlock - The target model block in the workspace.
  */
  handleSetterBlockCreation(targetBlock: any) {
    targetBlock.getField('selected_point_ref').setVisible(false);
    this.blocklyWorkSpace.render();
    this.updateSetterBlockOptions();
    this.commonService.subcribeToScopeDropdownClick(targetBlock, BlockFieldName.SELECTED_POINT_NAME, true);
    targetBlock['isDropdownClickEventAdded'] = true;
  }


  handleSetterBlockDropdownChange(event: any, targetBlock: any) {
    const setterBlockOptions = targetBlock.getField(BlockFieldName.SELECTED_POINT_NAME).getOptions();
    const targetSelectedSetterOption = setterBlockOptions.find((option: any) => option[1] === event.newValue);
    const selectedPointDomain = event.newValue;
    const selectedPointName = targetSelectedSetterOption[0];
    targetBlock.setFieldValue(selectedPointDomain, 'selected_point_ref');
    targetBlock.getField('selected_point_ref').setVisible(false);
  }

  /**
   * Method to handle the create event when a block is dragged from the toolbox to the workspace,
   * or when model blocks are populated from the workspace XML.
   * @param {any} targetBlock - The target model block in the workspace.
  */
  handleModelBlockCreation(targetBlock: any) {
    targetBlock.getField('selectedModelId').setVisible(false);
    targetBlock.getField('modelVersion').setVisible(false);
    this.blocklyWorkSpace.render();
    const modelBlocksInWorkspace = this.blocklyWorkSpace.getAllBlocks(true).filter((blockObj: any) => blockObj.type === BlockType.MODEL_BLOCK);
    if (modelBlocksInWorkspace.length > 8) {
      // Showing error when the model block count in the workspace exceeds.
      targetBlock.dispose();
      this.showToast('error', `Workspace cannot contain more than ${BlocksLimitOnWorkspace.MODEL_BLOCKS} Models.`);
    } else {
      // Setting the options to the dropdown field of the created model block.
      this.setModelBlockDropdownOptions(targetBlock);
      this.formatCategoryNames();

      if (!targetBlock['isDropdownClickEventAdded']) {
        this.commonService.subcribeToScopeDropdownClick(targetBlock, BlockFieldName.SELECTED_MODEL, true);
        targetBlock['isDropdownClickEventAdded'] = true;
      }
    }
  }

  /**
   * Method to handle the dropdown change event of the modelblock in the workspace.
   * @param {any} event - The dropdown change event object from blockly.
   * @param {any} targetBlock - The target model block in the workspace.
   **/
  handleModelBlockDropdownChange(event: any, targetBlock: any) {
    if (event.name === BlockFieldName.SELECTED_MODEL) {
      const modalOptions = targetBlock.getField(BlockFieldName.SELECTED_MODEL).getOptions();
      const targetSelectedModalOption = modalOptions.find((option: any) => option[1] === event.newValue);
      const selectedModalId = event.newValue;
      const selectedModalName = targetSelectedModalOption[0];
      targetBlock.setFieldValue(selectedModalId, 'selectedModelId');
      targetBlock.getField('selectedModelId').setVisible(false);
      if (selectedModalId && selectedModalName) {
        this.fetchPointsForSelectedModals();
      }
    }
  }

  /**
   * Method to set the options to the dropdown field of the model block on model block create event.
   * @param {any} targetBlock - The target model block in the workspace.
   * 
   * * This method sets the options to the dropdown field of the model block based on the value in the selected model id.
   * * If the selectedModelId field doesn't have any value, it sets the default value to the dropdown and clears the selectedModelId field. 
   * * If the selectedModelId field has a value and it is not available in the modelOptions array, it sets the default value to the dropdown and clears the selectedModelId field value.
  */

  setModelBlockDropdownOptions(targetBlock: any) {
    const existingSelectedModelId = targetBlock.getFieldValue('selectedModelId'); // Existing selected model Id stored in block
    const modelVersion = targetBlock.getFieldValue('modelVersion'); // Existing model version stored in block


    // Fetching the selected model config from the modelOptions array.
    const selectedModelConfig = this.modelOptions.find(option =>
      option.modelId.includes(existingSelectedModelId) &&
      option.modelVersion === modelVersion
    );

    const targetOption = { "label": "select modal", "value": "DEFAULT_MODAL" }; // Default option to show in the dropdown.
    // If the model block has a value in the selected model id field,
    if (existingSelectedModelId) {
      // If selected model id is available in the modelOptions array,
      if (selectedModelConfig) {
        targetOption.label = this.commonService.getModelNameWithVersion(selectedModelConfig);
        targetOption.value = selectedModelConfig.modelId;
        this.commonService.setDropdownOptionsForBlock(targetBlock, this.blocklyWorkSpace, BlockFieldName.SELECTED_MODEL, [targetOption], true);
        targetBlock.setFieldValue(selectedModelConfig.modelId, BlockFieldName.SELECTED_MODEL);
        targetBlock.setFieldValue(selectedModelConfig.modelId, 'selectedModelId');
        targetBlock.setFieldValue(selectedModelConfig.modelVersion, 'modelVersion');
        targetBlock.getField('selectedModelId').setVisible(false);
        targetBlock.getField('modelVersion').setVisible(false);
        targetBlock['isReferencingMetadata'] = true; // Flag to indicate that the model block is referencing the metadata.
      } else {
        // when the model block has a selected model id, and the model is not available in the modelOptions array, 
        // Setting the default value to the dropdown and clear the selectedModelId in the selectedModelId field, 
        targetBlock.setFieldValue('', 'selectedModelId');
        targetBlock.setFieldValue('', 'modelVersion');
        targetBlock.getField('selectedModelId').setVisible(false);
        targetBlock.getField('modelVersion').setVisible(false);
        this.blocklyWorkSpace.render();
      }
    }
  }

  /**
   * Method to handle the delete event when a model block is deleted from the workspace.
   * This method includes the logic to ensure the point blocks should exist for all the selected models workspace.
   */

  syncPointBlocksWithSelectedModels() {
    // remove _<portNumber>
    const removePort = (lbl: string): string => lbl.replace(/_\d+$/, '');

    // Remove suffixes
    const removeSuffix = (str: string): string => str.replace(/_\d+$/, '');

    // Base key that ignores any suffix we might already have
    const baseKey = (pt: any): string => `${pt.modalId}::${pt.modelVersion ?? ''}::${pt.name}`;

    // Get all model blocks in the workspace
    const modelBlocks = this.blocklyWorkSpace.getAllBlocks(true).filter((blockObj: any) => blockObj.type === BlockType.MODEL_BLOCK);

    // If no model blocks are present
    if (modelBlocks.length === 0) {
      this.createdPointsCollection = [];
      this.handleNoModelBlocksOnWorkspace();
      return;
    }

    // build a copy of every point
    const copyPoint: Record<string, any> = {};

    this.createdPointsCollection.forEach(pointObj => {
      const key = baseKey(pointObj);
      if (!copyPoint[key]) {
        // Removing port and previous suffixes
        const rawPointObj = { ...pointObj };
        delete rawPointObj.port;
        rawPointObj.label = removeSuffix(removePort(rawPointObj.label));
        rawPointObj.type = removeSuffix(rawPointObj.type);
        copyPoint[key] = rawPointObj;
      }
    });

    // index by modelId::version 
    const pointsByModelKey: Record<string, any[]> = {};
    Object.values(copyPoint).forEach((point: any) => {
      const key = `${point.modalId}::${point.modelVersion}`;
      (pointsByModelKey[key] ??= []).push(point);
    });

    const modelUsageCount: Record<string, number> = {};
    const pointsToCreate: any[] = [];

    modelBlocks.forEach((block: any) => {
      const modelId = block.getFieldValue(BlockFieldName.SELECTED_MODEL);
      const metaRef = block['isReferencingMetadata'] === true;

      let version: string | null = block.getFieldValue('modelVersion') ?? null;
      if (!version) {
        version = metaRef
          ? this.modelOptions.find(o => o.modelId === modelId)?.modelVersion
          : this.allModelsCollection?.find((m: any) => m.value === modelId)?.version;
      }

      const pts = pointsByModelKey[`${modelId}::${version}`] ?? [];

      const originalModelId = modelId.split('_')[0];
      const idx = modelUsageCount[originalModelId] ?? 0;
      modelUsageCount[originalModelId] = idx + 1;

      pts.forEach((base: any) => {
        const copy = { ...base };
        if (idx > 0) {
          copy.label = `${copy.label}_${idx}`;
          copy.type = `${copy.type}_${idx}`;
          copy.modalId = `${copy.modalId}_${idx}`;
        }
        pointsToCreate.push(copy);
      });
    });

    // assign ports, refresh workspace / toolbox
    this.createdPointsCollection = this.assignPortsToModelPoints(pointsToCreate);

    this.toggleSetterBlockFromToolbox('create');
    this.triggerInitializeSetterBlock();
    this.createDynamicBlocks(this.createdPointsCollection);
    this.updateModelPointBlocksInWorkspace();
    this.formatCategoryNames();
  }

  /**
   * Method to delete the point blocks from the toolbox and the workspace when no model blocks with selected model options exists in workspace.
   */
  handleNoModelBlocksOnWorkspace() {
    const targetCategory = this.categoryMenu.selectedCategory.id === Category.DEVICE ? CustomCategory.MODEL_POINTS : '';
    const toolBox = JSON.parse(JSON.stringify(this.toolBox));
    const targetCategoryIndex = toolBox.contents.findIndex((category: any) => category.name === targetCategory);

    // Set only default blocks in the toolbox.
    const defaultBlocks = this.toolBox.contents[targetCategoryIndex].contents.filter(
      (blockObj: any) => blockObj.type.includes(BlockType.MODEL_BLOCK)
    );
    this.toolBox.contents[targetCategoryIndex].contents = [...defaultBlocks];

    this.createdPointsCollection = []; // clear createdPoints Collection

    // Remove setter blocks in workspace
    const setterBlocksInWorkspace = this.blocklyWorkSpace.getAllBlocks(true).filter(
      (blockObj: any) => blockObj.type === BlockType.POINT_SETTER
    );
    setterBlocksInWorkspace.forEach((setterBlock: any) => this.disposeBlockWithoutDeletingChildBlocks(setterBlock));
    this.setterBlocksToinitialize = [];

    // Remove setter blocks in the toolbox
    this.toggleSetterBlockFromToolbox('delete');

    // Update or refresh the toolbox with updated blocks
    this.blocklyWorkSpace.updateToolbox(this.toolBox);
    this.formatCategoryNames();

    // Remove model point blocks from the workspace
    const modelPointBlocksInWorkspace = this.blocklyWorkSpace.getAllBlocks(true).filter(
      (blockObj: any) => blockObj.type.includes(BlockType.MODEL_POINT)
    );
    modelPointBlocksInWorkspace.forEach((blockObj: any) => blockObj.dispose());
  }

  /**
   * Method to update the model point blocks in the workspace with the latest point names.
   * 1. Renames the model point blocks with the assigned port on re-ordering the model blocks in the workspace.
   * 2. Deletes the model point blocks from the workspace when the corresponding model block is deleted.
  */
  updateModelPointBlocksInWorkspace() {
    const pointModelBlocksInWorkspace = this.blocklyWorkSpace.getAllBlocks(true).filter((blockObj: any) => blockObj.type.includes(BlockType.MODEL_POINT));
    pointModelBlocksInWorkspace.forEach((blockObj: any) => {
      const blockType = blockObj.type;
      const isModelExists = this.createdPointsCollection.some((pointObj: any) => pointObj.type === blockType);
      if (isModelExists) {
        const targetPoint = this.createdPointsCollection.find((pointObj: any) => pointObj.type === blockType);
        blockObj.setFieldValue(targetPoint.label, 'pointName');
      } else {
        blockObj.dispose();
      }
    });
  }


  /**
   * Method to handle the seperate the suffixes from the modal points data for the selected models in the workspace.
   * @param {Record<string, any[]>} allModelsWithPoints - The model points data for the selected models in the workspace.
   */
  separateSuffixData(allModelsWithPoints: Record<string, any[]>): Record<string, any[]> {
    const formattedModels: Record<string, any[]> = {};

    Object.keys(allModelsWithPoints).forEach(modalId => {
      const baseModalId = modalId.replace(/_suffix/g, "");

      // First storing the base points
      const basePoints = allModelsWithPoints[modalId].filter(point => !point.type.match(/_\d+$/));

      // Adding base points in the formatted object
      if (!formattedModels[baseModalId]) {
        formattedModels[baseModalId] = [...basePoints];
      }

      // Building suffixes points (_1, _2, _3, ...)
      const suffixedGroups: Record<string, any[]> = {};

      allModelsWithPoints[modalId].forEach(point => {
        const suffixMatch = point.type.match(/_(\d+)$/); // identify the suffix value from point.type `_1`, `_2`, etc.
        if (suffixMatch) {
          const suffixNumber = suffixMatch[1];
          const suffixedKey = `${baseModalId}_${suffixNumber}`;

          if (!suffixedGroups[suffixedKey]) {
            suffixedGroups[suffixedKey] = [];
          }
          suffixedGroups[suffixedKey].push(point);
        }
      });

      // Store suffixed model points in formattedModels
      Object.keys(suffixedGroups).forEach(suffixedKey => {
        formattedModels[suffixedKey] = suffixedGroups[suffixedKey];
      });
    });

    return formattedModels;
  }



  /**
  * Method to fetch the points for the selected model (selected option) from the model block in workspace.
  */
  fetchPointsForSelectedModals() {
    const modelBlocks = this.blocklyWorkSpace.getAllBlocks(true)
      .filter((blockObj: any) => blockObj.type === BlockType.MODEL_BLOCK);

    const formatPoints = (sourceModels: any[]) => {
      const uniqueKeys = new Set();

      const uniqueModels = sourceModels.filter((model) => {
        const key = `${model.id}::${model.version}`;
        if (uniqueKeys.has(key)) return false;
        uniqueKeys.add(key);
        return true;
      });

      const rawPoints = uniqueModels.flatMap((model: any) => {
        const points = model.points || [];
        return points.map((point: any) => ({
          modalName: model.name,
          modalId: model.id,
          modelVersion: model.version ?? null,
          name: point.name,
          id: point.pointId,
          domain: point.domainName,
          label: `${model.name}_${point.name}`,
          type: `${BlockType.MODEL_POINT}_${point.domainName}`,
          defaultValue: point.defaultValue ?? null
        }));
      });

      return rawPoints.map((point: any, index: number, fullArray: any[]) => {
        const uniqueDomain = this.createUniqueValueForKey(point.domain, 'domain', fullArray.slice(0, index), '#');
        point.domain = uniqueDomain;
        point.type = `${BlockType.MODEL_POINT}_${uniqueDomain}`;
        return point;
      });
    };

    const processPoints = (formattedResponse: any[]) => {
      const pointBlocksToCreate: any[] = [];

      // group points by modelId::version
      const pointsByModelKey: Record<string, any[]> = {};
      formattedResponse.forEach(pt => {
        const key = `${pt.modalId}::${pt.modelVersion}`;
        (pointsByModelKey[key] ??= []).push(pt);
      });

      // keep track of how many times we have already seen a modelId 
      const modelUsageCount: Record<string, number> = {};

      modelBlocks.forEach((blockObj: any) => {
        const selectedModelId = blockObj.getFieldValue(BlockFieldName.SELECTED_MODEL);
        const isReferencingMetadata = blockObj['isReferencingMetadata'] === true;

        // Assigning the version for model if blockObj has modelVersion field value
        let version: string | null = blockObj.getFieldValue('modelVersion') ?? null;
        if (!version) {
          // if no version is set, use the modelOptions or allModelsCollection to find it
          version = isReferencingMetadata
            ? this.modelOptions.find(opt => opt.modelId === selectedModelId)?.modelVersion
            : this.allModelsCollection?.find((m: any) => m.value === selectedModelId)?.version;
        }

        // Get all points for exactly that modelId + version
        const modelVersionKey = `${selectedModelId}::${version}`;
        const modelPoints = pointsByModelKey[modelVersionKey] ?? [];
        const originalModelId = selectedModelId.split('_')[0]; // Remove any suffix from modelId

        const usageIndex = modelUsageCount[originalModelId] ?? 0;
        modelUsageCount[originalModelId] = usageIndex + 1;

        modelPoints.forEach(raw => {
          const pt = { ...raw };

          // Add version if it's missing 
          if (!pt.modelVersion && version) {
            pt.modelVersion = version;
          }

          if (usageIndex > 0) {
            // Add suffix to label and type 
            pt.label = `${pt.label}_${usageIndex}`;
            pt.type = `${pt.type}_${usageIndex}`;
            pt.modalId = `${pt.modalId}_${usageIndex}`;
            pt.defaultValue = pt.defaultValue ?? null;
          }

          pointBlocksToCreate.push(pt);
        });
      });

      // assign ports & create dynamic blocks
      this.createdPointsCollection = this.assignPortsToModelPoints(pointBlocksToCreate);
      this.toggleSetterBlockFromToolbox('create');
      this.triggerInitializeSetterBlock();
      this.createDynamicBlocks(this.createdPointsCollection);
      this.updateModelPointBlocksInWorkspace();
      this.formatCategoryNames();
    };

    // Split blocks by metadata reference
    const blocksUsingModelOptions = modelBlocks.filter((block: any) => block['isReferencingMetadata'] === true);
    const blocksUsingAPI = modelBlocks.filter((block: any) => !(block['isReferencingMetadata']));

    const idsForAPI = blocksUsingAPI.map((block: any) =>
      block.getFieldValue(BlockFieldName.SELECTED_MODEL)
    );

    const sourceModels: any[] = [];

    // ModelOptions-based data
    blocksUsingModelOptions.forEach((block: any) => {
      const selectedModelId = block.getFieldValue(BlockFieldName.SELECTED_MODEL);
      const modelFromOptions = this.modelOptions.find((option: any) => option.modelId === selectedModelId);
      if (modelFromOptions) {
        sourceModels.push({
          name: modelFromOptions.modelName,
          id: modelFromOptions.modelId,
          version: modelFromOptions.modelVersion,
          points: (modelFromOptions.points || []).map((pt: any) => ({
            pointId: pt.pointId,
            name: pt.pointName,
            domainName: pt.domainName ?? pt.pointName,
            defaultValue: pt.defaultValue ?? null
          }))
        });
      }
    });

    if (idsForAPI.length === 0) {
      const formattedResponse = formatPoints(sourceModels);
      processPoints(formattedResponse);
      return;
    }

    // API-based data
    this.isLoading = true;
    this.siteSequencerService.getModelPoints(idsForAPI).subscribe(
      (res: any) => {
        if (res && res.length > 0) {
          const apiSourceModels = res.map((model: any) => {
            const versionFromCollection = this.allModelsCollection?.find((m: any) => m.value === model.id)?.version;
            return {
              name: model.name,
              id: model.id,
              version: versionFromCollection ?? null,
              points: model.points ?? []
            };
          });
          sourceModels.push(...apiSourceModels);
        }

        const formattedResponse = formatPoints(sourceModels);

        processPoints(formattedResponse);
        this.validateBlocklyLogic();
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
        this.showToast('error', err.message || 'Failed to fetch the points for the model');
      }
    );
  }


  /**
   * Method to trigger the setter block initialization when the points are created.
   */
  triggerInitializeSetterBlock() {
    if (this.setterBlocksToinitialize.length > 0) {
      this.setterBlocksToinitialize.forEach((setterBlock: any, index: number) => {
        const setterBlockInWorkspace = this.blocklyWorkSpace.getBlockById(setterBlock.id);
        if (!setterBlockInWorkspace) {
          return;
        }
        if (this.createdPointsCollection.some((pointObj: any) => pointObj.type === setterBlock.selected_point_ref)) {

          setterBlockInWorkspace.setFieldValue(setterBlock.selected_point_ref, BlockFieldName.SELECTED_POINT_NAME);
          setterBlockInWorkspace.getField('selected_point_ref').setVisible(false);
        } else {

          if (this.createdPointsCollection.length > 0) {
            setterBlockInWorkspace.setFieldValue('DEFAULT_MODAL', BlockFieldName.SELECTED_POINT_NAME);
            setterBlockInWorkspace.getField('selected_point_ref').setVisible(false);
          } else {
            this.disposeBlockWithoutDeletingChildBlocks(setterBlockInWorkspace);
          }
        }

        this.setterBlocksToinitialize.splice(index, 1);
      });
    }
  }

  assignPortsToModelPoints(modelPoints: any) {
    return this.blocklyWorkspaceBuilderService.assignPortsToModelPointsByWorkspaceOrder(
      this.blocklyWorkSpace,
      modelPoints
    );
  }

  /**
   * Method to create variables. 
   * @param blockConfigArray - The variable configuration object to create variables.
   * blockConfigArray = { "name": 'abc', 
   *                    "id": '123', 
   *                    "label": `${pointObj.modalName} ${pointObj.name} ${pointObj.port}`,
                        "type": `model_point_${pointObj.id}`
                      }
  */
  createDynamicBlocks(blockConfigArray: any) {
    const blocksToInjectInToolbox: any[] = [];
    blockConfigArray.forEach((blockConfig: any) => {
      const blockToolBoxConfig = {
        "kind": "block",
        "type": blockConfig.type,
        "enabled": true,
        "name": blockConfig.label,
        "defaultValue": blockConfig.defaultValue ?? null
      }
      blocksToInjectInToolbox.push(blockToolBoxConfig);
      dynamicDeviceModelBlockBuilder.modelPointBlockInit(blockConfig);
    });

    // Injecting the created blocks to the category in toolbox.
    const targetCategory = this.categoryMenu.selectedCategory.id === Category.DEVICE ? CustomCategory.MODEL_POINTS : '';
    const toolBox = JSON.parse(JSON.stringify(this.toolBox));
    const targetCategoryIndex = toolBox.contents.findIndex((category: any) => category.name === targetCategory);
    // Apending the created blocks array to the category in the toolbox.
    const defaultBlocks = this.toolBox.contents[targetCategoryIndex].contents.filter((blockObj: any) => blockObj.type.includes(BlockType.MODEL_BLOCK) || blockObj.type === BlockType.POINT_SETTER);
    this.toolBox.contents[targetCategoryIndex].contents = [
      ...defaultBlocks,
      ...blocksToInjectInToolbox
    ];

    this.blocklyWorkSpace.updateToolbox(this.toolBox);

    if (this.pointBlocksToInitialize.length > 0) {
      return
    }

    // Update the options of setter blocks in the workspace.
    this.updateSetterBlockOptions();
    this.deleteInvalidPointBlocksInWorkspace();
    this.formatCategoryNames();
  }

  /**
   * Method to update the setter block options of all Setter block (using the selectedPointRef value saved in selected_point_ref field in setter blocks) in the workspace.
   */
  updateSetterBlockOptions() {
    const setterBlocksArray = this.blocklyWorkSpace.getAllBlocks(true).filter((blockObj: any) => blockObj.type === BlockType.POINT_SETTER);
    const selectedModelsInWorkspace = this.blocklyWorkSpace.getAllBlocks(true).filter((blockObj: any) => blockObj.type === BlockType.MODEL_BLOCK)
      .map((filteredObj: any) => filteredObj.getFieldValue('selected_model'));
    setterBlocksArray.forEach((setterBlock: any) => {
      const selectedPointRef = setterBlock.getFieldValue('selected_point_ref');
      const setter_model_value = setterBlock.getFieldValue('setter_model_value');
      const option = {
        "label": "select point",
        "value": "DEFAULT_MODAL",
      }
      if (setter_model_value) {
        const modelValueFound = selectedModelsInWorkspace.includes(setter_model_value);
        if (modelValueFound) {
          if (selectedPointRef) {
            const selectedPointConfig = this.createdPointsCollection.find((pointObj: any) => pointObj.type === setterBlock.getFieldValue('selected_point_ref'));
            if (selectedPointConfig) {
              option.label = selectedPointConfig.label;
              option.value = selectedPointConfig.type;
            }
          }
        } else {
          // If the model id stored in setter block is not found in the workspace.
          const modelBlocksWithSelectedModelInWorkspace = this.blocklyWorkSpace.getAllBlocks(true).filter((blockObj: any) => blockObj.type === BlockType.MODEL_BLOCK && blockObj.getFieldValue(BlockFieldName.SELECTED_MODEL) && blockObj.getFieldValue(BlockFieldName.SELECTED_MODEL) !== 'DEFAULT_MODAL');
          if (modelBlocksWithSelectedModelInWorkspace && modelBlocksWithSelectedModelInWorkspace.length > 0) {
            setterBlock.setFieldValue('', 'setter_model_value');
          } else {
            this.disposeBlockWithoutDeletingChildBlocks(setterBlock);
            this.setterBlocksToinitialize = [];
            return;
          }
        }
      }
      this.commonService.setDropdownOptionsForBlock(setterBlock, this.blocklyWorkSpace, BlockFieldName.SELECTED_POINT_NAME, [option], false);
      setterBlock.setFieldValue(option.value, BlockFieldName.SELECTED_POINT_NAME);
      setterBlock.setFieldValue(option.value, 'selected_point_ref');
      setterBlock.getField('selected_point_ref').setVisible(false);
      setterBlock.getField('setter_model_value').setVisible(false);
      this.blocklyWorkSpace.render();
    });
  }

  /**
   * Method to delete the invalid point blocks in the workspace.
   * Check if the point blocks on the workspace are created (in the model points category) in the toolbox, if the block is not created in the toolbox, delete it from the workspace.
   */
  deleteInvalidPointBlocksInWorkspace() {
    const validPointBlockTypes = this.createdPointsCollection.map((pointObj: any) => pointObj.type);
    const allPointBlocksInWorkspace = this.blocklyWorkSpace.getAllBlocks(true).filter((blockObj: any) => blockObj.type.includes('model_point'));
    allPointBlocksInWorkspace.forEach((blockObj: any) => {
      const isPointBlockValid = validPointBlockTypes.some((pointType: any) => blockObj.type === pointType);
      if (!isPointBlockValid) {
        blockObj.dispose();
      }
    });
  }

  /**
   * Method to handle the setter block creation and deletion in the toolbox.
   * @param {any} event - event object from blockly.
   * @param {any} targetBlock - The target block object.
   */
  toggleSetterBlockFromToolbox(event: string) {
    const targetCategory = this.categoryMenu.selectedCategory.id === Category.DEVICE ? CustomCategory.MODEL_POINTS : '';
    if (!this.toolBox?.contents?.length || !this.blocklyWorkSpace?.updateToolbox) {
      return;
    }

    const toolBox = JSON.parse(JSON.stringify(this.toolBox));
    const targetCategoryIndex = toolBox.contents.findIndex((category: any) => category.name === targetCategory);
    if (targetCategoryIndex < 0 || !toolBox.contents[targetCategoryIndex]?.contents) {
      return;
    }
    const isSetterBlockExists = toolBox.contents[targetCategoryIndex].contents.some((blockObj: any) => blockObj.type === BlockType.POINT_SETTER);
    if (event === 'create' && !isSetterBlockExists) {
      // Creating the setter block in the toolbox.
      const setterblockConfig = { 'kind': 'block', 'type': BlockType.POINT_SETTER }
      this.toolBox.contents[targetCategoryIndex].contents.push(setterblockConfig);
    } else if (event === 'delete' && isSetterBlockExists) {
      // Deleting the setter block from the toolbox.
      this.toolBox.contents[targetCategoryIndex].contents = this.toolBox.contents[targetCategoryIndex].contents.filter((blockObj: any) => blockObj.type !== BlockType.POINT_SETTER);
    }
    this.blocklyWorkSpace.updateToolbox(this.toolBox);

  }




  /**
   * Method to handle the setter block events when dragged on workspace from toolbox or populated from workspace Xml.
   * @param event - event object from blockly.
   */
  handleSetterBlockEvents(event: any) {
    const targetBlock = this.blocklyWorkSpace.getBlockById(event.blockId);
    const currentBlockType = event.type === 'create' ? event.json?.type : (event.type === 'delete' ? event.oldJson?.type : '');
    if ((targetBlock && targetBlock.type === BlockType.POINT_SETTER) || currentBlockType === BlockType.POINT_SETTER) {
      const isBlockInFlyout = event.type !== 'delete' ? targetBlock.isInFlyout : true; // Flag to check if the event is triggered when the block is in toolbox..
      if (event.type === 'create') {
        this.handleSetterBlockCreation(targetBlock);
      } else if (event.type === Blockly.Events.CHANGE && !isBlockInFlyout) {
        event.newValue ? this.handleSetterBlockDropdownChange(event, targetBlock) : '';
      }
    } else {
      // if(this.modelOptions && this.modelOptions.length > 0) {
      this.handleNestedSetterBlockEvents(event, targetBlock);
      // } else {
      //   this.handleNoModelBlocksOnWorkspace();
      // }
    }

  }

  /**
   * Method to delete the nested block with input connections or child blocks.
   * @param {any} block - The block to be deleted.
   * 
   * * This method is used to delete the block without deleting the child blocks or input connections.
   * * It unplugs the block from its parent and disconnects the child blocks before disposing of the block.
   */

  disposeBlockWithoutDeletingChildBlocks(block: any) {
    // Unplug the block from parent if connected
    block.unplug?.(true); // true = heal block tree (connect next block to parent if possible)

    // Disconnect children before disposing the target block
    block?.inputList?.forEach((input: any) => {
      const target = input.connection?.targetBlock();
      if (target) {
        target.unplug();
      }
    });

    // Disposing the target block
    block?.dispose?.(false); // false = do not heal connections (already done)
  }

  /**
   * Method to handle the create event for setter blocks
   * @param event - event object from blockly.
   * @param targetBlock - The target block object.
   * This method is triggered when the setter block is created in the workspace from xml.
   */
  handleNestedSetterBlockEvents(event: any, targetBlock: any) {
    if (event.type === 'create' && targetBlock) {
      if (targetBlock) {
        const childSetterBlocks = targetBlock.getDescendants('ordered').filter((blockObj: any) => blockObj.type === BlockType.POINT_SETTER);
        if (childSetterBlocks.length > 0) {
          childSetterBlocks.forEach((childBlock: any) => {
            if (!childBlock['isDropdownClickEventAdded']) {
              this.commonService.subcribeToScopeDropdownClick(childBlock, BlockFieldName.SELECTED_POINT_NAME, true);
              childBlock['isDropdownClickEventAdded'] = true;
            }
            childBlock.getField('selected_point_ref').setVisible(false);
            childBlock.getField('setter_model_value').setVisible(false);
          });
          this.blocklyWorkSpace.render();
        }
      }
    }
  }

  handleMqttSubscribeCreation(event: any, targetBlock: any) {
    if (!this.isUpdatingExistingMarker && !this.isLoadingAllSequences && !targetBlock['isCreated']) {
      const newSubscribeBlockConfig: any = {
        url: targetBlock.getFieldValue('url'),
        username: targetBlock.getFieldValue('username'),
        password: targetBlock.getFieldValue('password'),
        topic: targetBlock.getFieldValue('topic'),
        id: targetBlock.getFieldValue('id'),
      }
      // Saving the new sequence without passing sequence id in payload
      this.saveSequence(newSubscribeBlockConfig).subscribe((res: any) => {
        if (res && res['seqId']) {
          // Appending the obtained sequenceId to the new sequence.
          newSubscribeBlockConfig['id'] = res.seqId;
          const createdBlock = this.blocklyWorkSpace.getBlockById(event.blockId);
          // Adding the obtained id to the id field of the subscribe block.
          this.setAndHideFieldsinBlock(createdBlock.id, 'id', res.seqId);
          // Saving (updating) the new sequence after obtaining the sequence ID. 
          this.saveSequence(newSubscribeBlockConfig).subscribe((seqObj: any) => {
          }, (err: any) => {
            this.handleSequenceCreationError(targetBlock, 'sequence', err);
          });

          // Adding the new sequence to the sequence collection
          this.sequences.unshift(newSubscribeBlockConfig);
          this.sortBreadCrumbs();
        } else {
          this.handleSequenceCreationError(targetBlock, 'sequence');
        }
        this.isUpdatingExistingMarker = false;
      }, (err: any) => {
        this.handleSequenceCreationError(targetBlock, 'sequence', err);
        this.isUpdatingExistingMarker = false;
      });
    }
  }

  subscribeTodeliveryLogsButtonClick(targetBlock: any) {
    const deliveryLogsButton = targetBlock.getField('deliveryLogs');
    deliveryLogsButton.fieldGroup_.addEventListener('click', (event: any) => {
      this.isLoading = true;
      const seqId = targetBlock.getFieldValue('sequenceId');
      const sequenceScope = targetBlock.getFieldValue('scope');
      if (sequenceScope === scope.CUSTOM_SCOPE) {
        const sequenceObj = this.sequences.find((seqObj: any) => seqObj.seqId === seqId);
        if (sequenceObj.scope && sequenceObj.scope.length > 0 && sequenceObj.scope[0] !== null) {
          this.siteSequencerService.getSequenceDeliveryLogs(seqId)
            .subscribe((res: any) => {
              if (res && res.length > 0) {
                this.showDeliveryLogsDialog(res);
                this.isLoading = false;
              } else {
                this.showToast('error', `No logs found for this sequence.`);
                this.isLoading = false;
              }
            }, (err => {
              this.showToast('error', `${err.message}`);
              this.isLoading = false;
            }));
        } else {
          this.showToast('error', `Please click Save button before viewing the delivery logs.`);
          this.isLoading = false;
        }
      } else {
        this.showToast('error', `Please select scope to view the delivery logs.`);
        this.isLoading = false;
      }
    });
  }

  handleHaystackQueryBuilderBlockEvents(event: any) {
    if (!event || event.type !== Blockly.Events.BLOCK_CREATE) {
      return;
    }

    const blockIds = event.ids?.length ? event.ids : (event.blockId ? [event.blockId] : []);
    blockIds.forEach((blockId: string) => {
      const targetBlock = this.blocklyWorkSpace.getBlockById(blockId);
      if (targetBlock?.type === this.haystackQueryBuilderBlockType) {
        this.prepareHaystackQueryBuilderBlock(targetBlock);
      }
    });
  }

  prepareHaystackQueryBuilderBlock(targetBlock: any) {
    this.setHaystackQueryDisplayVisibility(targetBlock);
    this.subscribeToHaystackQueryBuilderButtonClick(targetBlock);
  }

  prepareHaystackQueryBuilderBlocks(blocks: any[] = []) {
    blocks.forEach((blockObj: any) => {
      if (blockObj?.type === this.haystackQueryBuilderBlockType) {
        this.prepareHaystackQueryBuilderBlock(blockObj);
      }
    });
  }

  subscribeToHaystackQueryBuilderButtonClick(targetBlock: any) {
    if (!targetBlock || targetBlock['isQueryBuilderButtonSubscribed']) {
      return;
    }

    const queryBuilderButton = targetBlock.getField('QUERY_BUILDER_BUTTON');
    if (queryBuilderButton?.fieldGroup_) {
      queryBuilderButton.fieldGroup_.style.cursor = 'pointer';
      const textElement = queryBuilderButton.fieldGroup_.querySelector?.('text');
      if (textElement) {
        textElement.style.fill = 'var(--primary)';
        textElement.style.fontWeight = '700';
        textElement.style.textDecoration = 'underline';
      }
    }
    queryBuilderButton?.fieldGroup_?.addEventListener('click', (event: any) => {
      event.stopPropagation();
      this.openHaystackQueryBuilderDialog(targetBlock);
    });
    targetBlock['isQueryBuilderButtonSubscribed'] = true;
  }

  setHaystackQueryDisplayVisibility(targetBlock: any) {
    const queryField = targetBlock?.getField?.('QUERY');
    const haystackQuery = this.getHaystackQueryFromBlock(targetBlock);

    queryField?.setValue?.(haystackQuery);
    queryField?.setVisible(!!haystackQuery);
    queryField?.setTooltip?.('');
    if (queryField?.fieldGroup_) {
      queryField.fieldGroup_.removeAttribute?.('title');
      queryField.fieldGroup_.style.cursor = 'default';
    }
    targetBlock?.setTooltip?.('');
    this.blocklyWorkSpace?.render?.();
  }

  getHaystackQueryFromBlock(targetBlock: any): string {
    return this.getHaystackQueryBuilderMetadata(targetBlock).haystackQuery || targetBlock?.getFieldValue?.('QUERY') || '';
  }

  closeHaystackQueryPreviewDialog() {
    this.selectedHaystackQueryPreview = '';
    this.dialog.closeAll();
  }

  getHaystackQueryBuilderMetadata(targetBlock: any): { builderType: string; selectedTags: string[]; haystackQuery: string; tagValuesMap: any; kVTags: any[] } {
    try {
      const metadata = targetBlock?.data ? JSON.parse(targetBlock.data) : {};
      return {
        builderType: metadata.builderType || 'BUILDER',
        selectedTags: Array.isArray(metadata.selectedTags) ? metadata.selectedTags : [],
        haystackQuery: metadata.haystackQuery || '',
        tagValuesMap: metadata.tagValuesMap || {},
        kVTags: Array.isArray(metadata.kVTags) ? metadata.kVTags : []
      };
    } catch {
      return {
        builderType: 'BUILDER',
        selectedTags: [],
        haystackQuery: '',
        tagValuesMap: {},
        kVTags: []
      };
    }
  }

  getHaystackQueryBuilderData(targetBlock: any): { builderType: string; selectedTags: string[]; haystackQuery: string; tagValuesMap: any; kVTags: any[] } {
    const metadata = this.getHaystackQueryBuilderMetadata(targetBlock);
    return {
      builderType: metadata.builderType || 'BUILDER',
      selectedTags: metadata.selectedTags || [],
      haystackQuery: metadata.haystackQuery || targetBlock?.getFieldValue?.('QUERY') || '',
      tagValuesMap: metadata.tagValuesMap || {},
      kVTags: metadata.kVTags || []
    };
  }

  async openHaystackQueryBuilderDialog(targetBlock: any) {
    const blockData = this.getHaystackQueryBuilderData(targetBlock);
    const dialogRef = this.dialog.open(AddPointModelComponent, {
      panelClass: 'popupModalConfig',
      width: '900px',
      // Do not block standard topmost-dialog Escape handling.
      disableClose: false,
      autoFocus: false,
      data: {
        siteId: this.selectedSiteId,
        siteName: this.selectedSite?.dis || '',
        builderType: blockData.builderType || 'builder',
        selectedTags: blockData.selectedTags || [],
        haystackQuery: blockData.haystackQuery || '',
        tagValuesMap: blockData.tagValuesMap || {},
        kVTags: blockData.kVTags || [],
        isEditMode: !!targetBlock?.data
      }
    });
    dialogRef.updatePosition({ top: '60px' });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.applyHaystackQueryBuilderResult(targetBlock, result);
      }
    });
  }

  applyHaystackQueryBuilderResult(targetBlock: any, result: any) {
    const builderType = result.builderType || 'builder';
    const selectedTags = Array.isArray(result.selectedTags) ? result.selectedTags : (Array.isArray(result.tags) ? result.tags : []);
    const haystackQuery = result.haystackQuery || result.hayStackQuery || '';
    const tagValuesMap = result.tagValuesMap || {};
    const kVTags = Array.isArray(result.kVTags) ? result.kVTags : [];

    targetBlock.data = JSON.stringify({ builderType, selectedTags, haystackQuery, tagValuesMap, kVTags });
    this.setHaystackQueryDisplayVisibility(targetBlock);
    targetBlock.render?.();
  }

  showDeliveryLogsDialog(deliveryLogs: any) {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      panelClass: ['fs-mat-dialog-container', 'full-height', 'sequence-logs-modal'],
      width: '752px',
      height: '311px',
      // Allow this log modal to close when it is the active overlay.
      disableClose: false
    });
    const headerColumns = ['status', 'ccuName', 'deliveredDateTime', 'ackedDateTime'];
    const headerColumnsToDisplay = headerColumns.filter(key => Object.keys(deliveryLogs[0]).includes(key));
    const htmlContent = {
      sequenceLogstableData: deliveryLogs,
      sequenceLogsHeaderColumns: headerColumnsToDisplay,
      selectedTimeZone: this.selectedSite.tz
    }
    dialogRef.componentInstance.htmlContent = htmlContent;
    dialogRef.componentInstance.type = 'delivery_logs';
    dialogRef.componentInstance.showHeader = false;
    dialogRef.componentInstance.isSearchFieldRequired = false;
    dialogRef.updatePosition({ top: '60px' });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  handleSequenceCreation(event: any, targetBlock: any) {
    if (!this.isUpdatingExistingMarker && !this.isLoadingAllSequences && !targetBlock['isCreated']) {
      const defaultSequenceName = this.generateRandomString();
      targetBlock.setFieldValue('', 'markername');
      const newSequence: any = {
        seqName: defaultSequenceName,
        blocklyXml: this.parseXMLForSequence(targetBlock),
        snippet: this.getJSCodeForSequence(targetBlock, defaultSequenceName),
        // frequency: targetBlock.getFieldValue('Occurance'),
        isEnabled: targetBlock.getFieldValue('RUN_STATUS') === SequenceStatus.ENABLE ? true : false,
      }

      if (targetBlock.type === BlockType.MQTT_SUBSCRIBE) {
        newSequence['brokerUrl'] = javascriptGenerator.valueToCode(targetBlock, 'brokerUrl', javascriptGenerator.ORDER_ATOMIC).replace(/^['"]|['"]$/g, '');
        newSequence['topic'] = javascriptGenerator.valueToCode(targetBlock, 'topic', javascriptGenerator.ORDER_ATOMIC).replace(/^['"]|['"]$/g, '');
        newSequence['username'] = javascriptGenerator.valueToCode(targetBlock, 'username', javascriptGenerator.ORDER_ATOMIC).replace(/^['"]|['"]$/g, '');
        newSequence['password'] = javascriptGenerator.valueToCode(targetBlock, 'password', javascriptGenerator.ORDER_ATOMIC).replace(/^['"]|['"]$/g, '');
      } else {
        newSequence['frequency'] = targetBlock.getFieldValue('Occurance');
      }

      this.categoryMenu.selectedCategory.id === Category.SYSTEM ? newSequence['scope'] = [null] : '';
      // Saving the new sequence without passing sequence id in payload
      this.saveSequence(newSequence).subscribe((sequenceObj: any) => {
        if (sequenceObj && sequenceObj['seqId']) {
          // Appending the obtained sequenceId to the new sequence.
          newSequence['seqId'] = sequenceObj.seqId;
          const createdBlock = this.blocklyWorkSpace.getBlockById(event.blockId);
          // Adding the obtained sequence id to the sequenceId field of the sequence block.
          if (this.categoryMenu.selectedCategory.id === Category.SYSTEM) {
            this.setAndHideFieldsinBlock(createdBlock.id, 'selectedScopeValue', [null]);
          }
          this.setAndHideFieldsinBlock(createdBlock.id, 'sequenceId', sequenceObj.seqId);
          newSequence['blocklyXml'] = this.parseXMLForSequence(createdBlock);
          newSequence['snippet'] = this.getJSCodeForSequence(createdBlock, newSequence.seqName);
          // Saving (updating) the new sequence after obtaining the sequence ID. 
          this.saveSequence(newSequence).subscribe((seqObj: any) => {
          }, (err: any) => {
            this.handleSequenceCreationError(targetBlock, 'sequence', err);
          });

          // Adding the new sequence to the sequence collection
          this.sequences.unshift(newSequence);
          this.sortBreadCrumbs();
        } else {
          this.handleSequenceCreationError(targetBlock, 'sequence');
        }
        this.isUpdatingExistingMarker = false;
      }, (err: any) => {
        this.handleSequenceCreationError(targetBlock, 'sequence', err);
        this.isUpdatingExistingMarker = false;
      });
    }
  }

  handleSequenceCreationError(targetSequenceBlock: any, BlockType: any, error?: any) {
    this.showToast('error', `${error && error.error ? error.error.error : BlockType + 'creation failed.'}`);
    const targetBlock = this.blocklyWorkSpace.getBlockById(targetSequenceBlock.id);
    targetBlock ? targetBlock.dispose() : '';
  }

  handleSequenceDeletion(event: any) {
    if (!this.isLoadingAllSequences) {
      const sequenceIdToDelete = event.oldJson?.fields?.sequenceId;
      const indexToDelete = this.sequences.findIndex((seqObj) => seqObj.seqId == sequenceIdToDelete);
      const breadcrumbIndexToDelete = this.breadcrumbs.findIndex((breadcrumbObj: any) => breadcrumbObj.seqId === event?.oldJson?.fields?.sequenceId);
      const seqTabToDelete = { 'seqId': sequenceIdToDelete };
      if (indexToDelete >= 0) {
        this.sequences.splice(indexToDelete, 1);
        this.breadcrumbs.splice(breadcrumbIndexToDelete, 1);
        if (this.categoryMenu.selectedCategory.id === Category.CLOUD) {
          this.toggleSequenceTab(seqTabToDelete, 'delete');
        }
      }
    }
  }

  handleSequenceInputFieldChange(event: any, targetBlock: any) {
    const blockType = targetBlock.type;
    const seqIdInBlock = targetBlock.getFieldValue('sequenceId');
    const index = this.sequences.findIndex((seqObj) => seqObj.seqId == seqIdInBlock);
    if (event.name == 'markername') {
      this.sequences[index].seqName = event.newValue;
      // Updating breadcrumb for renamed sequence.
      const breadcrumbIndex = this.breadcrumbs.findIndex((breadcrumb: any) => breadcrumb.seqId === seqIdInBlock);
      if (breadcrumbIndex >= 0) {
        this.breadcrumbs[breadcrumbIndex].seqName = event.newValue;
        if (this.categoryMenu.selectedCategory.id === Category.CLOUD) {
          this.toggleSequenceTab(targetBlock, 'rename');
        }
      }
    }
  }

  /**
   * Method to update the sequence collection when subscribe block's input field change.
   */
  updateSubscribeBlockFields() {
    const subscribeBlocksInWorkspace = this.blocklyWorkSpace.getAllBlocks(true).filter((blockObj: any) => blockObj.type === BlockType.MQTT_SUBSCRIBE);
    if (subscribeBlocksInWorkspace.length > 0) {
      subscribeBlocksInWorkspace.forEach((subscribeBlock: any) => {
        const index = this.sequences.findIndex((seqObj) => seqObj.seqId == subscribeBlock.getFieldValue('sequenceId'));
        if (index >= 0) {
          this.sequences[index].brokerUrl = javascriptGenerator.valueToCode(subscribeBlock, 'brokerUrl', javascriptGenerator.ORDER_ATOMIC).replace(/^['"]|['"]$/g, '');
          this.sequences[index].username = javascriptGenerator.valueToCode(subscribeBlock, 'username', javascriptGenerator.ORDER_ATOMIC).replace(/^['"]|['"]$/g, '');
          this.sequences[index].password = javascriptGenerator.valueToCode(subscribeBlock, 'password', javascriptGenerator.ORDER_ATOMIC).replace(/^['"]|['"]$/g, '');
          this.sequences[index].topic = javascriptGenerator.valueToCode(subscribeBlock, 'topic', javascriptGenerator.ORDER_ATOMIC).replace(/^['"]|['"]$/g, '');
        }
      })
    }
  }

  handleSequenceDropdownChange(event: any, targetBlock: any) {
    if (event.name === 'Occurance') {
      const seqIdInBlock = targetBlock.getFieldValue('sequenceId');
      const index = this.sequences.findIndex((seqObj) => seqObj.seqId == seqIdInBlock);
      this.sequences[index].frequency = event.newValue;
    } else if (event.name === 'RUN_STATUS') {
      const previousValue = event.oldValue;
      const seqIdInBlock = targetBlock.getFieldValue('sequenceId');
      const index = this.sequences.findIndex((seqObj) => seqObj.seqId == seqIdInBlock);
      const selectedRunStatus = targetBlock.getFieldValue('RUN_STATUS');
      const isEnabled = selectedRunStatus == SequenceStatus.ENABLE ? true : false;
      this.sequences[index].isEnabled = isEnabled;
      if (this.categoryMenu.selectedCategory.id === Category.CLOUD) {
        const seqTabEventType = targetBlock.getFieldValue('RUN_STATUS') === SequenceStatus.ENABLE_WITH_LOGS ||
          targetBlock.getFieldValue('RUN_STATUS') === SequenceStatus.DISABLE_WITH_LOGS ? 'create' : '';
        this.toggleSequenceTab(targetBlock, seqTabEventType);
      }
      this.sortBreadCrumbs();
      if (selectedRunStatus === SequenceStatus.DRY_RUN) {
        this.previousRunStatus = previousValue;
        this.activateDryRun(targetBlock);
      }
    }
  }

  toggleSequenceTab(targetBlockObj: any, eventType: string) {
    if (eventType === 'create') {
      const sequenceTab = {
        'seqName': targetBlockObj.getFieldValue('markername'),
        'seqId': targetBlockObj.getFieldValue('sequenceId'),
        'status': targetBlockObj.getFieldValue('RUN_STATUS'),
        'isMqttSubscribe': targetBlockObj.type === BlockType.MQTT_SUBSCRIBE ? true : false
      };
      const sequenceIndexInTabs = this.sequenceTabs.findIndex((sequenceObj) => sequenceObj.seqId === sequenceTab.seqId);
      sequenceIndexInTabs < 0 ? this.sequenceTabs.push(sequenceTab) : '';

    } else if (eventType === 'delete') {
      const targetSequenceId = targetBlockObj.seqId ? targetBlockObj.seqId : targetBlockObj.getFieldValue('sequenceId');
      const sequenceIndexInTabs = this.sequenceTabs.findIndex((sequenceObj) => sequenceObj.seqId === targetSequenceId);
      sequenceIndexInTabs >= 0 ? this.sequenceTabs.splice(sequenceIndexInTabs, 1) : '';

    } else if (eventType === 'rename') {
      const targetSequenceId = targetBlockObj.getFieldValue('sequenceId');
      const updatedSequenceName = targetBlockObj.getFieldValue('markername');
      const sequenceIndexInTabs = this.sequenceTabs.findIndex((sequenceObj) => sequenceObj.seqId === targetSequenceId);
      sequenceIndexInTabs >= 0 ? this.sequenceTabs[sequenceIndexInTabs].seqName = updatedSequenceName : '';
    }

    this.tempSequenceTab = this.sequenceTabs;
  }

  /**
   * Switches to the selected tab.
   * 
   * @param selectedTabData - The data of the selected tab.
   */
  switchToSelectedTab(selectedTabData: any) {
    // Skipping the canvas or logs tab switching functionality in library builder mode.
    if (this.builderMode === BuilderMode.LIBRARY_BUILDER) {
      return;
    }

    this.searchText = '';
    this.isSearchActive = false;
    this.canvasTabs.tabs = this.tempCanvasTabs;

    // Resetting the Sequence tab data when switching to canvas tab.
    this.isSequenceTabSelected = false;
    this.resetSequenceLogs();
    this.switchToSelectedCanvasTab(selectedTabData);
    this.canvasTabToSwitch = null;
  }

  resetModelPointsCategory() {
    const targetCategoryIndex = this.toolBox.contents.findIndex((category: any) => category.name === CustomCategory.MODEL_POINTS);
    if (targetCategoryIndex >= 0) {
      this.toolBox.contents[targetCategoryIndex].contents = [];
      this.blocklyWorkSpace.updateToolbox(this.toolBox);
      this.formatCategoryNames();
    }
    this.allModelsWithPoints = null;
    this.createdPointsCollection = [];
    this.deviceRunBlocksOnWorkspace = [];
  }

  searchTabs(event: any) {
    const searchText = event.target.value;
    let searchedTabs = [];
    if (searchText) {
      const allTabs = [...this.canvasTabs.tabs, ...this.sequenceTabs];
      searchedTabs = allTabs.filter((tab: any) => {
        const tabName = tab.name ? tab.name : tab.seqName;
        return tabName.toLowerCase().includes(searchText.toLowerCase());
      });
    }
  }

  /**
   * Creating new canvas tab upon clicking add canvas button and when fetching and creating a new workspace for the selected category level.  
   * @param {boolean} initWorkspace - The flag to initialize the workspace if true and to clear and update same workspace when false.
   * 1. Creating a new workspace by calling saveWorkspace API (without workspaceId). 
   * 2. Updating the workspace by calling the saveWorkspace API with the obtained workspaceId.  
  */
  createNewCanvasTab(initWorkspace?: boolean) {
    if (!initWorkspace && this.blocklyWorkSpace) {
      const allBlocks = this.blocklyWorkSpace.getAllBlocks();
      if ((allBlocks.length > 0 && !this.noChangesInWorkspace) && !this.checkAndReturnErrorStatus()) {
        // Blocking creation of a new tab when the current workspace has validation errors.
        return;
      }
    }

    this.isLoading = true;
    this.searchText = '';
    this.isSearchActive = false;
    this.canvasTabs.tabs = JSON.parse(JSON.stringify(this.tempCanvasTabs));

    this.isCreateCanvasLoading = true
    this.categoryMenu.selectedCategory.id === Category.DEVICE ? this.isCreatingNewDeviceCanvas = true : '';   // Making the flag true when creating a new device canvas tab for populating the default blocks.

    // if no workspaces are available for the selected category level.
    // Create a new canvas tab for the selected category level.
    const selectedCategoryLevel = this.categoryMenu.selectedCategory.id;
    if (initWorkspace) {
      this.canvasTabs.tabs = [];
      this.canvasTabs.selectedCanvasTab = null;
    }
    const defaultCanvasTabName = (DefaultCategoryTabName as any)[selectedCategoryLevel];
    const canvasTabConfig: any = {
      "siteRef": this.selectedSiteId,
      "workspaceXml": '',
      "category": selectedCategoryLevel,
      "name": this.createUniqueValueForKey(defaultCanvasTabName, 'name', this.canvasTabs.tabs, ' '),
    }

    // Calling SaveWorkspace API without passing Id to register a new workspace for the selected category level.
    this.siteSequencerService.saveWorkspace(canvasTabConfig)
      .subscribe((res: any) => {
        if (res && res.id) {
          canvasTabConfig['id'] = res.id;
          // Updating the  workspace with the obtained id
          this.siteSequencerService.saveWorkspace(canvasTabConfig)
            .subscribe((res: any) => {
              if (res) {
                canvasTabConfig.workspaceXml = res.workspaceXml;
                canvasTabConfig['isCanvasNameEdit'] = false;
                canvasTabConfig['tempName'] = canvasTabConfig.name;
                canvasTabConfig['showMenu'] = false;
                this.canvasTabs.tabs.length > 0 ? this.canvasTabs.tabs.push(canvasTabConfig) : this.canvasTabs.tabs = [canvasTabConfig];
                this.tempCanvasTabs = JSON.parse(JSON.stringify(this.canvasTabs.tabs));
                this.canvasTabs.activeTabIndex = this.canvasTabs.tabs.length > 0 ? (this.canvasTabs.tabs.length - 1) : 0;
                this.activeTabIndex = this.canvasTabs.activeTabIndex;
                if (initWorkspace) {
                  this.canvasTabs.selectedCanvasTab = canvasTabConfig;
                }
                // Calling switchToSelectedCanvasTab() method to switch to the newly created canvas tab.
                this.switchToSelectedCanvasTab(canvasTabConfig, initWorkspace)
              }
              this.isCreateCanvasLoading = false;
            }, (error: any) => {
              this.isLoading = false;
              this.isCreateCanvasLoading = false;
              this.showToast('error', error?.error && error?.error?.error ? error?.error?.error : `Something went wrong, please try again.`);
            });
        }
      }, (err: any) => {
        this.isLoading = false;
        this.isCreateCanvasLoading = false;
        this.showToast('error', err?.error && err?.error?.error ? err?.error?.error : `Something went wrong, please try again.`);
      });

  }

  /**
   * Switching to selected canvas tab. 
   * @param selectedCanvasTabConfig {any} - The selected canvas tab configuration.
  */
  async switchToSelectedCanvasTab(selectedCanvasTabConfig: any, initWorkspace?: boolean, isDeletingWorkspace?: boolean) {
    this.isLoading = true;

    // This method can be called directly from logs view (create/switch workspace).
    // Ensure workspace container is rendered before Blockly initialization.
    if (this.isSequenceTabSelected) {
      this.isSequenceTabSelected = false;
      this.resetSequenceLogs();
    }

    const switchTab = (isDeletingWorkspace: boolean | undefined) => {
      this.canvasTabs.selectedCanvasTab = selectedCanvasTabConfig;
      this.canvasTabs.activeTabIndex = this.canvasTabs.tabs.findIndex((tab: any) => tab.name === selectedCanvasTabConfig.name);
      this.builderMode = BuilderMode.SEQUENCE_BUILDER; // Setting the builder mode
      this.previousMode = null;
      this.blocklyWorkSpace.clear();
      this.categoryMenu.selectedCategory.id === Category.DEVICE ? this.resetModelPointsCategory() : '';
      this.buildAndLoadSequencesFromXml(isDeletingWorkspace)
    };

    if (!initWorkspace && this.blocklyWorkSpace) {
      const allBlocks = this.blocklyWorkSpace.getAllBlocks(true);
      if (allBlocks.length === 0 && isDeletingWorkspace || this.noChangesInWorkspace) {
        // If the Blockly workspace is empty, switch the tab immediately
        switchTab(isDeletingWorkspace);
      } else {
        // If the Blockly workspace is not empty, check if blocks are valid
        if (!isDeletingWorkspace) {
          const isSequencesValid = this.checkAndReturnErrorStatus();
          if (isSequencesValid) {
            await this.saveSequenceOnTabChange();
            switchTab(isDeletingWorkspace);
          } else {
            // If blocks are not valid, fall back to the previous tab
            const previousCanvasTab = this.canvasTabs.selectedCanvasTab;
            const previousTabIndex = this.canvasTabs.tabs.findIndex((tab: any) => tab.name === previousCanvasTab?.name);
            this.activeTabIndex = previousTabIndex;
            this.isLoading = false;
          }
        }
      }

      if (this.categoryMenu.selectedCategory.id === Category.DEVICE) this.resetModelPointsCategory();
    } else {
      if (this.categoryMenu.selectedCategory.id === Category.DEVICE) this.resetModelPointsCategory();
      this.canvasTabs.selectedCanvasTab = selectedCanvasTabConfig;
      this.canvasTabs.activeTabIndex = this.canvasTabs.tabs.findIndex((tab: any) => tab.name === selectedCanvasTabConfig.name);
      this.initializeBlockly();
    }

  }


  /**
   * Retrieves the selected sequence tab and performs necessary actions based on the tab switch.
   * 
   * @param sequence - The selected sequence tab.
   */
  getSelectedSequenceTab(sequence: any) {
    // Skipping the canvas or logs tab switching functionality in library builder mode.
    if (this.builderMode === BuilderMode.LIBRARY_BUILDER) {
      return;
    }
    this.sequenceLogs = [];
    let isSequencesValid = false;
    const isSwitchingFromDefaultTab = !this.isSequenceTabSelected;
    if (isSwitchingFromDefaultTab) {
      isSequencesValid = this.checkAndReturnErrorStatus();
      if (isSequencesValid) {
        if (!this.noChangesInWorkspace) {
          this.saveWorkspaceXML();
          this.saveAllSequences(true);
        }
      } else {
        return;
      }
    }
    sequence ? this.sequenceTohighlight = JSON.parse(JSON.stringify(sequence)) : '';
    this.selectedSequenceTab = sequence;
    this.isSequenceTabSelected = true;
    this.resetSequenceLogs();

    if (!isSwitchingFromDefaultTab) {
      if (this.selectedSequenceTab) {
        // When switching between sequence tabs - get logs for selected sequence
        this.subscribeToSequenceLogs();
      } else {
        // when switching from a sequence tab to canvas tab - Re-render the workspace
        setTimeout(() => {
          this.previousMode = BuilderMode.LIBRARY_BUILDER;
          const categoryLevelTabConfig = { 'index': this.categoryMenu.activeTabIndex, 'tab': { "textLabel": this.categoryMenu.selectedCategory.name } };
          this.toggleCategoryLevelTab(categoryLevelTabConfig, true);
        }, 500);
      }
    } else {
      // when switching to sequence tab from canvas tab - save the sequences and clear the workspace
      if (isSequencesValid) {
        this.subscribeToSequenceLogs();
        this.toggleWorkspace('delete');
      }
    }
  }

  /**
   * Resetting the sequence logs data and unsubscribe the sequence logs response when switched to canvas tab from sequence logs tab. 
   */
  resetSequenceLogs() {
    this.sequenceLogs = [];
    this.sequenceLogstableData = [];
    this.sequenceLogsHeaderColumns = [];
    clearInterval(this.sequenceLogsSubscription);
    this.sequenceLogsSubscription = null;
  }

  subscribeToSequenceLogs(isDryRunSelected: boolean = false) {
    const logsRefreshTime = isDryRunSelected ? this.dryRunLogsRefreshTime : this.sequenceLogsRefreshTime;
    this.resetSequenceLogs();
    this.getSequenceLogs(this.selectedSequenceTab.seqId, isDryRunSelected, this.selectedSequenceTab.isMqttSubscribe);
    // Calling the sequence logs API for every minute (Refreshing the sequence logs);
    this.sequenceLogsSubscription = setInterval(() => {
      this.getSequenceLogs(this.selectedSequenceTab.seqId, isDryRunSelected, this.selectedSequenceTab.isMqttSubscribe);
    }, logsRefreshTime);
  }

  getSequenceLogs(sequenceId: any, isDryRunSelected: boolean, isMqttSubscribe: boolean) {
    const sequenceRunMode = isDryRunSelected ? 'DRY_RUN' : isMqttSubscribe ? 'EVENT_TRIGGERED_RUN' : 'SCHEDULED_RUN';
    this.siteSequencerService.getSequenceLogs(this.selectedSiteId, sequenceId, sequenceRunMode, this.lokiLogs)
      .subscribe((res: any) => {
        if (res && res.length > 0) {
          this.isLoadingAllSequences = false;
          this.sequenceLogs = res;
          // Replacing key name 'level' with 'type' 
          const logsData = res[0].logs.map((logObj: any) => {
            if ('level' in logObj) {
              const { level, ...rest } = logObj;
              return { type: level, ...rest };
            }
            return logObj;
          });
          this.sequenceLogs[0].logs = logsData;
          this.sequenceLogstableData = this.sequenceLogs[0].logs;
          this.sequenceLogsHeaderColumns = [...Object.keys(this.sequenceLogstableData[0])];
          this.isLoading = false;
        } else {
          this.isLoadingAllSequences = false;
          this.isLoading = false;
        }
        // Show dry run logs modal if dry run is selected and modal is not already opened
        if (isDryRunSelected && !this.isDryRunModalOpened) {
          const hasLogsData = res && Array.isArray(res) && res.length > 0;
          this.showDryRunLogs(!hasLogsData);
        }
      }, (err: any) => {
        this.isLoadingAllSequences = false;
        this.isLoading = false;
        this.showToast('error', `${err?.error && err?.error?.error ? err?.error?.error : 'Something went wrong, please try again.'}`);
      })
  }

  activateDryRun(sequenceBlock: any) {
    this.isLoading = true;
    const isDryRunSelected = true;
    const isSequencesValid = this.checkAndReturnErrorStatus();
    this.selectedSequenceTab = {
      'seqId': sequenceBlock.getFieldValue('sequenceId'),
      'blockId': sequenceBlock.id
    }
    // Fall back to previous selected Run status option of the sequence.
    const targetBlock = this.blocklyWorkSpace.getBlockById(this.selectedSequenceTab.blockId)
    targetBlock.setFieldValue(this.previousRunStatus, 'RUN_STATUS');

    if (isSequencesValid) {
      if (!this.noChangesInWorkspace) {
        this.saveAllSequences(false, isDryRunSelected);
      } else {
        this.triggerSequenceDryRun();
      }
    } else {
      this.isLoading = false;
    }
  }

  // Dry running the sequence and fetching the logs
  triggerSequenceDryRun() {
    this.isLoading = true;
    this.siteSequencerService.dryRunSequence(this.selectedSequenceTab.seqId)
      .subscribe((res) => {
        // If Loki logs are enabled, fetch logs for every 5 seconds else fetch once.
        if (this.lokiLogs) {
          this.subscribeToSequenceLogs(true);
        } else {
          this.getSequenceLogs(this.selectedSequenceTab.seqId, true, this.selectedSequenceTab.isMqttSubscribe);
        }
      }, (err: any) => {
        this.isLoading = false;
        this.showToast('error', `${err?.error && err?.error?.error ? err?.error?.error : 'Something went wrong, please try again.'}`);
      });
  }

  /**
   * Opens a dialog to show dry run logs.
   * 
   * @param isDataNotFound - Indicates whether the data is not found.
   */
  showDryRunLogs(isDataNotFound: boolean) {
    this.isDryRunModalOpened = true;
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      panelClass: ['fs-mat-dialog-container', 'full-height', 'sequence-logs-modal'],
      minWidth: '1000px',
      width: '100%',
      height: 'calc(100vh - 50px)',
      // Escape closes only the active dry-run log modal.
      disableClose: false
    });
    const htmlContent = {
      sequenceLogstableData: this.sequenceLogstableData,
      sequenceLogsHeaderColumns: this.sequenceLogsHeaderColumns,
      selectedTimeZone: this.selectedSite?.tz
    }
    dialogRef.componentInstance.htmlContent = htmlContent;
    dialogRef.componentInstance.type = 'sequence_logs';
    dialogRef.componentInstance.showHeader = false;
    dialogRef.componentInstance.isFixedHeight = isDataNotFound;
    dialogRef.updatePosition({ top: '60px' });
    dialogRef.afterClosed().subscribe(result => {
      this.selectedSequenceTab = null;
      this.sequenceLogstableData = [];
      this.sequenceLogsHeaderColumns = [];
      this.isDryRunModalOpened = false;

      // if (this.sequenceLogsSubscription) {
      //   clearInterval(this.sequenceLogsSubscription);
      //   this.sequenceLogsSubscription = null;
      // }
      this.resetSequenceLogs();
    });
  }

  openCCULogsModal() {
    const dialogRef = this.dialog.open(CcuLogsModalComponent, {
      panelClass: ['fs-mat-dialog-container', 'full-height', 'sequence-logs-modal', 'ccu-logs-modal'],
      width: '594px',
      // Let MatDialog close this topmost logs modal on Escape.
      disableClose: false,
      autoFocus: false
    });
    dialogRef.componentInstance.selectedSiteId = this.selectedSiteId;
    dialogRef.componentInstance.sequenceList = this.sequences;
    this.previousCCULogsRef ? dialogRef.componentInstance.previousCCULogsRef = this.previousCCULogsRef : {};
    dialogRef.updatePosition({ top: '120px' });
    dialogRef.afterClosed().subscribe(result => {
      const selectedRefs = result ? result : {};
      this.previousCCULogsRef = selectedRefs;
    });
  }

  setScopeLabelForSystemSequences(sequenceBlockObj: any) {
    this.isLoading = true;
    const selectedScopeValue = sequenceBlockObj.getFieldValue('selectedScopeValue');
    if (selectedScopeValue && selectedScopeValue.length > 0 && selectedScopeValue[0] !== null) {
      this.siteSequencerService.getCCUAndEquipDetailsForSite(this.selectedSiteId)
        .subscribe((res: any) => {
          const data = res.ccuDetailsList ? res.ccuDetailsList : [];
          if (data.length > 0) {
            data.forEach((item: any) => {
              item['formattedProfile'] = this.commonService.getFormattedProfileName(item.profile);
            });
          }
          const selectedScopeItems = data.filter((item: any) => selectedScopeValue.includes(item.ccuId));
          this.updateSelectedScopeInSequenceBlock(selectedScopeItems, sequenceBlockObj);
          this.isLoading = false;
        }, (err: any) => {
          this.isLoading = false;
        });
    } else {
      sequenceBlockObj.setFieldValue(scope.DEFAULT_SCOPE, 'scope');
      sequenceBlockObj.setFieldValue([null], 'selectedScopeValue');
      sequenceBlockObj.getField('selectedScopeValue').setVisible(false);
      this.blocklyWorkSpace.render();
      this.isLoading = false;
    }
  }

  showExternalOrPointsDialog(targetBlock: any, isPointModal: boolean) {
    let displayData = isPointModal ? this.createdPointsCollection : [];
    if (isPointModal) {
      displayData = displayData.map((dataObj: any) => ({ "value": dataObj.type, "label": dataObj.label }));
    }

    const selectedId = isPointModal ? targetBlock.getFieldValue('selected_point_ref') : targetBlock.getFieldValue('selectedModelId');
    const selectedName = isPointModal ? targetBlock.getField('selected_point_name').selectedOption[0]
      : targetBlock.getField('selected_model').selectedOption[0];
    const version = !isPointModal ? (selectedName?.match(/\(v\s([\d.]+)\)/)?.[1] ?? null) : null;
    const selectedData = { selectedId, selectedName, version };

    const dialogRef = this.dialog.open(ModalListDialogComponent, {
      panelClass: ['external-modal-modal'],
      maxWidth: '800px',     // limit max width on large screens
      height: 'auto',        // responsive height
      maxHeight: '400px',
      // Keep modal dismissal scoped to the topmost open dialog.
      disableClose: false,
      autoFocus: false,
      data: {
        isPointModal,
        displayData,
        selectedData,
      }
    });

    dialogRef.updatePosition({ top: '44px' });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        if (isPointModal) {
          this.updateSelectedPointInSetterBlock(result, targetBlock);
        } else {
          this.allModelsCollection = result.allModels && result.allModels.length > 0 ? result.allModels : [];
          this.updateSelectedModalInModalBlock(result.selectedModal, targetBlock);
        }
      }
    });
  }


  /**
  * Method to update the selected point option in the setter block after select point dialog is closed.
  * @param selectedPoint - The selected point object containing label and value.
  * @param targetBlock - The target block (Model block) to update the selected options.
  */

  updateSelectedPointInSetterBlock(selectedPoint: any, targetBlock: any) {
    const targetOptions = [{ label: selectedPoint.label, value: selectedPoint.value }];
    if (selectedPoint && selectedPoint.label) {
      this.commonService.setDropdownOptionsForBlock(targetBlock, this.blocklyWorkSpace, BlockFieldName.SELECTED_POINT_NAME, targetOptions, false);
      const setter_model_value = this.createdPointsCollection.find((pointObj: any) => pointObj.type === selectedPoint.value)
      targetBlock.setFieldValue(selectedPoint.value, 'selected_point_ref');
      targetBlock.setFieldValue(setter_model_value.modalId, 'setter_model_value');
      targetBlock.setFieldValue(selectedPoint.value, BlockFieldName.SELECTED_POINT_NAME);
    }
    this.noChangesInWorkspace = false;
  }


  /**
  * Method to update the selected modal option in the modal block.
  * @param selectedModal - The selected modal object containing label and value.
  * @param targetBlock - The target block (Model block) to update the selected options.
  */
  updateSelectedModalInModalBlock(selectedModal: any, targetBlock: any) {
    const previousSelectedModel = targetBlock.getFieldValue('selectedModelId');
    const targetOptions = [{ label: selectedModal.versionLabel ? `${selectedModal.label}${selectedModal.versionLabel}` : selectedModal.label, value: selectedModal.value }];
    if (selectedModal && selectedModal.value) {
      this.commonService.setDropdownOptionsForBlock(targetBlock, this.blocklyWorkSpace, BlockFieldName.SELECTED_MODEL, targetOptions, false);
      targetBlock.setFieldValue(selectedModal.value, 'selectedModelId');
      targetBlock.setFieldValue(selectedModal.value, BlockFieldName.SELECTED_MODEL);
      targetBlock.setFieldValue(selectedModal.version, 'modelVersion');
      targetBlock['isReferencingMetadata'] = false; // Resetting the isReferencingMetadata flag for referencing the points for selectedModel from API instead of referencing metadata.
      this.noChangesInWorkspace = false;
      // If the same model is selected again, manually trigger the model block dropdown change event for fetching the model points.
      if (previousSelectedModel === targetOptions[0].value) {
        const manualEventConfig = { newValue: selectedModal.value, name: BlockFieldName.SELECTED_MODEL };
        this.handleModelBlockDropdownChange(manualEventConfig, targetBlock);
        targetBlock['isReferencingMetadata'] = false; // Resetting the isReferencingMetadata flag for referencing the points for selectedModel from API instead of referencing metadata.
        this.noChangesInWorkspace = false;
      }
    }
  }

  showScopeSelectionDialog(targetBlock: any) {
    this.isLoading = true;
    this.siteSequencerService.getCCUAndEquipDetailsForSite(this.selectedSiteId)
      .subscribe((res: any) => {
        const data = res.ccuDetailsList ? res.ccuDetailsList : [];

        // adding selected property in ccuDetailsList array.
        const selectedScopeValue = targetBlock.getFieldValue('selectedScopeValue');
        if (data.length > 0) {
          data.forEach((item: any) => {
            item.selected = selectedScopeValue.includes(item.ccuId);
            item['formattedProfile'] = this.commonService.getFormattedProfileName(item.profile);
          });
        }
        const dialogRef = this.dialog.open(SequenceScopeSelectionModalComponent, {
          panelClass: ['fs-mat-dialog-container', 'full-height', 'scope-selection-modal'],
          minWidth: '318px',
          width: 'auto',
          disableClose: false,
          autoFocus: false
        });
        this.isLoading = false;
        dialogRef.componentInstance.scopeData = data;
        dialogRef.componentInstance.isFixedHeight = data.length > 0 ? false : true;
        dialogRef.updatePosition({ top: '60px' });
        dialogRef.afterClosed().subscribe(result => {
          this.updateSelectedScopeInSequenceBlock(result, targetBlock);
        });
      }, (err: any) => {
        this.isLoading = false;
      });
  }


  /**
   * Updates the selected scope in the sequence block.
   * @param {any} selectedScopeOptions - The selected scope options.
   * @param {any} targetBlock - The target block (system sequence block) to update the selected scope.
  **/

  updateSelectedScopeInSequenceBlock(selectedScopeOptions: any, targetBlock: any) {
    const options = targetBlock.getField("scope").getOptions();  // Getting scope dropdown options.
    let selectedOption!: any;
    let selectedScopes;

    if (selectedScopeOptions.length > 0) {
      let scopeLabel = selectedScopeOptions.length === 1 ? `${selectedScopeOptions[0].ccuName} - ${this.appendEllipse(selectedScopeOptions[0].formattedProfile)}` :
        (selectedScopeOptions.length > 1 ? `${selectedScopeOptions[0].ccuName} - ${this.appendEllipse(selectedScopeOptions[0].formattedProfile)} & +${(selectedScopeOptions.length - 1)}` : '');
      options[1] = [scopeLabel, scope.CUSTOM_SCOPE];
      selectedOption = scope.CUSTOM_SCOPE;
      selectedScopes = selectedScopeOptions.map((scopeObj: any) => scopeObj.ccuId);
    } else {
      options.splice(1, 1);
      selectedOption = scope.DEFAULT_SCOPE;
      selectedScopes = [];
    }

    targetBlock.setFieldValue(selectedOption, 'scope');
    const selectedScopeLabel = targetBlock.getFieldValue('scope');
    targetBlock.setFieldValue(selectedScopes, 'selectedScopeValue');
    targetBlock.getField('selectedScopeValue').setVisible(false);
    this.blocklyWorkSpace.render();
  }

  /**
   * Handles the query block connections.
   * 
   * @param event - The event object containing the blockId and reason.
   */
  handleQueryBlockConnections(event: any) {
    if (event.blockId) {
      const isConnectEvent = event && event.reason ? event.reason.find((reason: any) => reason == 'connect') : '';
      if (isConnectEvent) {
        const allBlocks = this.blocklyWorkSpace?.getAllBlocks();
        const queryWithConditionBlocks = allBlocks.filter((blockObj: any) => blockObj.type === 'haystack_query_with_condition');
        if (queryWithConditionBlocks.length) {
          queryWithConditionBlocks.forEach((blockObj: any) => {
            this.checkQueryConnectionType(blockObj);
          });
        }
      }
    }
  }

  /**
   * Checks the connection type of a query block.
   * @param block - The block to check the connection for.
   */
  checkQueryConnectionType(block: any) {
    const inputName = 'Query_condition';
    const validConnectionTypes = ['haystack_query_condition', 'haystack_logical_operator', 'haystack_not_operator'];
    const isInputExist = block.getInput(inputName);
    if (isInputExist) {
      const connectedBlock = block.getInput(inputName).connection.targetBlock();
      if (connectedBlock && validConnectionTypes.indexOf(connectedBlock.type) < 0) {
        connectedBlock.unplug();
        this.showToast('error', `Invalid connection for query block`);
      }
    }
  }

  /**
   * Validate and save the sequence.
   * 
   * @returns {void}
   */
  validateAndSaveSequence() {
    this.closeOnlyTextEditor();
    if (this.categoryMenu.selectedCategory.id == Category.DEVICE) {
      this.isLoading = true;
      this.syncPointBlocksWithSelectedModels();
      this.isLoading = false;
    }
    const isSequencesValid = this.checkAndReturnErrorStatus();
    if (this.builderMode === BuilderMode.SEQUENCE_BUILDER) {
      isSequencesValid ? this.saveAllSequences() : '';
    }
  }

  hasDeviceRunStartupBlock(): boolean {
    return this.blocklyWorkspaceBuilderService.hasDeviceRunStartupBlock(this.blocklyWorkSpace);
  }

  /**
   * Validates and saves the data.
   * 
   * @param showErrorDialog - Optional parameter to indicate whether to show an error dialog.
   * @returns True if the validation is successful, otherwise false.
   */
  checkAndReturnErrorStatus() {
    if (this.noChangesInWorkspace) {
      // Skipping the validation if there are no changes in the workspace.
      return true;
    } else {
      this.errorBlocks = [];
      this.alertHystersisValidationSummary = [];
      if (this.builderMode === BuilderMode.SEQUENCE_BUILDER && this.categoryMenu.selectedCategory.id === Category.DEVICE) {
        const hasRunStartupBlock = this.hasDeviceRunStartupBlock();
        if (!hasRunStartupBlock) {
          this.showToast('error', `Run on startup block is mandatory`);
          return false;
        }
      }
      const allBlocks = this.blocklyWorkSpace?.getAllBlocks();
      allBlocks?.forEach((blockObj: any) => {
        if (this.builderMode === BuilderMode.SEQUENCE_BUILDER) {
          this.categoryMenu.selectedCategory.id !== Category.DEVICE ? this.validateSequenceBlock(blockObj) : '';  // Skipping sequence blocks validation in device category.
        } else {
          this.validateSequencerBlock(blockObj);
        }
        this.validateInputField(blockObj);
      });
      if (this.errorBlocks.length > 0) {
        this.showToast('error', `Invalid block or sequence found. Please ensure all input fields are filled and the blocks are enclosed within the designated sequence`);
        // Highligting the error block
        this.sequenceTohighlight = { "id": this.errorBlocks[0] };
        this.getBlockIntoView(this.sequenceTohighlight, false);
        // Also showing the alert-hysteresis validation errors in a dialog,
        if (this.alertHystersisValidationSummary.length > 0) {
          this.showAlertValidationErrorsDialog();
        }
        return false;
      } else {
        return true;
      }
    }
  }

  /**
   * Displaying the alert-hysteresis block validation errors (alert name and its list of errors) in a popup.
   */
  showAlertValidationErrorsDialog() {
    const dialogRef = this.dialog.open(SequenceValidationPopupComponent, {
      panelClass: ['alert-validation-errors-modal'],
      backdropClass: 'alert-validation-dark-backdrop',
      autoFocus: false,
      minWidth: '480px',
      maxWidth: '490px',
      // Validation results can be dismissed with Escape when this is the active dialog.
      disableClose: false
    });
    dialogRef.componentInstance.title = 'Alert Validation Errors';
    dialogRef.componentInstance.htmlContent = this.alertHystersisValidationSummary;
    dialogRef.componentInstance.type = 'alertValidation';
    dialogRef.componentInstance.showConfirmIcon = true;
    dialogRef.afterClosed().subscribe(() => { });
  }

  /**
   * Validates the input fields of a subscribe block.
   * 
   * @param block - The block to validate.
   */

  validateMqttBlockFields(block: any) {
    let warningText = '';
    const inputFields = ['brokerUrl', 'username', 'password', 'topic', 'message'];
    const emptyInputFields = block.inputList.filter((fieldObject: any) => fieldObject.name && inputFields.includes(fieldObject.name) && fieldObject.connection?.targetBlock() === null);
    if (emptyInputFields.length > 0) {
      warningText = 'Input field cannot be empty';
    }
    return warningText;
  }


  /**
   * Validates a sequence block.
   * 
   * @param block - The block to validate.
   */
  validateSequenceBlock(block: any) {
    if (this.sequenceBlockType.includes(block.type)) {
      let warningText = '';
      const sequenceNameLength = 50;
      const sequenceName = block.getFieldValue('markername').toString();
      const forbidSplCharsAtStart = /^(?:[A-Za-z0-9]|$)+[A-Za-z0-9]*$/;
      const forbidSplCharsInString = /^(?:[A-Za-z0-9\s]+)(?:[A-Za-z0-9_\s#%]*)$/;
      const existingSequenceIndex = this.sequences.findIndex((seqObj: any) => seqObj.seqName === sequenceName && seqObj.seqId !== block.getFieldValue('sequenceId'));
      if (sequenceName) {
        if (existingSequenceIndex < 0) {
          if (forbidSplCharsAtStart.test(sequenceName[0])) {
            if (forbidSplCharsInString.test(sequenceName)) {
              warningText = (sequenceName.length > sequenceNameLength) ? `Sequence name should not exceed ${sequenceNameLength} characters` : '';
            } else {
              warningText = "Special characters are not allowed in Sequence name. Allowed characters[underscore(_), hash(#), percentile(%), and space]`";
            }
          } else {
            warningText = "Sequence name should not start with special characters";
          }
        } else {
          warningText = "Sequence name already exists";
        }
      } else {
        warningText = 'Sequence name should not be empty';
      }

      if (!warningText && block.type === BlockType.MQTT_SUBSCRIBE) {
        // Fetching all input fields of a block
        const allInputfieldsInBlocks = block?.inputList.flatMap((inputListObj: any) => Array.isArray(inputListObj.fieldRow) ? inputListObj.fieldRow : [inputListObj.fieldRow]);
        const textfields = allInputfieldsInBlocks.filter((inputObj: any) => inputObj instanceof Blockly.FieldTextInput);
        const blockInputFields = textfields.filter((fieldObj: any) => fieldObj.name && fieldObj.name !== 'seqFunctionName' && (!fieldObj.value_ || fieldObj.value_.trim() === ''));
        // adding warning icon if block's input field is empty.
        warningText = blockInputFields.length > 0 ? 'Input field cannot be empty' : '';
        this.validateMqttBlockFields(block);
      }

      if (!warningText && block.type === BlockType.MQTT_SUBSCRIBE) {
        this.validateMqttBlockFields(block);
      }

      block.setWarningText(warningText);
      this.toggleBlockErrorState(warningText, block);
    }
  }

  /**
   * Validates a sequencer function block.
   * 
   * @param block - The block to validate.
  */
  validateSequencerBlock(block: any) {
    if (block.type === BlockType.SEQUENCER) {
      let warningText = '';
      const seqFunctionNameLength = 50;
      const descriptionLength = 1000;
      const seqFunctionName = block.getFieldValue('seqFunctionName').toString();
      const descWhat = block.getFieldValue('what');
      const descWhy = block.getFieldValue('why');
      const forbidSplCharsAtStart = /^(?:[A-Za-z0-9]|$)+[A-Za-z0-9]*$/;
      const forbidSplCharsInString = /^(?:[A-Za-z0-9\s]+)(?:[A-Za-z0-9_\s#%]*)$/;
      let existingSequenceIndex: any;
      existingSequenceIndex = this.sequencerFunctionCollection.findIndex((functionObj: any) => {
        if (this.selectedFunctionToView && this.selectedFunctionToView.seqFunctionName) {
          return (functionObj.seqFunctionName !== this.selectedFunctionToView.seqFunctionName) && (functionObj.seqFunctionName.toLowerCase() === seqFunctionName.toLowerCase());
        } else {
          return functionObj.seqFunctionName.toLowerCase() === seqFunctionName.toLowerCase();
        }
      });

      if (seqFunctionName) {
        if (existingSequenceIndex < 0) {
          if (forbidSplCharsAtStart.test(seqFunctionName[0])) {
            if (forbidSplCharsInString.test(seqFunctionName)) {
              warningText = (seqFunctionName.length > seqFunctionNameLength) ? `Sequencer function name should not exceed ${seqFunctionNameLength} characters` : '';
            } else {
              warningText = "Special characters are not allowed in Sequence name. Allowed characters[underscore(_), hash(#), percentile(%), and space]`";
            }
          } else {
            warningText = "Sequencer function name should not start with special characters";
          }
        } else {
          warningText = "Sequencer function name already exists";
        }
      } else {
        warningText = 'Sequencer function name should not be empty';
      }

      // Fetching all input fields of a block
      const allInputfieldsInBlocks = block?.inputList.flatMap((inputListObj: any) => Array.isArray(inputListObj.fieldRow) ? inputListObj.fieldRow : [inputListObj.fieldRow]);
      const textfields = allInputfieldsInBlocks.filter((inputObj: any) => inputObj instanceof Blockly.FieldTextInput);
      const hiddenMetadataFields = [BlockFieldName.SEQUENCE_FUNCTION_ID, 'xml', 'snippet'];
      const blockInputFields = textfields.filter((fieldObj: any) =>
        fieldObj.name &&
        fieldObj.name !== BlockFieldName.SEQUENCE_FUNCTION_NAME &&
        !hiddenMetadataFields.includes(fieldObj.name) &&
        !fieldObj.value_
      );
      // adding warning icon if block's input field is empty.
      if (blockInputFields.length > 0) {
        warningText = 'Input field cannot be empty';
      } else {
        if (!warningText && descWhat && (descWhat.length > descriptionLength)) {
          warningText = `What(description) field should not exceed ${descriptionLength} characters`;
        }
        if (!warningText && descWhy && (descWhy.length > descriptionLength)) {
          warningText = `Why(description) field should not exceed ${descriptionLength} characters`;
        }
      }

      block.setWarningText(warningText);
      this.toggleBlockErrorState(warningText, block);
    }
  }

  /**
   * Validates the input field of a block.
   * If the block is not a sequence or sequencer block, it checks for empty input fields and adds a warning icon.
   * If the block is not inside any sequence block, it adds a warning that the block should be inside a sequence or sequencer block.
   * Additionally, it validates date fields if all the input fields of the block are filled.
   * 
   * @param block - The block to validate.
   */
  validateInputField(block: any) {
    if (!block || !block.id) return; // To avoid the error if block is undefined or null when deleting the block by dragging it on to the bin icon.
    const isSequenceBuilder = this.builderMode === BuilderMode.SEQUENCE_BUILDER;
    const isCloudOrSystemCategory = this.categoryMenu.selectedCategory.id === Category.CLOUD || this.categoryMenu.selectedCategory.id === Category.SYSTEM;
    const procedureBlockTypes = ['procedures_defnoreturn', 'procedures_defreturn'];
    const rootBlockTypes = isSequenceBuilder
      ? (isCloudOrSystemCategory ? [...this.sequenceBlockType, ...procedureBlockTypes] : this.sequenceBlockType)
      : BlockType.SEQUENCER;
    const rootBlockLabel = isSequenceBuilder
      ? (isCloudOrSystemCategory ? `${BlockIdentifier.SEQUENCE} or Function` : BlockIdentifier.SEQUENCE)
      : BlockType.SEQUENCER;
    let excludeBlocks: string[] = [];
    excludeBlocks = ['haystack_query_with_condition_pre_defined_current_value', 'haystack_query_with_condition_pre_defined_device', 'haystack_query_with_condition_pre_defined_equip', 'haystack_query_with_condition_pre_defined', BlockType.TEXT, BlockType.TEXT_MULTILINE];

    // Skipping the validation for loose blocks (blocks which are not inside any sequence blocks) in device category Sequence builder.
    const skipLooseBlocksValidation = this.builderMode === BuilderMode.SEQUENCE_BUILDER && this.categoryMenu.selectedCategory.id === Category.DEVICE;

    if (!(rootBlockTypes.includes(block.type))) {   // Skipping the validation for sequence and sequencer blocks.
      let warningText = '';
      const rootBlock = block.getRootBlock();
      // Fetching all input fields of a block
      const allInputfieldsInBlocks = block?.inputList.flatMap((inputListObj: any) => Array.isArray(inputListObj.fieldRow) ? inputListObj.fieldRow : [inputListObj.fieldRow]);
      const textfields = allInputfieldsInBlocks.filter((inputObj: any) => inputObj instanceof Blockly.FieldTextInput); // Fields of type text
      const dropdownFields = allInputfieldsInBlocks.filter((inputObj: any) => inputObj instanceof Blockly.FieldDropdown); // Fields of type dropdown

      // Filtering the empty input fields
      // Skipping the fields that are hidden by a mutator (e.g. alertHystersis hides its upper/lower limit fields via setVisible when the corresponding limit is selected as NO)
      let blockInputFields: any[] = [];
      blockInputFields = textfields.filter((fieldObj: any) =>
        fieldObj.name && fieldObj.isVisible() && (!fieldObj.value_ || fieldObj.value_.trim() === '') &&
        !fieldObj.name.includes('CustomInput_')
      );

      // Adding the dropdown field value is "'DEFAULT_MODAL' or null or undefined or empty" in to the blockInputFields array.
      dropdownFields.filter((fieldObj: any) => {
        if (!fieldObj.isVisible()) return;
        const fieldValue = fieldObj.getValue();
        if (fieldValue === 'DEFAULT_MODAL' || fieldValue === null || fieldValue === undefined || fieldValue === '') {
          blockInputFields.push(fieldObj);
        }
      });

      // Condition (block.id === rootBlock.id) checks if the current block itself is a root/parent block (and the block is not a child of any sequence block).

      // if category is the device then skip the checking if the block is inside the sequence or not.
      if ((!skipLooseBlocksValidation) && ((block.id === rootBlock.id) || !(rootBlockTypes.includes(rootBlock.type)))) {
        const surroundBlock = block.getSurroundParent();
        warningText = surroundBlock ? '' : `Block should be inside a ${rootBlockLabel} block`;   // Setting warning text if the block is not inside any sequence block.
      } else {
        // Setting warning text if block's input field is empty.
        if (blockInputFields.length > 0 && excludeBlocks.indexOf(block.type) < 0) {
          warningText = 'Input field cannot be empty';
        }

        // Validating the input field of a text block only if it is attached to the MQTT subscribe or MQTT publish blocks.
        if (!warningText && block.type === BlockType.TEXT) {
          const surroundBlock = block.getSurroundParent();
          const isTextBlockInsideMqttBlock = surroundBlock && (surroundBlock.type === BlockType.MQTT_SUBSCRIBE || surroundBlock.type === BlockType.MQTT_PUBLISH) ? true : false;
          if (blockInputFields.length > 0 && isTextBlockInsideMqttBlock) {
            warningText = 'Input field cannot be empty';
          }
        }

        // Setting warning text if the model block is not inside run on startup block.
        if (!warningText && block.type === BlockType.MODEL_BLOCK) {
          const isModelBlockInsideRunBlock = block.getRootBlock().type === 'sequence_run_startup' ? true : false;
          warningText = isModelBlockInsideRunBlock ? '' : `Model blocks should be inside a 'Run on startup' block`;
        }
      }

      if (!warningText && block.type === BlockType.MQTT_PUBLISH) {
        const mqttFieldValidationError = this.validateMqttBlockFields(block);
        if (mqttFieldValidationError) {
          warningText = mqttFieldValidationError;
        }
      }

      // Only run number validation if no errors found
      if (!warningText) {
        const numberValidationError = this.validateNumberInputFields(block);
        if (numberValidationError) {
          warningText = numberValidationError;
        }
      }

      if (!warningText) {
        const topic = javascriptGenerator.valueToCode(block, 'topic', javascriptGenerator.ORDER_ATOMIC);
        if (topic && /[#+]/.test(topic)) {
          warningText = 'Topic must not contain wildcard characters (# or +)';
        }
      }

      if (this.isSmartNodeDeviceType() && this.bacnetBlockTypes.includes(block.type)) {
        warningText = 'BACnet blocks are not supported for Smart Node';
      }

      if (!warningText) {
        const deviceTypeWarning = this.getDeviceTypeValidationWarning(block);
        if (deviceTypeWarning) {
          warningText = deviceTypeWarning;
        }
      }

      if (!warningText) {
        const porBusWarning = this.getPorBusValidationWarning(block);
        if (porBusWarning) {
          warningText = porBusWarning;
        }
      }

      // Adding warning icons with warning text for error blocks.  
      block.setWarningText(warningText);
      this.toggleBlockErrorState(warningText, block);

      !warningText ? this.validateDateInputFields(block) : '';
      !warningText ? this.validateAlertBlockWithOffsetLimit(block) : '';
    }
  }

  getDeviceTypeValidationWarning(block: any): string {
    if (this.builderMode !== BuilderMode.SEQUENCE_BUILDER || this.categoryMenu.selectedCategory.id !== Category.DEVICE) return '';
    const deviceType = this.getRunStartupDeviceType();
    const isSmartNode = deviceType === 'SMART_NODE';
    if (!this.deviceTypeRestrictedBlocks.includes(block.type)) return '';

    if (!isSmartNode) {
      if (block['invalidDeviceTypeValue']) {
        delete block['invalidDeviceTypeValue'];
      }
      return '';
    }

    const fieldName = this.deviceTypeFieldMap[block.type];
    if (!fieldName) return '';
    const fieldValue = block.getFieldValue(fieldName);
    const numericValue = parseInt(fieldValue, 10);
    const hasInvalidFlag = !!block['invalidDeviceTypeValue'];
    const isInvalid = !Number.isNaN(numericValue) && numericValue > 3;

    if (!isInvalid && hasInvalidFlag) {
      delete block['invalidDeviceTypeValue'];
      return '';
    }

    return (isInvalid || hasInvalidFlag) ? 'Smart node supports value range 1-4' : '';
  }

  isPorBusBlockAllowed(block: any): boolean {
    if (!block || !this.porBusRestrictedBlocks.includes(block.type)) return true;
    return this.isSmartNodeDeviceType();
  }

  getPorBusValidationWarning(block: any): string {
    if (this.builderMode !== BuilderMode.SEQUENCE_BUILDER || this.categoryMenu.selectedCategory.id !== Category.DEVICE) return '';
    if (!this.porBusRestrictedBlocks.includes(block.type)) return '';
    return this.isPorBusBlockAllowed(block)
      ? ''
      : 'POR bus blocks are supported only for Smart Node device type';
  }

  getRunStartupDeviceType(): string | null {
    if (this.builderMode !== BuilderMode.SEQUENCE_BUILDER || this.categoryMenu.selectedCategory.id !== Category.DEVICE) return null;
    return this.blocklyWorkspaceBuilderService.getRunStartupDeviceType(this.blocklyWorkSpace);
  }

  isSmartNodeDeviceType(): boolean {
    return this.blocklyWorkspaceBuilderService.isSmartNodeDeviceType(this.blocklyWorkSpace);
  }

  updateDeviceTypeOptionsForDeviceBlocks(deviceType: string) {
    if (!this.blocklyWorkSpace || !deviceType) return;
    const allBlocks = this.blocklyWorkSpace.getAllBlocks(true);
    const targetBlocks = allBlocks.filter((blockObj: any) => this.deviceTypeRestrictedBlocks.includes(blockObj.type));
    const maxOption = deviceType === 'SMART_NODE' ? 4 : 8;
    const options = Array.from({ length: maxOption }, (_, index) => ({
      label: `${index + 1}`,
      value: `${index}`
    }));

    targetBlocks.forEach((blockObj: any) => {
      const fieldName = this.deviceTypeFieldMap[blockObj.type];
      if (!fieldName) return;
      const field = blockObj.getField(fieldName);
      const previousValue = field?.getValue();
      this.commonService.setDropdownOptionsForBlock(blockObj, this.blocklyWorkSpace, fieldName, options, false);

      if (deviceType === 'SMART_NODE') {
        const numericValue = parseInt(previousValue, 10);
        if (!Number.isNaN(numericValue) && numericValue > 3) {
          blockObj['invalidDeviceTypeValue'] = previousValue;
          if (field && field.getValue() !== previousValue) {
            // Preserve the previously selected (now invalid) value so the user can correct it.
            (field as any).value_ = previousValue;
            if (typeof field.setText === 'function') {
              field.setText(`${numericValue + 1}`);
            }
            if (typeof field.forceRerender === 'function') {
              field.forceRerender();
            }
          }
        }
      } else if (blockObj['invalidDeviceTypeValue']) {
        delete blockObj['invalidDeviceTypeValue'];
      }

      this.validateInputField(blockObj);
    });
  }

  validateBacnetBlocksOnWorkspace() {
    if (this.builderMode !== BuilderMode.SEQUENCE_BUILDER || this.categoryMenu.selectedCategory.id !== Category.DEVICE) return;
    const targetTypes = [
      ...this.bacnetBlockTypes,
      ...this.deviceTypeRestrictedBlocks,
      ...this.porBusRestrictedBlocks
    ];
    this.blocklyWorkspaceBuilderService
      .getWorkspaceBlocksByTypes(this.blocklyWorkSpace, targetTypes)
      .forEach((blockObj: any) => this.validateInputField(blockObj));
  }


  validateNumberInputFields(block: any): string {
    const targetBlockTypes = ['alertHystersis', 'alertWithOffset'];
    const targetFields = [
      'ALERT_TRIGGER_OFFSET', 'ALERT_FIX_OFFSET',
      'ALERT_TRIGGER_UPPER_LIMIT_OFFSET', 'ALERT_FIX_UPPER_LIMIT_OFFSET',
      'ALERT_TRIGGER_LOWER_LIMIT_OFFSET', 'ALERT_FIX_LOWER_LIMIT_OFFSET'
    ];

    if (targetBlockTypes.includes(block.type)) {
      let hasError = false;

      const allInputfieldsInBlocks = block?.inputList.flatMap((inputListObj: any) =>
        Array.isArray(inputListObj.fieldRow) ? inputListObj.fieldRow : [inputListObj.fieldRow]
      );
      const textfields = allInputfieldsInBlocks.filter((inputObj: any) => inputObj instanceof Blockly.FieldTextInput);
      // Skipping fields hidden by the hystersis_mutator (e.g. when the corresponding upper/lower limit fields via setVisible when the corresponding limit is selected as NO)
      const numberFields = textfields.filter((fieldObj: any) => fieldObj.name && fieldObj.isVisible() && targetFields.includes(fieldObj.name));
      const numericRegex = /^\d+(\.\d+)?$/;
      numberFields.forEach((fieldObj: any) => {
        const fieldValue = fieldObj.getValue().trim();
        if (!numericRegex.test(fieldValue) || parseFloat(fieldValue) < 0) {
          hasError = true;
        }
      });

      return hasError ? 'Invalid value in offset field' : '';
    }
    return '';
  }


  /**
   * Method to validate the enable upperlimit and enable lower limit fields in alert block with offset and limit.
   * @param block	- Blockly block object
  */
  validateAlertBlockWithOffsetLimit(block: any) {
    const blocksWithLimitToggle = ['alertHystersis'];
    let warningText = '';
    if (blocksWithLimitToggle.indexOf(block.type) >= 0) {
      const upperLimitEnabled = block.getFieldValue('SHOW_UPPER_LIMIT') === 'YES' ? true : false;
      const lowerLimitEnabled = block.getFieldValue('SHOW_LOWER_LIMIT') === 'YES' ? true : false
      if (!upperLimitEnabled && !lowerLimitEnabled) {
        warningText = 'At least one limit should be enabled';
      }

      const getLimitValue = (fieldName: string): number | null | undefined => {
        const targetBlock = block.getInputTargetBlock(fieldName);
        if (!targetBlock) {
          return undefined;
        }
        if (targetBlock.type !== 'math_number') {
          return null;
        }
        const value = parseFloat(targetBlock.getFieldValue('NUM'));
        return isNaN(value) ? undefined : value;
      };

      const upperLimit = getLimitValue('ALERT_TRIGGER_UPPER_LIMIT');
      const upperLimitFix = getLimitValue('ALERT_FIX_UPPER_LIMIT');
      const lowerLimit = getLimitValue('ALERT_TRIGGER_LOWER_LIMIT');
      const lowerLimitFix = getLimitValue('ALERT_FIX_LOWER_LIMIT');

      // If no warning text is set, check for missing limit values and set a warning if any are missing.
      if (!warningText) {
        const hasMissingLimitValue = (upperLimitEnabled && (upperLimit === undefined || upperLimitFix === undefined)) ||
          (lowerLimitEnabled && (lowerLimit === undefined || lowerLimitFix === undefined));
        if (hasMissingLimitValue) {
          warningText = 'Input field cannot be empty';
        }
      }

      const hasValidLimitValue = !warningText && (
        (upperLimitEnabled && (upperLimit === null || upperLimitFix === null)) ||
        (lowerLimitEnabled && (lowerLimit === null || lowerLimitFix === null))
      );

      // Validating limit values
      if (!warningText && !hasValidLimitValue) {
        const limitErrors: string[] = [];
        if (upperLimitEnabled && typeof upperLimit === 'number' && typeof upperLimitFix === 'number' && !(upperLimitFix < upperLimit)) {
          limitErrors.push('Upper Limit Fix should be less than Upper Limit');
        }
        if (lowerLimitEnabled && typeof lowerLimit === 'number' && typeof lowerLimitFix === 'number' && !(lowerLimitFix > lowerLimit)) {
          limitErrors.push('Lower Limit Fix should be greater than Lower Limit');
        }
        if (upperLimitEnabled && lowerLimitEnabled && typeof upperLimit === 'number' && typeof lowerLimit === 'number' && !(upperLimit > lowerLimit)) {
          limitErrors.push('Upper Limit should be greater than Lower Limit');
        }
        if (upperLimitEnabled && lowerLimitEnabled && typeof upperLimitFix === 'number' && typeof lowerLimitFix === 'number' && !(upperLimitFix > lowerLimitFix)) {
          limitErrors.push('Upper Limit Fix should be greater than Lower Limit Fix');
        }
        warningText = limitErrors.join('\n');
      }

      if (warningText) {
        const validationEntry = {
          blockId: block.id,
          name: block.getFieldValue('ALERT_TITLE') || 'Untitled Alert',
          errors: warningText.split('\n'),
          upperLimitEnabled,
          lowerLimitEnabled,
          upperLimit: upperLimit ?? null,
          upperLimitFix: upperLimitFix ?? null,
          lowerLimit: lowerLimit ?? null,
          lowerLimitFix: lowerLimitFix ?? null
        };
        const existingIndex = this.alertHystersisValidationSummary.findIndex((entry: any) => 
          entry.blockId === block.id
        );
        if (existingIndex >= 0) {
          this.alertHystersisValidationSummary[existingIndex] = validationEntry;
        } else {
          this.alertHystersisValidationSummary.push(validationEntry);
        }
      }
    }

    this.toggleBlockErrorState(warningText, block);
  }

  /**
   * Validates the date input fields of a block.
   * @param block - The block to validate.
   */
  validateDateInputFields(block: any) {
    const blocksWithMultiDates = ['getHistorizedValueFromDateRange', 'gethistorizedDateTimeVariant', 'getAggregatedValuesFromDateRange', 'getAggregatedValuesFromDateTimeVariant'];
    let warningText = '';
    if (blocksWithMultiDates.indexOf(block.type) >= 0) {
      const fieldsWithDate = ['start_date', 'end_date'];

      // Fetching all input fields of a block
      const allInputfieldsInBlocks = block?.inputList.flatMap((inputListObj: any) => Array.isArray(inputListObj.fieldRow) ? inputListObj.fieldRow : [inputListObj.fieldRow]);
      const textfields = allInputfieldsInBlocks.filter((inputObj: any) => inputObj instanceof Blockly.FieldTextInput);

      // Checking if each datefield in the block has a valid date. 
      textfields.forEach((fieldObj: any) => {
        if (fieldsWithDate.indexOf(fieldObj.name) >= 0) {
          const regex = /^\d{4}-\d{2}-\d{2}$/;
          if (!(regex.test(fieldObj.value_))) {
            warningText = 'Invalid date. Please enter the date in YYYY-MM-DD format';
          }
        }
      });

      // Checking if block contains multiple date fields and comparing them.
      const multiDateFields = textfields.filter((fieldObj: any) => fieldObj.name && fieldsWithDate.indexOf(fieldObj.name) >= 0);
      if (!warningText && multiDateFields.length > 1) {
        const fromDate = new Date(block.getFieldValue('start_date'));
        const toDate = new Date(block.getFieldValue('end_date'));

        if (fromDate <= toDate) {
          warningText = '';
        } else if (fromDate > toDate) {
          warningText = 'From Date should be less than To Date';
        }
        else {
          warningText = 'To Date should be greated than From Date';
        }
      }


      // Additional validation for time format
      if (['getAggregatedValuesFromDateTimeVariant', 'gethistorizedDateTimeVariant'].includes(block.type)) {
        const fieldsWithTime = ['start_time', 'end_time'];
        const timeRegex = /^(?:2[0-3]|[01][0-9]):[0-5][0-9]$/;

        // Fetching all input fields of a block
        const allInputfieldsInBlocks = block?.inputList.flatMap((inputListObj: any) => Array.isArray(inputListObj.fieldRow) ? inputListObj.fieldRow : [inputListObj.fieldRow]);
        const textfields = allInputfieldsInBlocks.filter((inputObj: any) => inputObj instanceof Blockly.FieldTextInput);

        // Checking if each datefield in the block has a valid date. 
        textfields.forEach((fieldObj: any) => {
          if (fieldsWithTime.indexOf(fieldObj.name) >= 0) {
            if (!(timeRegex.test(fieldObj.value_))) {
              warningText = 'Invalid time format. Please enter time in HH:MM format (24-hour clock)';
            }
          }
        });

      }

    }
    block.setWarningText(warningText);
    this.toggleBlockErrorState(warningText, block);
  }

  /**
   * Toggles the error state of a block and updates the errorBlocks array accordingly.
   * @param {any} warningText - The warning text associated with the error state.
   * @param {any} block - The block object to toggle the error state for.
   */
  toggleBlockErrorState(warningText: any, block: any) {
    const targetIndex = this.errorBlocks.indexOf(block.id);
    if (warningText) {
      this.errorBlocks.push(block.id);
      block.setHighlighted(true);
      block.select();
    } else {
      if (block.isInErrorState) {
        this.errorBlocks.push(block.id);
      } else {
        targetIndex >= 0 ? this.errorBlocks.splice(targetIndex, 1) : '';
        block.setHighlighted(false);
        block.unselect();
      }
    }
  }

  navigateBackToSiteSequences() {
    const targetBuilderMode = BuilderMode.SEQUENCE_BUILDER;
    const skipValidationCheck = true;
    this.toggleBuilderMode(targetBuilderMode, skipValidationCheck);
  }

  navigateToLibraryBuilder() {
    this.resetLibraryBuilder();
    this.isBuildingNewSequenceFunction = true;
    this.toggleBuilderMode(BuilderMode.LIBRARY_BUILDER);
  }

  showConfirmationDialog(eventType: any, selectedSeqFunction?: any) {
    this.siteSequencerService.getSequenceFunctionsUsage(selectedSeqFunction.functionId, this.SequenceFunctionsComponent)
      .subscribe((res: any) => {
        if (res) {
          const sequenceFunctionUsage = res;
          sequenceFunctionUsage['eventType'] = eventType;
          const selectedSequenceFunction = selectedSeqFunction.seqFunctionName;
          const dialogRef = this.dialog.open(EditAndDeleteConfirmationModalComponent, {
            panelClass: 'fs-mat-dialog-container',
            minWidth: '480px',
            // Escape cancels the active confirmation without affecting other dialogs.
            disableClose: false
          });
          const title = `Are you sure you want to ${eventType} ${selectedSequenceFunction}?`;
          const subTitle = 'this action cannot be undone';
          dialogRef.componentInstance.title = title;
          dialogRef.componentInstance.subTitle = subTitle;
          dialogRef.componentInstance.sequenceFunction = sequenceFunctionUsage;
          dialogRef.componentInstance.type = 'confirm';
          dialogRef.componentInstance.confirmBtnText = 'Continue';
          dialogRef.componentInstance.showConfirmIcon = true;
          dialogRef.componentInstance.isCanvasAction = false;
          dialogRef.updatePosition({ top: '60px' });
          dialogRef.afterClosed().subscribe(result => {
            // On edit or delete confirmation
            if (result && result == 'confirm') {
              if (eventType === 'edit') {
                this.canvasTabToSwitch = this.canvasTabs.selectedCanvasTab;
                this.handleViewSequence(selectedSeqFunction);
              }
              else if (eventType === 'delete') {
                this.deleteSequenceFunction();
              }
            }
          });
        }
      }, (err: any) => {
        this.showToast('error', err?.error && err?.error?.error ? err?.error?.error : `Something went wrong, please try again.`);
      });

  }

  saveSequenceFunction() {
    const allBlocks = this.blocklyWorkSpace.getAllBlocks(true);
    const functionBlocksInCanvas = allBlocks.filter((blockObj: any) => blockObj.type === 'sequencer');
    if (functionBlocksInCanvas.length > 0
      && functionBlocksInCanvas[0].id === this.activeSequencerBlockRef && this.sequencerBlock) {
      this.isLoading = true;
      const targetBlock = this.blocklyWorkSpace.getBlockById(this.activeSequencerBlockRef);
      const isSequencesValid = this.checkAndReturnErrorStatus();
      if (isSequencesValid) {
        this.sequencerBlock = {
          "seqFunctionName": targetBlock.getFieldValue('seqFunctionName'),
          "why": targetBlock.getFieldValue('why'),
          "what": targetBlock.getFieldValue('what'),
          "snippet": this.getJSCodeForSequence(targetBlock, ''),
          "xml": this.sequencerBlock.xml = this.parseXMLForSequence(targetBlock),
          "component": this.SequenceFunctionsComponent
        }

        this.siteSequencerService.saveSequenceFunction(this.sequencerBlock)
          .subscribe((res) => {
            if (res && res.functionId) {
              // Adding the obtained functionId to the functionId field of sequencer block
              this.sequencerBlock['functionId'] = res['functionId'];
              targetBlock.setFieldValue(this.sequencerBlock['functionId'], 'functionId');
              targetBlock.getField('functionId').setVisible(false);
              this.updateSequencerBlockConfig(targetBlock);

              this.saveAndUpdateSequenceFunction(false, true);
            } else {
              this.isLoading = false;
            }
          }, (err: any) => {
            this.isLoading = false;
            this.showToast('error', err?.error?.error ? err?.error?.error : `Something went wrong in saving sequence function, please try again.`);
          });
      } else {
        this.isLoading = false;
      }
    } else {
      this.isLoading = false;
      this.showToast('error', 'Add a sequencer block to canvas to create a sequencer function');
    }
  }

  openSaveProcedureAsSequenceFunctionDialog(procedureBlock: any) {
    if (!procedureBlock || !this.isSupportedSequenceFunctionSourceBlock(procedureBlock)) return;
    // Reuse the existing block validation rules before opening the save/update dialog.
    if (!this.validateLibrarySaveSourceBlock(procedureBlock)) {
      return;
    }
    const invalidBlocks = this.getInvalidBlocksInProcedureForLibraryToolbox(procedureBlock);
    if (invalidBlocks.length) {
      const specialValidationMessage = invalidBlocks.find((item: string) => item.startsWith('Procedure calls are not supported'));
      if (specialValidationMessage) {
        this.showToast('error', specialValidationMessage);
        return;
      }
      const preview = invalidBlocks.slice(0, 3).join(', ');
      const suffix = invalidBlocks.length > 3 ? ` and ${invalidBlocks.length - 3} more` : '';
      this.showToast('error', `Remove unsupported blocks before saving: ${preview}${suffix}`);
      return;
    }
    const procedureMetadata = this.getProcedureLibraryMetadata(procedureBlock);
    const linkedFunctionId = procedureMetadata.functionId;
    const sourceFunctionId = procedureMetadata.sourceFunctionId || linkedFunctionId;
    const matchingFunction = sourceFunctionId
      ? this.sequencerFunctionCollection.find((functionObj: any) => functionObj.functionId === sourceFunctionId)
      : null;
    const canUpdateExistingFunction = !!linkedFunctionId && this.isSequenceFunctionCreatedByLoggedInUser(matchingFunction);
    const sourceName = matchingFunction?.seqFunctionName || this.getSequenceFunctionSourceBlockName(procedureBlock) || DefaultTabName.LIBRARY_BUILDER;
    const defaultName = sourceFunctionId && !canUpdateExistingFunction
      ? this.getUniqueValueWithCopySuffix(sourceName, 'seqFunctionName', this.sequencerFunctionCollection)
      : sourceName;
    this.pendingProcedureBlock = procedureBlock;
    this.pendingProcedureSourceFunctionId = sourceFunctionId;
    this.pendingProcedureFunctionId = canUpdateExistingFunction ? linkedFunctionId : '';
    this.saveSeqFunctionForm = {
      name: defaultName,
      why: procedureMetadata.why || matchingFunction?.why || '',
      what: procedureMetadata.what || matchingFunction?.what || ''
    };
    this.saveSeqFunctionError = '';
    const dialogRef = this.dialog.open(this.saveSeqFunctionDialogTpl, {
      width: '440px',
      // Let the active template dialog participate in topmost Escape handling.
      disableClose: false,
      autoFocus: false,
      panelClass: 'save-seq-function-dialog-panel'
    });
    dialogRef?.updatePosition?.({ top: '100px' });
  }

  onSeqFunctionDialogInputChange() {
    const name = (this.saveSeqFunctionForm.name || '').trim();
    const why = (this.saveSeqFunctionForm.why || '').trim();
    const what = (this.saveSeqFunctionForm.what || '').trim();
    this.saveSeqFunctionError = this.validateSeqFunctionDialogInput(name, why, what, this.pendingProcedureFunctionId);
  }

  async saveProcedureAsSequenceFunction() {
    if (this.isSavingSeqFunctionFromProcedure) {
      return;
    }
    if (!this.pendingProcedureBlock) return;
    // Validate again at submit time because the workspace may have changed while the
    // dialog was open.
    if (!this.validateLibrarySaveSourceBlock(this.pendingProcedureBlock)) {
      return;
    }
    const name = (this.saveSeqFunctionForm.name || '').trim();
    const why = (this.saveSeqFunctionForm.why || '').trim();
    const what = (this.saveSeqFunctionForm.what || '').trim();
    const isUpdate = !!this.pendingProcedureFunctionId;

    const validationError = this.validateSeqFunctionDialogInput(name, why, what, this.pendingProcedureFunctionId);
    if (validationError) {
      this.saveSeqFunctionError = validationError;
      return;
    }

    this.saveSeqFunctionError = '';
    this.isSavingSeqFunctionFromProcedure = true;

    try {
      const xml = this.buildSequencerXmlFromProcedure(this.pendingProcedureBlock, name, why, what);
      const snippet = this.buildSnippetFromSequencerXml(xml, '');
      const payload = {
        seqFunctionName: name,
        why,
        what,
        xml,
        snippet,
        component: this.SequenceFunctionsComponent
      };

      const request$ = isUpdate
        ? this.siteSequencerService.updateSequenceFunction(this.pendingProcedureFunctionId, payload)
        : this.siteSequencerService.saveSequenceFunction(payload);

      request$.subscribe({
        next: (res: any) => {
          this.isSavingSeqFunctionFromProcedure = false;
          const functionId = this.pendingProcedureFunctionId || res?.functionId || '';
          const shouldLinkFunctionIdToSource = isUpdate || !this.pendingProcedureSourceFunctionId;
          if (res && (res.functionId || isUpdate)) {
            if (isUpdate && this.isProcedureDefinitionBlock(this.pendingProcedureBlock) && name &&
              this.pendingProcedureBlock?.getFieldValue?.('NAME') !== name) {
              this.pendingProcedureBlock.setFieldValue?.(name, 'NAME');
            }
            if (this.isProcedureDefinitionBlock(this.pendingProcedureBlock)) {
              this.setProcedureDescription(this.pendingProcedureBlock, { why, what });
            }
            this.setProcedureLibraryMetadata(this.pendingProcedureBlock, {
              functionId: shouldLinkFunctionIdToSource ? functionId : '',
              sourceFunctionId: shouldLinkFunctionIdToSource ? functionId : (this.pendingProcedureSourceFunctionId || functionId),
              why,
              what,
              xml,
              snippet
            });
            if (functionId) {
              this.upsertSequenceFunctionInCollection({
                functionId,
                seqFunctionName: name,
                why,
                what,
                xml,
                snippet,
                category: this.categories.CREATED_BY_ME
              });
            }
            if (isUpdate) {
              this.pendingProcedureFunctionId = functionId;
            }
            this.saveSeqFunctionError = '';
            this.dialog.closeAll();
            this.showToast('success', `Sequence function ${name} ${isUpdate ? 'updated' : 'created'} successfully.`);
            this.setUpdatedFunctionsBlockData();
            this.resetSaveSeqFunctionDialogState();
          } else {
            this.saveSeqFunctionError = `Something went wrong in ${isUpdate ? 'updating' : 'saving'} sequence function, please try again.`;
          }
        },
        error: (err: any) => {
          this.isSavingSeqFunctionFromProcedure = false;
          this.saveSeqFunctionError = err?.error?.error || 'Function name already exists. Please update details and try again.';
        }
      });
    } catch {
      this.isSavingSeqFunctionFromProcedure = false;
      this.saveSeqFunctionError = 'Something went wrong in saving sequence function, please try again.';
    }
  }

  closeSaveSeqFunctionDialog() {
    this.dialog.closeAll();
    this.resetSaveSeqFunctionDialogState();
  }

  get isProcedureSeqFunctionUpdateMode(): boolean {
    return !!this.pendingProcedureFunctionId;
  }

  get isProcedureSeqFunctionCreateAsNewMode(): boolean {
    return !!this.pendingProcedureSourceFunctionId && !this.pendingProcedureFunctionId;
  }

  private resetSaveSeqFunctionDialogState(): void {
    this.pendingProcedureBlock = null;
    this.pendingProcedureSourceFunctionId = '';
    this.pendingProcedureFunctionId = '';
    this.saveSeqFunctionError = '';
    this.isSavingSeqFunctionFromProcedure = false;
  }

  private buildSequencerXmlFromProcedure(procedureBlock: any, name: string, why: string, what: string): string {
    const statementInputName = this.getSequenceFunctionSourceStatementInputName(procedureBlock);
    const stackBlock = statementInputName ? procedureBlock.getInputTargetBlock(statementInputName) : null;
    const stackDom = stackBlock ? (Blockly.Xml.blockToDom(stackBlock) as Element) : null;
    const dependentProcedureDoms = this.getProcedureDependencyDomElements(procedureBlock);
    return this.buildSequencerXmlDocument(name, why, what, stackDom, dependentProcedureDoms);
  }

  private buildSequencerXmlDocument(
    name: string,
    why: string,
    what: string,
    stackDom?: Element | null,
    additionalTopLevelBlocks: Element[] = []
  ): string {
    const primaryBlockPosition = { x: 40, y: 40 };
    const dependentBlockPosition = { x: 520, startY: 40, gapY: 180 };
    const doc = document.implementation.createDocument('https://developers.google.com/blockly/xml', 'xml', null);
    const root = doc.documentElement;

    const seqBlock = doc.createElement('block');
    seqBlock.setAttribute('type', this.getSequencerFunctionBlockType());
    seqBlock.setAttribute('x', `${primaryBlockPosition.x}`);
    seqBlock.setAttribute('y', `${primaryBlockPosition.y}`);

    const nameField = doc.createElement('field');
    nameField.setAttribute('name', 'seqFunctionName');
    nameField.textContent = name;

    const whyField = doc.createElement('field');
    whyField.setAttribute('name', 'why');
    whyField.textContent = why;

    const whatField = doc.createElement('field');
    whatField.setAttribute('name', 'what');
    whatField.textContent = what;

    seqBlock.appendChild(nameField);
    seqBlock.appendChild(whyField);
    seqBlock.appendChild(whatField);

    const statement = doc.createElement('statement');
    statement.setAttribute('name', 'CODE');

    if (stackDom) {
      const importedStack = doc.importNode(stackDom, true);
      statement.appendChild(importedStack);
    }

    seqBlock.appendChild(statement);
    root.appendChild(seqBlock);
    additionalTopLevelBlocks.forEach((blockDom: Element | null, index: number) => {
      if (!blockDom) {
        return;
      }
      const importedBlock = doc.importNode(blockDom, true) as Element;
      importedBlock.setAttribute('x', `${dependentBlockPosition.x}`);
      importedBlock.setAttribute('y', `${dependentBlockPosition.startY + (index * dependentBlockPosition.gapY)}`);
      root.appendChild(importedBlock);
    });

    return new XMLSerializer().serializeToString(root);
  }

  private validateLibrarySaveSourceBlock(sourceBlock: any): boolean {
    if (!sourceBlock) {
      return false;
    }

    this.errorBlocks = [];
    const descendantBlocks = sourceBlock.getDescendants?.(true) || [];
    const dependentProcedureBlocks = this.getProcedureDependencyBlocks(sourceBlock);
    // Keep library-save validation scoped to the selected block tree so unrelated
    // invalid blocks elsewhere in the workspace do not block the action.
    const blocks = Array.from(new Set([sourceBlock, ...descendantBlocks, ...dependentProcedureBlocks]));

    blocks.forEach((block: any) => {
      if (block === sourceBlock && this.isSequenceBlockSourceForLibrarySave(sourceBlock)) {
        this.validateSequenceBlock(block);
      }
      this.validateInputField(block);
    });

    if (this.errorBlocks.length > 0) {
      this.showToast('error', 'Invalid block or sequence found. Please ensure all input fields are filled and the blocks are enclosed within the designated sequence');
      this.sequenceTohighlight = { "id": this.errorBlocks[0] };
      this.getBlockIntoView(this.sequenceTohighlight, false);
      return false;
    }

    return true;
  }

  private getInvalidBlocksInProcedureForLibraryToolbox(procedureBlock: any): string[] {
    const statementInputName = this.getSequenceFunctionSourceStatementInputName(procedureBlock);
    const stackBlock = statementInputName ? procedureBlock?.getInputTargetBlock?.(statementInputName) : null;
    if (!stackBlock) return [];
    const libraryToolbox = this.getLibraryToolboxSnapshot();
    const dependencyBlocks = this.getProcedureDependencyBlocks(procedureBlock);
    const blocks = Array.from(new Set([
      stackBlock,
      ...stackBlock.getDescendants(true),
      ...dependencyBlocks.flatMap((block: any) => [block, ...(block?.getDescendants?.(true) || [])])
    ]));
    const invalid: string[] = [];

    blocks.forEach((block: any) => {
      if (!this.isBlockValidInLibraryToolbox(block, libraryToolbox)) {
        invalid.push(this.getBlockIdentifiers(block));
      }
    });

    return Array.from(new Set(invalid));
  }

  private isSequenceBlockSourceForLibrarySave(block: any): boolean {
    return block?.type === BlockType.SEQUENCE || block?.type === BlockType.SEQUENCE_SYSTEM;
  }

  private hasProcedureCallsInBlocks(blocks: any[]): boolean {
    return this.blocklyWorkspaceBuilderService.hasProcedureCallsInBlocks(blocks);
  }

  private isBlockValidInLibraryToolbox(block: any, libraryToolbox: any): boolean {
    const blockType = block?.type;
    if (!blockType) return true;
    const hasProcedureCategory = libraryToolbox.contents.some((toolboxItem: any) =>
      toolboxItem.kind === toolBoxContentKind.CATEGORY &&
      (toolboxItem.custom === 'PROCEDURE' || toolboxItem.categorystyle === 'procedure_category')
    );
    const isTypeInToolbox = (type: any) =>
      libraryToolbox.contents.some((toolboxItem: any) =>
        toolboxItem.kind === toolBoxContentKind.CATEGORY && toolboxItem.contents && toolboxItem.contents.length &&
        toolboxItem.contents.some((contentItem: any) => contentItem.kind === toolBoxContentKind.BLOCK && contentItem.type === type)
      );

    if (blockType.startsWith(BlockType.CUSTOM_BLOCK)) {
      return false;
    }
    if (blockType.startsWith(BlockType.VARIABLES)) {
      const allVariables = this.blocklyWorkSpace.getAllVariableNames();
      const variableFieldOfBlock = block.getField(BlockFieldName.VARIABLE);
      const currentVariableNameOfblock = variableFieldOfBlock?.variable?.name;
      return allVariables?.includes(currentVariableNameOfblock);
    }
    if (blockType.startsWith(BlockType.MATH_CHANGE)) {
      return true;
    }
    if (hasProcedureCategory && blockType.startsWith('procedures_')) {
      return true;
    }
    return isTypeInToolbox(blockType);
  }

  private getProcedureDependencyBlocks(sourceBlock: any): any[] {
    if (!this.blocklyWorkSpace || !sourceBlock) {
      return [];
    }

    const statementInputName = this.getSequenceFunctionSourceStatementInputName(sourceBlock);
    const stackBlock = statementInputName ? sourceBlock?.getInputTargetBlock?.(statementInputName) : null;
    const searchRoots = [sourceBlock, stackBlock].filter(Boolean);
    if (!searchRoots.length) {
      return [];
    }

    const allWorkspaceBlocks = this.blocklyWorkSpace.getAllBlocks(false) || [];
    const procedureDefinitionByName = new Map<string, any>();
    allWorkspaceBlocks.forEach((block: any) => {
      if (!this.isProcedureDefinitionBlock(block)) {
        return;
      }
      const procedureName = this.getProcedureBlockName(block);
      if (procedureName) {
        procedureDefinitionByName.set(procedureName, block);
      }
    });

    const dependencyBlocks: any[] = [];
    const visitedProcedureNames = new Set<string>();
    const collectDependencies = (blocksToScan: any[]) => {
      const calledProcedureNames = this.getCalledProcedureNamesFromBlocks(blocksToScan);
      calledProcedureNames.forEach((procedureName: string) => {
        if (!procedureName || visitedProcedureNames.has(procedureName)) {
          return;
        }
        visitedProcedureNames.add(procedureName);
        const procedureDefinition = procedureDefinitionByName.get(procedureName);
        if (!procedureDefinition || procedureDefinition.id === sourceBlock.id) {
          return;
        }
        dependencyBlocks.push(procedureDefinition);
        collectDependencies([procedureDefinition, ...(procedureDefinition.getDescendants?.(true) || [])]);
      });
    };

    collectDependencies(searchRoots.flatMap((block: any) => [block, ...(block?.getDescendants?.(true) || [])]));
    return dependencyBlocks;
  }

  private getProcedureDependencyDomElements(sourceBlock: any): Element[] {
    return this.getProcedureDependencyBlocks(sourceBlock)
      .map((block: any) => Blockly.Xml.blockToDom(block) as Element)
      .filter((blockDom: Element | null) => !!blockDom);
  }

  private getCalledProcedureNamesFromBlocks(blocks: any[]): string[] {
    return this.blocklyWorkspaceBuilderService.getCalledProcedureNamesFromBlocks(blocks);
  }

  private getProcedureCallName(block: any): string {
    return this.blocklyWorkspaceBuilderService.getProcedureCallName(block);
  }

  private getProcedureBlockName(block: any): string {
    return this.blocklyWorkspaceBuilderService.getProcedureBlockName(block);
  }

  private getLibraryToolboxSnapshot(): any {
    let toolBox = this.categoryMenu.selectedCategory.id === Category.DEVICE
      ? JSON.parse(JSON.stringify(DEVICE_TOOLBOX))
      : ObjectUtil.deepClone(BlocklyToolBox);

    toolBox.contents = toolBox.contents.filter((category: any) => !this.hideBlockCategory.includes(category.name));
    if (this.categoryMenu.selectedCategory.id === Category.SYSTEM) {
      const alertBlocksToHideForCCU = ['alertWithOffset', 'alertHystersis'];
      if (!this.showAlertWithOffsetBlocks) {
        toolBox.contents = toolBox.contents.map((category: any) => {
          category.contents = category.contents.filter((block: any) => !alertBlocksToHideForCCU.includes(block.type));
          return category;
        });
      }
      this.hideDeprecatedBlocksFromToolbox(toolBox);
    }

    const targetCategoriesToHide: any = [];
    const targetBlocksToHide: any[] = [
      BlockType.SEQUENCE,
      BlockType.SEQUENCE_SYSTEM,
      BlockType.SEQUENCE_DEVICE
    ];
    targetCategoriesToHide.push('MQTT');
    if (this.categoryMenu.selectedCategory.id === Category.DEVICE) {
      targetBlocksToHide.push(BlockType.MODEL_BLOCK);
      targetCategoriesToHide.push(CustomCategory.MODEL_POINTS);
    }

    toolBox.contents = toolBox.contents
      .map((category: any) => {
        if (!category.contents || typeof category.contents !== 'object') return category;
        category.contents = category.contents.filter((block: any) => !targetBlocksToHide.includes(block.type));
        return category;
      })
      .filter((category: any) => !targetCategoriesToHide.includes(category.name));

    const categoriesToHide = ['Created by Me', 'Shared by Others'];
    categoriesToHide.forEach((categoryNameToHide: any) => {
      const targetCategoryIndex = toolBox.contents.findIndex((category: any) => category.name === categoryNameToHide);
      if (targetCategoryIndex >= 0) {
        toolBox.contents.splice(targetCategoryIndex, 1);
      }
    });

    return toolBox;
  }

  private buildSnippetFromSequencerXml(xml: string, name: string): string {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xml, 'text/xml');
    const tempWorkspace = new Blockly.Workspace();
    try {
      Blockly.Xml.domToWorkspace(xmlDoc.documentElement, tempWorkspace);

      if (this.categoryMenu.selectedCategory.id === Category.DEVICE) {
        let code = pythonGenerator.workspaceToCode(tempWorkspace);
        code = this.pythonToMicropython(code);
        return this.formatCodeForFunctionBlock(code);
      }

      let code = javascriptGenerator.workspaceToCode(tempWorkspace);
      if (this.categoryMenu.selectedCategory.id == Category.CLOUD) {
        code = `var timeFormatEnum = Java.type('io.seventyfivef.seq.enumeration.TimeFormat');\nvar dateFormatEnum = Java.type('io.seventyfivef.seq.enumeration.DateFormat');\nvar dateTimeFormatEnum = Java.type('io.seventyfivef.seq.enumeration.DateTimeFormat');\n` + code;
      }
      if (this.builderMode === BuilderMode.SEQUENCE_BUILDER) {
        code = this.formatCodeForFunctionBlock(code);
      }
      if (name) {
        const safeName = name.replaceAll(' ', '');
        code += `sequence_${safeName}()`;
      }
      return code;
    } finally {
      tempWorkspace.dispose();
    }
  }

  private validateSeqFunctionDialogInput(name: string, why: string, what: string, currentFunctionId: string = ''): string {
    const seqFunctionNameLength = 50;
    const descriptionLength = 1000;
    const forbidSplCharsAtStart = /^(?:[A-Za-z0-9]|$)+[A-Za-z0-9]*$/;
    const forbidSplCharsInString = /^(?:[A-Za-z0-9\s]+)(?:[A-Za-z0-9_\s#%]*)$/;

    if (!name || !why || !what) {
      return 'Function name, Why, and What are required.';
    }

    const existingSequenceIndex = this.sequencerFunctionCollection.findIndex((functionObj: any) =>
      functionObj.seqFunctionName?.toLowerCase() === name.toLowerCase() &&
      functionObj.functionId !== currentFunctionId
    );

    if (existingSequenceIndex >= 0) {
      return 'Sequencer function name already exists';
    }

    if (!forbidSplCharsAtStart.test(name[0])) {
      return 'Sequencer function name should not start with special characters';
    }

    if (!forbidSplCharsInString.test(name)) {
      return 'Special characters are not allowed in Sequence name. Allowed characters[underscore(_), hash(#), percentile(%), and space]`';
    }

    if (name.length > seqFunctionNameLength) {
      return `Sequencer function name should not exceed ${seqFunctionNameLength} characters`;
    }

    if (what.length > descriptionLength) {
      return `What(description) field should not exceed ${descriptionLength} characters`;
    }

    if (why.length > descriptionLength) {
      return `Why(description) field should not exceed ${descriptionLength} characters`;
    }

    return '';
  }

  private getSequenceFunctionSourceStatementInputName(block: any): string {
    if (this.isProcedureDefinitionBlock(block)) {
      return 'STACK';
    }

    if (block?.type === BlockType.SEQUENCE || block?.type === BlockType.SEQUENCE_SYSTEM) {
      return 'CODE';
    }

    return '';
  }

  private getSequenceFunctionSourceBlockName(block: any): string {
    if (this.isProcedureDefinitionBlock(block)) {
      return (block?.getFieldValue?.('NAME') || '').trim();
    }

    if (block?.type === BlockType.SEQUENCE || block?.type === BlockType.SEQUENCE_SYSTEM) {
      return (block?.getFieldValue?.('markername') || '').trim();
    }

    return '';
  }

  private getSequencerFunctionBlockType(): string {
    // Sequencer function definitions use the sequencer block across categories.
    // Kept as a helper so category-based rules can be adjusted centrally if needed.
    switch (this.categoryMenu.selectedCategory.id) {
      case Category.CLOUD:
      case Category.SYSTEM:
      case Category.DEVICE:
      default:
        return BlockType.SEQUENCER;
    }
  }

  seqFunctionActionFromFlyout(eventType: any, blockObj?: any) {
    const seqFunctionBlock = blockObj;
    if (eventType === 'edit') {
      this.isFunctionBlockClicked = true;
      this.showConfirmationDialog('edit', seqFunctionBlock);
    } else if (eventType === 'delete') {
      this.sequencerBlock = {};
      this.showConfirmationDialog('delete', seqFunctionBlock);
    } else if (eventType === 'view') {
      this.isFunctionBlockClicked = true;
      this.handleViewSequence(seqFunctionBlock);
    }
  }

  deleteSequenceFunction() {
    this.isLoading = true;
    const selectedSeqFunction = this.selectedFunctionToView;
    this.isDeletingSequenceFunction = true;
    this.siteSequencerService.deleteSequenceFunction(selectedSeqFunction.functionId, this.SequenceFunctionsComponent)
      .subscribe((res) => {
        this.showToast('success', `sequence function ${selectedSeqFunction.seqFunctionName} deleted succesfully`);
        this.toggleBuilderMode(BuilderMode.SEQUENCE_BUILDER, true);
      }, err => {
        this.isLoading = false;
        this.isDeletingSequenceFunction = false;
        this.showToast('error', err?.error && err?.error?.error ? err?.error?.error : `Something went wrong in deleting sequence function ${selectedSeqFunction.seqFunctionName} , please click delete button again.`);
      })

  }

  async duplicateSequenceFunction() {
    this.isLoading = true;
    this.isDuplicatingSequenceFunction = true;

    this.toggleWorkspace('delete'); // Deleting the existing workspace before duplicating the sequence to support readonly mode.
    await this.initializeBlockly(); // Initializing the blockly workspace to support readonly mode.
    if (!this.blocklyWorkSpace) {
      this.isDuplicatingSequenceFunction = false;
      this.isLoading = false;
      return;
    }
    this.toggleWorkspaceReadOnlyMode(false); // Making the workspace editable after duplicating the sequence function.
    await this.toggleWorkspace('create'); // creating and populating the blocks in to the workspace.

    const allBlocks = this.blocklyWorkSpace.getAllBlocks(true);
    this.isLoading = true;
    if (allBlocks.length <= 0) {
      this.isDuplicatingSequenceFunction = false;
      this.showToast('error', 'Add a sequencer block to canvas to create a sequencer function');
      this.isLoading = false;
      return;
    }
    const isSequencesValid = this.checkAndReturnErrorStatus();
    if (isSequencesValid) {
      const allBlocks = this.blocklyWorkSpace.getAllBlocks(true);
      const sequencerBlock = allBlocks.find((blockObj: any) => blockObj.type === BlockType.SEQUENCER &&
        blockObj.getFieldValue('functionId') === this.sequencerBlock.functionId);
      const targetBlockInWorkspace = this.blocklyWorkSpace.getBlockById(sequencerBlock.id);

      if (targetBlockInWorkspace) {
        const functionName = this.getUniqueValueWithCopySuffix(sequencerBlock.getFieldValue('seqFunctionName'), 'seqFunctionName', this.sequencerFunctionCollection);
        targetBlockInWorkspace.setFieldValue(functionName, 'seqFunctionName');
        this.defaultTabLabel = functionName;
        this.functionIdForDuplication = targetBlockInWorkspace.getFieldValue('functionId'); // Storing the functionId of the function for duplication before resetting it to empty string.
        targetBlockInWorkspace.setFieldValue('', 'functionId');
        this.updateSequencerBlockConfig(targetBlockInWorkspace);
        // Passing Component in the payload to save the sequence function.
        const payload = JSON.parse(JSON.stringify(this.sequencerBlock));
        payload['component'] = this.SequenceFunctionsComponent;
        if (this.isDuplicatingSequenceFunction) {
          payload['parentComponentId'] = this.functionIdForDuplication;
        }
        this.siteSequencerService.saveSequenceFunction(payload)
          .subscribe((res) => {
            if (res && res.functionId) {
              targetBlockInWorkspace.setFieldValue(res.functionId, 'functionId');
              this.updateAlertBlockInSeqFunction(targetBlockInWorkspace, res.functionId); // Adding data property Updating the alert block IDs of the duplicated sequence with the obtained functionId followed by underscore (_) and unique number.
              this.updateSequencerBlockConfig(targetBlockInWorkspace);
              this.saveAndUpdateSequenceFunction(true);
              this.functionIdForDuplication = null;
              this.toggleWorkspaceReadOnlyMode(false); // Making the workspace editable after duplicating the sequence function.
              this.showToast('success', `Sequence function ${this.sequencerBlock.seqFunctionName} created successfully.`);
              this.confettiService.launchConfetti();
              this.isLoading = false;

            } else {
              this.isLoading = false;
              this.isDuplicatingSequenceFunction = false;
              this.showToast('error', `Something went wrong in creating ${this.sequencerBlock.seqFunctionName} as a new sequence, please click the 'Create as new sequence button' again.`);
            }
          }, err => {
            this.isLoading = false;
            this.isDuplicatingSequenceFunction = false;
            this.showToast('error', err?.error && err?.error?.error ? err?.error?.error : `Something went wrong in creating ${this.sequencerBlock.seqFunctionName} as a new sequence, please click the 'Create as new sequence button' again.`);
          });

      } else {
        this.isLoading = false;
      }
    }
  }

  /**
  * Method to set the readOnly mode of the workspace, and hide the toolbox along with toolbox toggle button.
  * @param isReadOnly - boolean value to set the readOnly mode of the workspace.
  */
  toggleWorkspaceReadOnlyMode(isReadOnly: boolean) {
    this.showHideToolBox(!isReadOnly); // Making toolbox hidden in readOnly Mode and visible in edit mode.
    this.showToolBoxToggleButton = !isReadOnly; //Hiding show toolbox button hidden in readOnly Mode.
    this.blocklyWorkSpace.options.readOnly = isReadOnly;
  }

  /**
   * Update the alert block Ids with functionId when duplicating a sequence function.
   * 
   * @param targetBlock - sequencer block (sequence function block) object to retrieve the alert blocks.
   * @param seqFunctionId - sequence function id to create unique id for the alert block and save it in data property.
   */
  updateAlertBlockInSeqFunction(targetBlock: any, seqFunctionId: any) {
    const allBlocksOfSequence = targetBlock.getDescendants('ordered');
    // Retrieving the alert blocks (blocks with type alertWithRef) from the child blocks of the sequence block.
    const alertBlocks = allBlocksOfSequence ?
      allBlocksOfSequence.filter((blockObj: any) => blockObj.type.includes('alertWithRef')) : [];
    if (alertBlocks.length) {
      const uniqueAlertIds: any[] = [];
      alertBlocks.forEach((alertBlock: any) => {
        // Generate a unique ID for each alert block by appending an underscore (_) and incrementing the number by 1 to the functionId (seqFunctionId).
        let updatedAlertId = `${seqFunctionId}_${uniqueAlertIds.length + 1}`;
        while (uniqueAlertIds.includes(updatedAlertId)) {
          updatedAlertId = `${seqFunctionId}_${uniqueAlertIds.length + 1}`;
        }
        uniqueAlertIds.push(updatedAlertId);
        // Saving the updated alertId in the data property of the block.
        // (Block.data property - Optional text data that round-trips between blocks and XML. Has no effect. May be used by 3rd parties for meta information.)       
        this.blocklyWorkSpace.getBlockById(alertBlock.id).data = updatedAlertId;
      });
    }
  }

  createUniqueValueForKey(valueToChange: any, targetKey: any, collection: any, seperator?: string) {
    // Check if the passed value string already exists in the provided collection.
    let existingValue = collection.find((item: any) => item[targetKey] === valueToChange);
    // If the value is unique, return the value as is.
    if (!existingValue) {
      return valueToChange;
    }

    let number = 1;
    let formattedValue = seperator ? `${valueToChange}${seperator}${number}` : `${valueToChange}_${number}`

    // Check if the formatted string already exists in the provided collection.
    let existingItem = collection.find((item: any) => item[targetKey] === formattedValue);

    // If the formatted string already exists, append a number and increment until it's unique.
    while (existingItem) {
      number++;
      formattedValue = seperator ? `${valueToChange}${seperator}${number}` : `${valueToChange}_${number}`
      existingItem = collection.find((item: any) => item[targetKey] === formattedValue);
    }
    return formattedValue;
  }

  getUniqueValueWithCopySuffix(valueToChange: any, targetKey: any, collection: any) {
    let number = 2;
    const formattedBaseValue = `${valueToChange}_copy`;
    let formattedValue: any = formattedBaseValue;
    let existingItem = collection.find((item: any) => item[targetKey] === formattedValue);
    while (existingItem) {
      formattedValue = `${formattedBaseValue}${number}`;
      existingItem = collection.find((item: any) => item[targetKey] === formattedValue);
      number++;
    }
    return formattedValue;
  }

  saveAndUpdateSequenceFunction(skipToggleBuilderMode?: boolean, isCreate?: boolean) {
    this.isLoading = true;
    const allBlocks = this.blocklyWorkSpace.getAllBlocks(true);
    if (allBlocks.length > 0) {
      const isSequencesValid = this.checkAndReturnErrorStatus();
      if (isSequencesValid) {
        const sequencerBlock = allBlocks.find((blockObj: any) => blockObj.type === BlockType.SEQUENCER &&
          blockObj.getFieldValue('functionId') === this.sequencerBlock.functionId);
        if (sequencerBlock) {
          this.updateSequencerBlockConfig(sequencerBlock);
          // Passing Component in the payload to save the sequence function.
          const payload = JSON.parse(JSON.stringify(this.sequencerBlock));
          payload['component'] = this.SequenceFunctionsComponent;
          // Adding parentComponentId in the payload if the sequence function is created by duplicating an existing sequence function.
          if (this.isDuplicatingSequenceFunction && this.functionIdForDuplication) {
            payload['parentComponentId'] = this.functionIdForDuplication;
          }
          this.siteSequencerService.updateSequenceFunction(this.sequencerBlock.functionId, payload)
            .subscribe((res: any) => {
              if (res) {
                if (!skipToggleBuilderMode) {
                  this.showToast('success', `sequence function ${this.sequencerBlock.seqFunctionName} saved succesfully`);
                  if (isCreate) this.confettiService.launchConfetti();
                  this.isLoading = false;
                  //A small delay introduced to display the toast message before switching back to sequence builder mode.
                  setTimeout(() => {
                    this.toggleBuilderMode(BuilderMode.SEQUENCE_BUILDER);
                  }, 1000);
                }
              } else {
                this.isLoading = false;
                this.showToast('error', `Something went wrong in saving the sequence function, please try again.`);
              }
            }, (err) => {
              this.isLoading = false;
              this.showToast('error', err?.error && err?.error?.error ? err?.error?.error : `Something went wrong, please try again.`);
            });
        } else {
          this.isLoading = false;
          this.showToast('error', 'Add a sequencer block to canvas to create a sequencer function');
        }
      } else {
        // Validation already shows toast; ensure loader is stopped for invalid blocks.
        this.isLoading = false;
      }
    } else {
      this.isLoading = false;
      this.showToast('error', 'Add a sequencer block to canvas to create a sequencer function');
    }
  }

  updateSequencerBlockConfig(block: any) {
    this.sequencerBlock.seqFunctionName = block.getFieldValue('seqFunctionName');
    this.sequencerBlock.functionId = block.getFieldValue('functionId');
    this.sequencerBlock.why = block.getFieldValue('why');
    this.sequencerBlock.what = block.getFieldValue('what');
    this.sequencerBlock.xml = this.parseXMLForSequence(block);
    this.sequencerBlock.snippet = this.getJSCodeForSequence(block, '');
    this.activeSequencerBlockRef = block.id;

    this.selectedFunctionToView = JSON.parse(JSON.stringify(this.sequencerBlock));
    this.selectedFunctionToView.category = this.categories.CREATED_BY_ME;
  }

  /**
   * Method to get the selected scope ids of a sequence as array.
   * @param targetBlock - The target block to get the selected scope ids from.
   * @returns 
   */
  getSelectedScopeIdsOfSequence(targetBlock: any) {
    const sequenceScope = targetBlock.getFieldValue('selectedScopeValue');
    if (sequenceScope && sequenceScope.length > 0) {
      const result = sequenceScope.split(',');
      return result;
    } else {
      return [null];
    }
  }

  /**
   * Saves all sequences in the site sequencer component.
   * 
   * @param isDeletingWorkspace - Optional parameter to indicate if the workspace is being deleted.
   * @param isDryRunSelected - Optional parameter to indicate if dry run is selected.
   * If no changes in the workspace, it will not trigger the API call.
   */
  async saveAllSequences(isDeletingWorkspace?: boolean, isDryRunSelected?: boolean) {
    this.isLoading = true;
    const allBlocks = this.blocklyWorkSpace?.getAllBlocks();
    const sequenceBlocks = allBlocks.filter((blockObj: any) => this.sequenceBlockType.includes(blockObj.type));
    const payload: any[] = [];
    let quartzCronRequest: any;
    const isSequencesBlocksExists = this.categoryMenu.selectedCategory.id === Category.DEVICE ? true : sequenceBlocks.length > 0;
    if ((this.sequences && this.sequences?.length > 0 && isSequencesBlocksExists) || !this.noChangesInWorkspace) {
      this.sequences.forEach((seqObj: any) => {
        let targetBlock: any = null;
        seqObj['frequency'] ? quartzCronRequest = this.getQuartzCronRequestValue(seqObj) : '';
        if (this.categoryMenu.selectedCategory.id !== Category.DEVICE) {
          const targetBlockArray = sequenceBlocks.filter((blockObj: any) => blockObj.getFieldValue('sequenceId') == seqObj.seqId);
          targetBlock = targetBlockArray[0];
          const isEnabled = (targetBlock.getFieldValue('RUN_STATUS') == SequenceStatus.ENABLE || targetBlock.getFieldValue('RUN_STATUS') == SequenceStatus.ENABLE_WITH_LOGS) ? true : false;
          seqObj['isEnabled'] = isEnabled;
          seqObj['logsEnabled'] = (targetBlock.getFieldValue('RUN_STATUS') == SequenceStatus.ENABLE_WITH_LOGS) ? true : false;
          seqObj['frequency'] = targetBlock.getFieldValue('Occurance');
          seqObj['blocklyXml'] = this.parseXMLForSequence(targetBlock);
          seqObj['snippet'] = this.getJSCodeForSequence(targetBlock, seqObj['seqName']);
          seqObj['alertBlocks'] = this.getAlertBlocksIdsOfSequence(targetBlock);
          seqObj['functionIds'] = this.getFunctionIdsOfSequence(targetBlock);
        } else {
          // Device category treats the whole workspace as a single sequence.
          seqObj['functionIds'] = this.getFunctionIdsOfSequence();
        }
        let formattedObj: any = {
          'seqId': seqObj['seqId'],
          "workspaceId": this.canvasTabs.selectedCanvasTab?.id,
          'siteRef': this.selectedSiteId,
          'seqName': this.getSequenceName(seqObj['seqName']),
          'blocklyXml': this.parseXMLForSequence(targetBlock),
          'snippet': this.getJSCodeForSequence(targetBlock, seqObj['seqName']) || '',
          "quartzCronRequest": quartzCronRequest,
          'enabled': seqObj['isEnabled'],
          'logsEnabled': seqObj['logsEnabled'],
          'functionIds': seqObj['functionIds'] || [],
          'category': this.categoryMenu.selectedCategory.id,
        };

        (seqObj['alertBlocks']?.length) ? formattedObj['seqAlerts'] = seqObj['alertBlocks'] : '';
        if (this.categoryMenu.selectedCategory.id === Category.CLOUD) {
          const mqttConfig = this.getMQTTConfigFromSequence(seqObj);
          if (Object.keys(mqttConfig).length > 0) {
            formattedObj['mqttConfig'] = mqttConfig;
            formattedObj['eventBasedExecution'] = true;
            delete formattedObj['quartzCronRequest'];
          }
        }
        if (this.categoryMenu.selectedCategory.id === Category.SYSTEM) {
          formattedObj['scope'] = this.getSelectedScopeIdsOfSequence(targetBlock);
          seqObj['scope'] = formattedObj['scope'];
        }
        // Adding metadata for models in the payload if the category is device and if there are valid model blocks in the workspace.
        if (this.categoryMenu.selectedCategory.id === Category.DEVICE) {
          this.syncPointBlocksWithSelectedModels();
          formattedObj['metadata'] = this.formatMetaDataForModels(this.createdPointsCollection) || [];

        }
        payload.push(formattedObj);
      });
      try {
        const res: any = await lastValueFrom(this.updateAllSequences(payload))

        const savedMetadata = payload[0]?.metadata ?? [];
        this.noChangesInWorkspace = true;
        if (!isDeletingWorkspace) {
          // Saving Workspace XML
          const isSavingAllSequences = true;
          this.saveWorkspaceXML(isSavingAllSequences);
          // If the selected category is DEVICE, updating the saved metadata.
          if (res && res.length && this.categoryMenu.selectedCategory.id === Category.DEVICE) {
            this.modelOptions = savedMetadata;
          }
          if (isDryRunSelected) {
            this.triggerSequenceDryRun();
          }

        } else {
          this.showToast('success', `Workspace saved successfully`);
          this.isLoading = false;
        }
      } catch (err: any) {
        this.isLoading = false;
        this.showToast('error', `${err.error && err.error.error ? err.error.error : err.message}`);
        this.noChangesInWorkspace = false;

      }
    } else {
      this.isLoading = false;
    }
  }

  /**
   *  Method to toggle the workspace error message based on the sequence applied to devices and sequence last updated date time.
   */
  toggleWorkspaceErrorMessage() {
    this.pushToDeviceService.getDeviceHierarchy(this.selectedSiteId, this.sequences[0]?.seqId)
      .subscribe((data: any) => {
        if (data && data.ccuList && Array.isArray(data.ccuList) && data.ccuList.length > 0) {
          const isSequenceAppliedToDevice = data?.ccuList?.some((ccu: any) =>
            ccu.rooms?.some((room: any) =>
              room.devices?.some((device: any) => device.appliedSeqId === this.sequences[0]?.seqId)
            )
          );


          if (isSequenceAppliedToDevice && data.appliedDate && this.sequenceLastUpdatedTime) {
            const appliedDate = data.appliedDate.split('.')[0];
            const sequenceUpdatedTime = this.sequenceLastUpdatedTime.split('.')[0];
            this.showWorkspaceWarningText = new Date(sequenceUpdatedTime) > new Date(appliedDate);
          } else {
            this.showWorkspaceWarningText = false;
          }
        } else {
          this.showWorkspaceWarningText = false;
        }
      });
  }

  /**
   * Method to format metadata for models from the created points collection.
   * @param points - Array of points to format metadata for models.
   */
  formatMetaDataForModels(points: any[]) {

    // sort by port to keep workspace order
    const ordered = points.slice().sort((a, b) => a.port - b.port);

    const counter: { [modelId: string]: number } = {};  // how many times we met a baseId
    let current: any = null;
    const out: any[] = [];


    ordered.forEach(pt => {
      const baseId = pt.modalId.replace(/_\d+$/, '');   // remove any suffix like _1, _2, to get the base model ID
      const version = pt.modelVersion;

      /* do we need a new block?  */
      const needNew =
        !current ||
        current.baseId !== baseId || // new model
        current.version !== version || // new version
        current.domains[pt.domain] === true; // domain already used in this block

      if (needNew) {
        const count = counter[baseId] || 0;
        counter[baseId] = count + 1;

        current = {
          baseId,
          version,
          domains: {},
          block: {
            modelId: count === 0 ? baseId : `${baseId}_${count}`,
            modelName: pt.modalName,
            modelVersion: version,
            points: []
          }
        };
        out.push(current.block);
      }

      /* register domain so a duplicate triggers a new block later */
      current.domains[pt.domain] = true;

      /* push point */
      current.block.points.push({
        pointId: pt.id,
        pointName: pt.name,
        registerAddress: String(pt.port),
        domainName: pt.domain,
        defaultValue: pt.defaultValue ?? null
      });
    });

    // Adding models with zero points
    const validModelBlocksInWorkspace = this.blocklyWorkSpace.getAllBlocks(true).filter(
      (blockObj: any) => blockObj.type === BlockType.MODEL_BLOCK && blockObj.getFieldValue(BlockFieldName.SELECTED_MODEL) !== 'DEFAULT_MODAL'
    );

    const modelWithZeroPoints: any = []
    validModelBlocksInWorkspace.forEach((modelBlock: any) => {
      const modelId = modelBlock.getFieldValue(BlockFieldName.SELECTED_MODEL);
      const version = modelBlock.getFieldValue('modelVersion')
      if (!out.some((model: any) => modelId == model.modelId.replace(/_\d+$/, ''))) {
        modelWithZeroPoints.push({
          modelId: modelId,
          modelName: modelBlock.getField('selected_model').selectedOption?.[0].replace(`(v ${version})`, '')?.trim(),
          modelVersion: version,
          points: []
        })
      }
    })

    modelWithZeroPoints.forEach((model: any) => {
      const length = out.filter((model: any) => model.modelId.replace(/_\d+$/, '') == model.modelId).length;
      out.push({
        modelId: length == 0 ? model.modelId : `${model.modelId}_${length}`,
        modelName: model.modelName,
        modelVersion: model.modelVersion,
        points: []
      })
    })

    return out;
  }

  getSequenceName(sequenceName: string) {
    if (this.categoryMenu.selectedCategory.id === Category.DEVICE) {
      return this.canvasTabs.selectedCanvasTab?.name
    }
    return sequenceName;
  }

  /**
   * Method to get the MQTT config for a sequence.
   * @param sequenceObj : sequence object to get the MQTT config 
   * @returns MQTT config object with brokerUrl, clientId, topic, username, and password.
   */
  getMQTTConfigFromSequence(sequenceObj: any) {
    const subscribeBlockKeys = ['brokerUrl', 'topic', 'username', 'password'];
    const mqttConfig: any = {};
    subscribeBlockKeys.forEach((key: any) => {
      sequenceObj[key] ? mqttConfig[key] = sequenceObj[key] : '';
    });
    const hasAllKeys = subscribeBlockKeys.every(key => key in mqttConfig);
    return hasAllKeys ? mqttConfig : {};
  }

  /**
   * Retrieves the alert block IDs of a sequence.
   * 
   * @param targetBlock - The target block to retrieve the alert block IDs from.
   * @returns An array of alert objects containing the alert block ID, type, title, message, notification message, severity, and enabled status.
   */
  getAlertBlocksIdsOfSequence(targetBlock: any) {
    const childBlocksOfSequence = targetBlock?.getDescendants?.('ordered') || [];
    const seqAlerts: any[] = [];
    const alertBlockTypes = ['alert', 'alertWithRef', 'alertWithOffset', 'alertHystersis'];

    // Collect alerts from sequence blocks and from all dependent procedures (including nested calls).
    const procedureDependencyBlocks = this.getProcedureDependencyBlocks(targetBlock) || [];
    const procedureBlocksToScan = procedureDependencyBlocks.flatMap((procedureBlock: any) => [
      procedureBlock,
      ...(procedureBlock?.getDescendants?.(true) || [])
    ]);

    const allCandidateBlocks = [...childBlocksOfSequence, ...procedureBlocksToScan];
    const alertBlocks = allCandidateBlocks.filter((blockObj: any) =>
      blockObj?.id && alertBlockTypes.includes(blockObj.type)
    );

    const uniqueAlertBlocks = Array.from(
      new Map(alertBlocks.map((alertBlockObj: any) => [alertBlockObj.id, alertBlockObj])).values()
    );

    uniqueAlertBlocks.forEach((alertBlockObj: any) => {
      const alertObj = this.getAlertDef(alertBlockObj);
      const alertBlockId = alertObj?.alertBlockId;
      const alertAlreadyExist = seqAlerts.some((seqAlert: any) => seqAlert?.alertBlockId === alertBlockId);
      if (alertBlockId && !alertAlreadyExist) {
        seqAlerts.push(alertObj);
      }
    });

    return seqAlerts;
  }

  getAlertDef(alertBlockObj: any) {
    const defaultAlertConfig = {
      "alertBlockId": alertBlockObj.id,
      "alertType": alertBlockObj.getFieldValue('ALERT_TYPE'),
      "title": alertBlockObj.getFieldValue('ALERT_TITLE'),
      "message": javascriptGenerator.valueToCode(alertBlockObj, 'ALERT_MESSAGE', javascriptGenerator.ORDER_MEMBER) || '',
      "notificationMessage": javascriptGenerator.valueToCode(alertBlockObj, 'ALERT_NOTIFICATION_MESSAGE', javascriptGenerator.ORDER_MEMBER) || '',
      "severity": alertBlockObj.getFieldValue('ALERT_SEVERITY'),
      "enabled": true
    }
    const configWithOffsetValues: any = {};
    if (alertBlockObj.type === 'alert') {
      // Return the default alert configuration if the alert block type is 'alert'
      defaultAlertConfig['message'] = alertBlockObj.getFieldValue('ALERT_MESSAGE');
      defaultAlertConfig['notificationMessage'] = alertBlockObj.getFieldValue('ALERT_NOTIFICATION_MESSAGE');
      return defaultAlertConfig;
    } else if (alertBlockObj.type === 'alertWithOffset') {
      configWithOffsetValues['alertBlockType'] = 'ALERT_BLOCK_OFFSET';
      configWithOffsetValues['offsetLimitDto'] = {
        // 'triggerOffset': javascriptGenerator.valueToCode(alertBlockObj,'ALERT_TRIGGER_OFFSET', javascriptGenerator.ORDER_MEMBER) || 0,
        // 'fixOffset': javascriptGenerator.valueToCode(alertBlockObj,'ALERT_FIX_OFFSET', javascriptGenerator.ORDER_MEMBER) || 0
        'triggerOffset': alertBlockObj.getFieldValue('ALERT_TRIGGER_OFFSET') || 0,
        'fixOffset': alertBlockObj.getFieldValue('ALERT_FIX_OFFSET') || 0
      };
      // Return the alert configuration with alert blockType and offset values if the alert block type is 'alertWithOffset'
      return {
        ...defaultAlertConfig,
        ...configWithOffsetValues
      };
    } else if (alertBlockObj.type === 'alertHystersis') {
      configWithOffsetValues['alertBlockType'] = 'ALERT_BLOCK_OFFSET_WITH_LIMIT';
      configWithOffsetValues['offsetLimitDto'] = {
        'upperLimitEnabled': alertBlockObj.getFieldValue('SHOW_UPPER_LIMIT') === 'YES' ? true : false,
        'lowerLimitEnabled': alertBlockObj.getFieldValue('SHOW_LOWER_LIMIT') === 'YES' ? true : false
      }
      // Adding upperLimitTriggerOffset and upperLimitFixOffset to the offsetLimitDto object if the upper limit is enabled.
      if (configWithOffsetValues['offsetLimitDto']['upperLimitEnabled']) {
        configWithOffsetValues['offsetLimitDto']['upperLimitTriggerOffset'] = alertBlockObj.getFieldValue('ALERT_TRIGGER_UPPER_LIMIT_OFFSET') || 0;
        configWithOffsetValues['offsetLimitDto']['upperLimitFixOffset'] = alertBlockObj.getFieldValue('ALERT_FIX_UPPER_LIMIT_OFFSET') || 0;
      }
      // Adding lowerLimitTriggerOffset and lowerLimitFixOffset to the offsetLimitDto object if the lower limit is enabled.
      if (configWithOffsetValues['offsetLimitDto']['lowerLimitEnabled']) {
        configWithOffsetValues['offsetLimitDto']['lowerLimitTriggerOffset'] = alertBlockObj.getFieldValue('ALERT_TRIGGER_LOWER_LIMIT_OFFSET') || 0;
        configWithOffsetValues['offsetLimitDto']['lowerLimitFixOffset'] = alertBlockObj.getFieldValue('ALERT_FIX_LOWER_LIMIT_OFFSET') || 0;
      }
      // Return the alert configuration with alert blockType and offset values if the alert block type is 'alertHystersis'
      return {
        ...defaultAlertConfig,
        ...configWithOffsetValues
      };
    } else {
      return defaultAlertConfig;
    }
  }

  /**
   * Retrieves the functionId from the function blocks of a sequence.
   * @param {any} rootBlock optional - Optional parameter indicates the root block which contains the function blocks as child blocks.
   * @returns An array of function IDs.
   */
  getFunctionIdsOfSequence(rootBlock?: any) {
    const isFunctionsInsideRootBlocks = rootBlock ? true : false;
    const uniqueFunctionIds = new Set<string>();
    const allBlocksOfSequence = isFunctionsInsideRootBlocks ? rootBlock.getDescendants('ordered') : this.blocklyWorkSpace.getAllBlocks(true);

    // Include function blocks from called procedures as well so nested usages are captured.
    const procedureDependencyBlocks = rootBlock ? this.getProcedureDependencyBlocks(rootBlock) : [];
    const procedureBlocksToScan = (procedureDependencyBlocks || []).flatMap((procedureBlock: any) => [
      procedureBlock,
      ...(procedureBlock?.getDescendants?.(true) || [])
    ]);

    const allCandidateBlocks = [...(allBlocksOfSequence || []), ...procedureBlocksToScan];
    const functionBlocks = allCandidateBlocks.filter((blockObj: any) => !!blockObj?.type);

    if (functionBlocks.length) {
      // Collect function ids from miniature fn_ blocks and procedure blocks with metadata.
      functionBlocks.forEach((functionBlockObj: any) => {
        const blockType = functionBlockObj?.type || '';

        // Miniature function blocks (legacy/current generator path).
        if (blockType.includes('fn_')) {
          const functionBlockId = (functionBlockObj.getFieldValue?.('functionId') || '').trim();
          if (functionBlockId) {
            uniqueFunctionIds.add(functionBlockId);
          }
        }

        // Procedure call/definition blocks created via drag-drop flow store function info in block.data.
        if (blockType === 'procedures_defnoreturn' || blockType === 'procedures_defreturn'
          || blockType === 'procedures_callnoreturn' || blockType === 'procedures_callreturn') {
          const procedureMetadata = this.getProcedureLibraryMetadata(functionBlockObj);
          const functionId = (procedureMetadata?.functionId || '').trim();
          const sourceFunctionId = (procedureMetadata?.sourceFunctionId || '').trim();

          if (functionId) {
            uniqueFunctionIds.add(functionId);
          } else if (sourceFunctionId) {
            uniqueFunctionIds.add(sourceFunctionId);
          }

          // Fallback for any legacy blocks where functionId may still be in a field.
          const functionIdFromField = (functionBlockObj.getFieldValue?.('functionId') || '').trim();
          if (functionIdFromField) {
            uniqueFunctionIds.add(functionIdFromField);
          }
        }
      })
    }
    return Array.from(uniqueFunctionIds);
  }

  /**
   * Parses the given block into an XML string representation.
   * 
   * @param block - The block to parse.
   * @returns The XML string representation of the block.
  */
  parseXMLForSequence(block?: any, isWorkspaceXmlRequired?: boolean) {
    const isDeviceCategorySelected = this.categoryMenu.selectedCategory.id === Category.DEVICE &&
      this.builderMode === BuilderMode.SEQUENCE_BUILDER;

    // Use workspaceToDom for the entire workspace XML when the selected category is "device" or no block is provided.
    // Otherwise, use blockToDom to get the XML for a specific block.
    const xmlDom = isDeviceCategorySelected || !block ?
      Blockly.Xml.workspaceToDom(this.blocklyWorkSpace) :
      Blockly.Xml.blockToDom(block);

    // Generate formatted XML using domToPrettyText for "device" category or a specific block.
    // Use serializeToString for raw XML in other cases.
    let xmlText = block ?
      Blockly.Xml.domToPrettyText(xmlDom) :
      new XMLSerializer().serializeToString(xmlDom);

    xmlText = xmlText
      .replace(/deletable="false"/g, 'deletable="true"')
      .replace(/movable="false"/g, 'movable="true"')
      .replace(/editable="false"/g, 'editable="true"');

    return xmlText;
  }

  /**
   * Generates JavaScript code for a sequence.
   * @param block The block to generate code from.
   * @param name The name of the sequence.
   * @returns The generated JavaScript code.
   */
  getJSCodeForSequence(block: any, name: any) {
    let code = "";
    if (this.categoryMenu.selectedCategory.id !== Category.DEVICE) {
      code = javascriptGenerator.workspaceToCode(this.blocklyWorkSpace)
      if (this.categoryMenu.selectedCategory.id == Category.CLOUD) {
        code = `var timeFormatEnum = Java.type('io.seventyfivef.seq.enumeration.TimeFormat');\nvar dateFormatEnum = Java.type('io.seventyfivef.seq.enumeration.DateFormat');\nvar dateTimeFormatEnum = Java.type('io.seventyfivef.seq.enumeration.DateTimeFormat');\n` + code;
      }
      // Formatting the code if any function blocks are added to the canvas.
      if (this.builderMode === BuilderMode.SEQUENCE_BUILDER) {
        code = this.formatCodeForFunctionBlock(code);
      }
      if (name && this.categoryMenu.selectedCategory.id !== Category.DEVICE) {
        name = name.replaceAll(' ', '');
        code += `sequence_${name}()`
      }
    } else {

      this.validateBlocklyLogic();
      code = this.code;
    }

    return code;
  }

  /**
   * Retrieves the block into view based on the provided breadcrumb and sequence block flag.
   * @param breadcrumb - The breadcrumb object containing the sequence ID and block ID.
   * @param isSequenceBlock - A boolean flag indicating whether the block is a sequence block.
   */
  getBlockIntoView(breadcrumb: any, isSequenceBlock: boolean) {
    if (breadcrumb) {
      const allBlocks = this.blocklyWorkSpace.getAllBlocks(true);
      let targetSequenceBlocks = [];
      targetSequenceBlocks = allBlocks.filter((blockObj: any) => {
        return isSequenceBlock ? (this.sequenceBlockType.includes(blockObj.type) && blockObj.getFieldValue('sequenceId') === breadcrumb.seqId) :
          blockObj.id === breadcrumb.id;
      });
      if (targetSequenceBlocks.length > 0) {
        const block = targetSequenceBlocks[0];
        block.select();
        if (isSequenceBlock) {
          const metrics = this.blocklyWorkSpace.getMetrics(); // Getting the metrics of the workspace
          const blockXYCords = block.getRelativeToSurfaceXY();  // Scroll the workspace so that the block's top left corner
          this.blocklyWorkSpace.scrollbar.set(blockXYCords.x * this.blocklyWorkSpace.scale - metrics.contentLeft + (metrics.viewWidth * 0.25), blockXYCords.y * this.blocklyWorkSpace.scale - metrics.contentTop + (metrics.viewHeight * 0.2));
        } else {
          this.blocklyWorkSpace.centerOnBlock(block.id);
        }
      }
    }
  }

  /**
   * Toggles the builder mode of the site sequencer component.
   * @param selectedbuilderMode The selected builder mode.
   */
  toggleBuilderMode(selectedbuilderMode: any, skipValidationCheck?: boolean) {
    this.previousMode = this.builderMode;
    const isSequencesValid = skipValidationCheck ? true : this.checkAndReturnErrorStatus();
    // Switching the builder only if all the blocks are valid.
    if (isSequencesValid) {
      this.isLoading = true;
      // Restricting the cross tab copy functionality.
      const blocklyStash = localStorage.getItem('blocklyStash');
      // Saving the copy of blocklyStash in copy_blocklyStash when switching from sequence builder to library builder.
      // (to avoid the loss of blocklyStash in localstorage, when switching back to sequence builder as blocklyStash will be cleared when re-initializing the workspace)
      if (blocklyStash !== null) {
        localStorage.setItem('copy_blocklyStash', blocklyStash);
      }
      if (this.previousMode === BuilderMode.SEQUENCE_BUILDER && !this.noChangesInWorkspace) {  // If switching from sequence builder
        this.saveWorkspaceXML();
        this.saveAllSequences(true);
      } else if (this.previousMode === BuilderMode.LIBRARY_BUILDER) { // If switching from Library builder
        this.resetLibraryBuilder();
      }
      this.toggleWorkspace('delete'); // Deleting the existing workspace
      setTimeout(() => {
        this.builderMode = selectedbuilderMode; // Setting the builder mode
        if (this.previousMode === BuilderMode.SEQUENCE_BUILDER) {
          this.initializeBlockly();
          this.toggleWorkspace('create'); // Re-initializing the workspace
        } else if (this.previousMode === BuilderMode.LIBRARY_BUILDER) {
          this.previousMode = BuilderMode.SEQUENCE_BUILDER;
          const selectedCategoryTabConfig = { 'index': this.categoryMenu.activeTabIndex, tab: { 'textLabel': this.categoryMenu.selectedCategory.label } };
          this.toggleCategoryLevelTab(selectedCategoryTabConfig, true);
        }
        // When switcing from library builder to sequence builder, saving the copy_blocklyStash to blocklyStash.
        const copy_blocklyStash = localStorage.getItem('copy_blocklyStash');
        if (copy_blocklyStash) {
          localStorage.setItem('blocklyStash', copy_blocklyStash);
          localStorage.removeItem('copy_blocklyStash');
        }
      }, 500);
    } else {
      this.sequencerBlock = null;
      this.selectedFunctionToView = null;
    }

  }

  handleViewSequence(targetBlock: any, isDoubleClickEventTriggered?: boolean) {
    if (this.isFunctionBlockClicked) {
      this.selectedFunctionToView = this.getHydratedSequenceFunction(targetBlock);
      if (isDoubleClickEventTriggered && this.isSequenceFunctionCreatedByLoggedInUser(this.selectedFunctionToView)) {
        this.seqFunctionActionFromFlyout('edit', targetBlock);
      } else {
        this.toggleBuilderMode(BuilderMode.LIBRARY_BUILDER);
        setTimeout(() => {
          this.isFunctionBlockClicked = false;
        }, 500);
      }
    }
  }

  private getHydratedSequenceFunction(targetBlock: any): any {
    if (!targetBlock?.functionId) {
      return targetBlock;
    }

    const savedFunction = (this.sequencerFunctionCollection || []).find((functionObj: any) => functionObj?.functionId === targetBlock.functionId);
    if (!savedFunction) {
      return targetBlock;
    }

    return this.mergeSequenceFunctionWithExisting(targetBlock, new Map([[targetBlock.functionId, savedFunction]]), savedFunction.category || targetBlock.category);
  }

  enableEditSequence() {
    this.blocklyWorkSpace.getToolbox()?.setVisible(true); //Making toolbox viewable in edit Mode.
    this.showToolBoxToggleButton = true; //Hiding show toolbox button viewable in edit Mode.
    this.blocklyWorkSpace.options.readOnly = false;
  }

  // Getter for checking with category and making the workspace readOnly or vice-versa
  // Making the workspace readOnly when the selected function is shared by others.
  get isWorkspaceReadOnly() {
    return !!this.selectedFunctionToView &&
      !this.isSequenceFunctionCreatedByLoggedInUser(this.selectedFunctionToView) &&
      !this.isDuplicatingSequenceFunction &&
      !this.isBuildingNewSequenceFunction;
  }

  resetLibraryBuilder() {
    this.sequencerBlock = null;
    this.selectedFunctionToView = null;
    this.isBuildingNewSequenceFunction = false;
    this.isDuplicatingSequenceFunction = false;
    this.isDeletingSequenceFunction = false;
    this.activeSequencerBlockRef = null;
    this.sequencerBlock = null;
    this.isFunctionBlockClicked = false;
  }

  clearFilterSearch() {
    this.aiSearchRequestId++;
    this.customBlocksSearchText = '';
    this.recommendedAIItems = [];
    this.isAISearchLoading = false;
    this.isAISearchActive = false;
    this.dropdownFunctionsList.createdByMeFunctions = ObjectUtil.deepClone(this.duplicateFunctionBlock.createdByMeFunctions);
    this.dropdownFunctionsList.createdByOtherFunctions = ObjectUtil.deepClone(this.duplicateFunctionBlock.createdByOtherFunctions);
    this.buildVirtualFunctionsList();
  }

  onQuickFiltersChange(selectedFilters: QuickFilterKey[]) {
    this.selectedQuickFilters = selectedFilters;
    this.setUpdatedFunctionsBlockData();
  }

  onOptionHover(item: any, fromAIItem: boolean) {
    this.enableTableEdit = true;
    this.hoveredFunctionBlock = item;
    this.hoveredOnRecommendedItem = fromAIItem;
    // If the tooltip is already showing for the same item, exiting the method to avoid resetting the tooltip.
    if (this.tooltipData?.id === item?.functionId) {
      return;
    }
    this.tooltipData = {
      id: item?.functionId,
      name: item?.seqFunctionName,
      why: item?.why,
      what: item?.what,
      lastUpdatedTime: item?.createdBy?.dateTime,
      firstName: item?.createdBy?.firstName || null,
      lastName: item?.createdBy?.lastName || null,
      email: item?.createdBy?.userEmailId || '',
      toolTipType: ToolTipType.Acess_Info,
      userId: item?.createdBy?.userId || '',
      componentType: this.SequenceFunctionsComponent
    }
  }

  onMouseOut() {
    this.enableTableEdit = false;
  }

  dropdownListAccordion(type: any) {
    this.dropdownAccordion[type] = !this.dropdownAccordion[type];
  }

  searchCustomBlocksOnDropDownList(searchText: string) {
    this.customBlocksSearchText = searchText || '';
    if (searchText && searchText?.length) {
      this.dropdownAccordion.createdByMeFunctions = true;
      this.dropdownAccordion.createdByOtherFunctions = true;
      const text = searchText.toLowerCase();
      this.searchBlocksOnDropDownListOnInternal(text);
    } else {
      this.clearFilterSearch();
    }
  }

  searchBlocksOnDropDownListOnInternal(text: string) {
    if (this.duplicateFunctionBlock?.createdByMeFunctions?.length) {
      const personalBlocks = ObjectUtil.deepClone(this.duplicateFunctionBlock.createdByMeFunctions);
      this.dropdownFunctionsList.createdByMeFunctions = this.functionBlockFilter(personalBlocks, text);
    }
    if (this.duplicateFunctionBlock?.createdByOtherFunctions?.length) {
      const sharedByOthersBlocks = ObjectUtil.deepClone(this.duplicateFunctionBlock.createdByOtherFunctions);
      this.dropdownFunctionsList.createdByOtherFunctions = this.functionBlockFilter(sharedByOthersBlocks, text);
    }

    this.buildVirtualFunctionsList();
  }

  functionBlockFilter(array: any, text: any) {
    return array.filter((x: any) => x.seqFunctionName.toLowerCase().includes(text));
  }

  updateBlockLikeBookmark(type: string, item: any) {
    if (item['showLikeAnimation'] || item['showBookmarkAnimation']) return;
    const animationDuration = type === 'LIKE' ? ANIMATION_DURATIONS.LIKE : ANIMATION_DURATIONS.BOOKMARK;
    if (type == 'LIKE') {
      item.likedByLoggedInUser = !item.likedByLoggedInUser;
      if (item.likedByLoggedInUser) {
        item.noOfLikes += 1;
        item['showLikeAnimation'] = true;
        setTimeout(() => {
          delete item['showLikeAnimation'];
        }, animationDuration);
      } else {
        item.noOfLikes -= 1;
        delete item['showLikeAnimation'];
      }
    } else {
      item.bookmarkedByLoggedInUser = !item.bookmarkedByLoggedInUser;
      if (item.bookmarkedByLoggedInUser) {
        item['showBookmarkAnimation'] = true;
        setTimeout(() => {
          delete item['showBookmarkAnimation'];
        }, animationDuration);
      } else {
        delete item['showBookmarkAnimation'];
      }
    }

    let payload = {
      "componentId": item?.functionId,
      "componentType": this.SequenceFunctionsComponent,
      "activityType": type,
      "value": type == 'LIKE' ? item.likedByLoggedInUser : item.bookmarkedByLoggedInUser
    }

    this.siteSequencerService.updateLikeOrBookmark(payload).subscribe({
      next: (res: string) => {
        if (res) {
          // Reset search criteria and clear input when like or bookmark is updated
          this.isLikeUnlikeRefresh = true;
          this.customBlocksSearchText = '';
          this.clearSearchInputFromParent();
          setTimeout(() => {
            this.setUpdatedFunctionsBlockData();
          }, animationDuration);
        }
      },
      error: (error) => {
        this.showToast('error', `${error.message}`);
      }
    });
  }

  get SequenceFunctionsComponent() {
    switch (this.categoryMenu.selectedCategory.id) {
      case Category.CLOUD:
        return componentType.CLOUD;
      case Category.SYSTEM:
        return componentType.SYSTEM;
      case Category.DEVICE:
        return componentType.DEVICE;
      default:
        return componentType.CLOUD;
    }
  }

  clearSearchInputFromParent() {
    const searchInput = (document.querySelector('puc-common-search input.searchTextField') as HTMLInputElement);
    if (searchInput) {
      searchInput.value = ''; // Clear the input value
    }
    if ((this.commonSearch as any)?.searchValue !== undefined) {
      (this.commonSearch as any).searchValue = ''; // Clear searchValue property on CommonSearchComponent
    }
  }

  // Method to typed search text back into the search box after a reload.
  setSearchInputValue(text: string) {
    const searchInput = (document.querySelector('puc-common-search input.searchTextField') as HTMLInputElement);
    if (searchInput) {
      searchInput.value = text;
    }
  }

  setUpdatedFunctionsBlockData() {
    // Skipping the list refresh API call if already in progress
    if (this.isListRefreshInProgress) {
      return;
    }
    this.isListRefreshInProgress = true; // Setting the flag to true before making the API call

    this.recommendedAIItems = [];
    this.isAISearchLoading = false;
    this.isAISearchActive = false;
    this.siteSequencerService.getSequenceFunctionsList(this.SequenceFunctionsComponent, this.selectedQuickFilters).subscribe((res: any) => {
      if (res) {
        this.isListRefreshInProgress = false; // Resetting the flag after receiving the response
        const createdByMeList = this.mergeSequenceFunctionListWithExisting(res.createdByMeList, this.categories.CREATED_BY_ME);
        const createdByOthers = this.mergeSequenceFunctionListWithExisting(res.createdByOthers, this.categories.SHARED_BY_OTHERS);
        this.sequencerFunctionCollection = [...createdByMeList, ...createdByOthers];

        // Setting the type for each block 
        this.sequencerFunctionCollection.forEach((blockObj: any) => {
          const defaultType = `fn_${blockObj.functionId}`;
          blockObj['type'] = defaultType;
        });
        this.duplicateFunctionBlock.createdByMeFunctions = ObjectUtil.deepClone(createdByMeList);
        this.duplicateFunctionBlock.createdByOtherFunctions = ObjectUtil.deepClone(createdByOthers);
        this.dropdownFunctionsList.createdByMeFunctions = ObjectUtil.deepClone(createdByMeList);
        this.dropdownFunctionsList.createdByOtherFunctions = ObjectUtil.deepClone(createdByOthers);
      
      } else {
        this.isListRefreshInProgress = false;
        this.sequencerFunctionCollection = [];
        this.isLoading = false;
      }
      this.buildVirtualFunctionsList();
      // Re-applying the search text typed by the user only when not refreshed due to like/bookmark.
      if (!this.isLikeUnlikeRefresh && this.customBlocksSearchText.length) {
        this.searchBlocksOnDropDownListOnInternal(this.customBlocksSearchText.toLowerCase());
        setTimeout(() => this.setSearchInputValue(this.customBlocksSearchText));
      }
      this.isLikeUnlikeRefresh = false; // Reset like/bookmark refresh flag
    }, (err) => {
      this.isListRefreshInProgress = false;
      this.isLoading = false;
      this.isLikeUnlikeRefresh = false; // Reset like/bookmark refresh flag on error
      this.showToast('error', `${err.message}`)
    });
  }

  likeCountFormat(count: number) {
    if (count < 1000) {
      return count.toString();
    } else {
      const roundedNumber: string = (Math.floor(count / 100) / 10).toFixed(1);
      return `${roundedNumber}k`;
    }
  }

  drop(event: any, draggedFunctionConfig: any) {
    this.tryAddDraggedFunctionToWorkspace(event, draggedFunctionConfig);
  }

  onFunctionBlockDragEnded(event: any, draggedFunctionConfig: any) {
    this.handleCursorType('dragEnded', event);
    const dropPoint = this.getDropPoint(event);
    const element = dropPoint ? document.elementFromPoint(dropPoint.x, dropPoint.y) as Element | null : null;
    if (this.isCustomBlocksMenuDropTarget(element)) {
      // Explicitly reset drag state when released over menu list so preview does not persist.
      event?.source?.reset?.();
      return;
    }
    this.tryAddDraggedFunctionToWorkspace(event, draggedFunctionConfig);
  }

  handleCursorType(eventType: any, event: any) {
    if (eventType === 'dragStarted') {
      document.body.style.cursor = 'grabbing';
      this.isDraggingFunctionBlock = true;
    } else if (eventType === 'dragEnded') {
      document.body.style.cursor = 'default';
      this.isDraggingFunctionBlock = false;
    } else if (eventType === 'dropped') {
      document.body.style.cursor = 'default';
      this.isDraggingFunctionBlock = false;
    } else if (eventType === 'moved') {
      document.body.style.cursor = 'grabbing';
      this.isDraggingFunctionBlock = true;
      const element = document.elementFromPoint(event.pointerPosition.x, event.pointerPosition.y) as Element | null;
      this.lastDragPointerPosition = { x: event.pointerPosition.x, y: event.pointerPosition.y };
      document.body.style.cursor = this.isBlockWorkspaceDropTarget(element, this.lastDragPointerPosition) ? 'grabbing' : 'no-drop';
    }
  }

  onFunctionBlockDragStarted(event: any) {
    this.handleCursorType('dragStarted', event);
    const element = event?.source?.element?.nativeElement as HTMLElement | undefined;
    const pointerEvent = event?.event as MouseEvent | TouchEvent | undefined;
    if (!element || !pointerEvent) {
      this.dragPointerOffset = { x: 0, y: 0 };
      return;
    }
    const rect = element.getBoundingClientRect();
    const clientX = (pointerEvent as TouchEvent).touches?.[0]?.clientX ?? (pointerEvent as MouseEvent).clientX;
    const clientY = (pointerEvent as TouchEvent).touches?.[0]?.clientY ?? (pointerEvent as MouseEvent).clientY;
    if (clientX == null || clientY == null) {
      this.dragPointerOffset = { x: 0, y: 0 };
      return;
    }
    this.dragPointerOffset = {
      x: clientX - rect.left,
      y: clientY - rect.top
    };
    this.lastDragPointerPosition = { x: clientX, y: clientY };
  }

  private getDropPoint(event: any): { x: number; y: number } | null {
    if (event?.dropPoint) {
      return event.dropPoint;
    }
    if (event?.pointerPosition) {
      return event.pointerPosition;
    }
    const pointerEvent = event?.event as MouseEvent | TouchEvent | undefined;
    if (pointerEvent) {
      const clientX = (pointerEvent as TouchEvent).changedTouches?.[0]?.clientX ??
        (pointerEvent as TouchEvent).touches?.[0]?.clientX ??
        (pointerEvent as MouseEvent).clientX;
      const clientY = (pointerEvent as TouchEvent).changedTouches?.[0]?.clientY ??
        (pointerEvent as TouchEvent).touches?.[0]?.clientY ??
        (pointerEvent as MouseEvent).clientY;
      if (clientX != null && clientY != null) {
        return { x: clientX, y: clientY };
      }
    }
    return this.lastDragPointerPosition;
  }

  private isBlockWorkspaceDropTarget(element: Element | null, dropPoint?: { x: number; y: number } | null): boolean {
    if (element?.classList?.contains('blocklyMainBackground')) {
      return true;
    }
    if (element?.closest('.blocklyMainBackground') || element?.closest('.blocklySvg')) {
      return true;
    }
    const container = document.getElementById(this.blocklyContainerId);
    if (container) {
      if (element && element.closest(`#${this.blocklyContainerId}`)) {
        return true;
      }
      if (dropPoint) {
        const rect = container.getBoundingClientRect();
        if (
          dropPoint.x >= rect.left &&
          dropPoint.x <= rect.right &&
          dropPoint.y >= rect.top &&
          dropPoint.y <= rect.bottom
        ) {
          return true;
        }
      }
    }
    return false;
  }

  private isCustomBlocksMenuDropTarget(element: Element | null): boolean {
    if (!element) {
      return false;
    }
    return !!element.closest(
      '.custom-blocks-menu, #custom-blocks-dropdown, #custom-blocks-container, .list-menu-functions, .functions-virtual-viewport'
    );
  }

  private tryAddDraggedFunctionToWorkspace(event: any, draggedFunctionConfig: any): void {
    const dropPoint = this.getDropPoint(event);
    if (!dropPoint || !this.blocklyWorkSpace) {
      return;
    }
    const element = document.elementFromPoint(dropPoint.x, dropPoint.y) as Element | null;
    if (this.isCustomBlocksMenuDropTarget(element)) {
      return;
    }
    if (this.isBlockWorkspaceDropTarget(element, dropPoint)) {
      this.addSelectedFunctionBlockInWorkspace(event, draggedFunctionConfig);
    }
  }

  /**  
  *  get the sequence block type based on the selected category
  */
  get sequenceBlockType() {
    switch (this.categoryMenu.selectedCategory.id) {
      case Category.CLOUD:
        return [BlockType.SEQUENCE, BlockType.MQTT_SUBSCRIBE];
      case Category.SYSTEM:
        return [BlockType.SEQUENCE_SYSTEM];
      case Category.DEVICE:
        return [BlockType.SEQUENCE_DEVICE];
      default:
        return [BlockType.SEQUENCE];
    }
  }

  searchbtnClicked() {
    this.isSearchActive = true;
  }

  /**
   * Searches for a sequence based on the provided search text.
   * @param searchText - The text to search for.
   */
  searchSequence(searchText: string) {
    this.searchText = searchText;
    if (this.searchText && this.searchText.length) {
      this.searchSequences(this.searchText);
    } else {
      this.canvasTabs.tabs = this.tempCanvasTabs;
    }
  }

  /**
   * Searches for sequences based on the provided search text.
   * Updates the canvasTabs and sequenceTabs arrays with the filtered results.
   * @param searchText - The text to search for in the sequence names.
   */
  searchSequences(searchText: string) {
    this.canvasTabs.tabs = this.tempCanvasTabs.filter((sequence: any) => sequence.name.toLowerCase().includes(searchText.toLowerCase()));
    this.sequenceTabs = this.sequenceTabs.filter((sequence: any) => sequence.seqName.toLowerCase().includes(searchText.toLowerCase()));
  }

  /**
   * Opens the menu for the given canvas data.
   * @param event - The mouse event that triggered the menu opening.
   * @param canvasdata - The data associated with the canvas.
   */
  openMenu(event: MouseEvent, canvasdata: any): void {
    this.clearOpenMenu();
    event.preventDefault(); // Prevent the default context menu from appearing
    const target = event.target as HTMLElement;
    const rect = target?.getBoundingClientRect();

    this.contextMenuPostion.x = rect?.left;
    this.contextMenuPostion.y = rect?.top;
    canvasdata.showMenu = true;
  }

  /**
   * Clears the canvas search by resetting the search text, deactivating the search,
   * and restoring the original tabs.
   */
  clearCanvasSearch() {
    this.searchText = '';
    this.isSearchActive = false;
    this.canvasTabs.tabs = this.tempCanvasTabs;
  }

  /**
   * Closes the search and sets the isSearchActive flag to false if the searchText is empty.
   */
  closeSearch() {
    if (this.searchText == '') {
      this.isSearchActive = false;
    }
  }

  canvasClicked(canvasTab: any) {
    clearTimeout(this.clickTimer);
    this.clickTimer = setTimeout(() => {
      this.switchToSelectedTab(canvasTab);
    }, 300);
  }

  canvasDblClicked(canvasTab: any) {
    clearTimeout(this.clickTimer);
    this.clearRenameCanvas();
    canvasTab.isCanvasNameEdit = true;
    // Setting the focus on the input field after the input is rendered.
    setTimeout(() => {
      this.renameInput.nativeElement.focus();
    }, 0);
  }

  /**
   * Clears the open menu for all canvas tabs.
   */
  clearOpenMenu() {
    this.canvasTabs.tabs.map((canvasObj: any) => canvasObj.showMenu = false);
  }

  clearRenameCanvas() {
    this.canvasTabs.tabs.map((canvasObj: any) => canvasObj.isCanvasNameEdit = false);
  }

  /**
   * Toggling input field on canvas tab to rename the canvas.
   * @param {any} canvasTab - The canvas tab to be renamed.
   * @param {MouseEvent} event - The mouse event that triggered the rename. 
   */
  showRenameCanvasInput(canvasTab: any, event: MouseEvent) {
    event.stopPropagation();
    canvasTab.showMenu = false;
    this.clearRenameCanvas();
    canvasTab.isCanvasNameEdit = true;
    // Setting the focus on the input field after the input is rendered.
    setTimeout(() => {
      this.renameInput.nativeElement.focus();
    }, 0);
  }

  /**
   * checking the provided value in the input with the existing canvas name and appending a unique value if the name already exists.
   * @param {any} canvasTab - The canvas tab to be renamed.
   */
  renameCanvasText(canvasTab: any) {
    const oldCanvasName = canvasTab.name;
    if (canvasTab.tempName == '') {
      canvasTab.tempName = canvasTab.name;
    } else if (canvasTab.name != canvasTab.tempName) {
      if (canvasTab.tempName.length > 40) {
        this.showToast('error', 'Canvas name should not exceed 40 characters');
      } else {
        const newName = this.createUniqueValueForKey(canvasTab.tempName, 'name', this.tempCanvasTabs, '-');
        if (newName.length > 40) {
          this.showToast('error', 'Canvas name should not exceed 40 characters');
        } else {
          canvasTab.tempName = this.createUniqueValueForKey(canvasTab.tempName, 'name', this.tempCanvasTabs, '-');
          canvasTab.name = canvasTab.tempName;
          this.renameWorkSpace(canvasTab, oldCanvasName);
        }
      }
    }
    canvasTab.isCanvasNameEdit = false;
  }

  /**
   * Renames the selected canvas tab and shows a success message.
   * @param {any} selectedCanvasTab - The canvas tab to be renamed.
   */
  renameWorkSpace(selectedCanvasTab: any, oldCanvasName: any) {
    let xml = selectedCanvasTab.workspaceXml;
    let workspaceRef: any = {
      "siteRef": this.selectedSiteId,
      "workspaceXml": xml || '',
      "category": this.categoryMenu.selectedCategory.id,  // "category": "CLOUD" or "CCU" or "DEVICE"
      "name": selectedCanvasTab.name,
      "id": selectedCanvasTab.id
    }

    this.siteSequencerService.saveWorkspace(workspaceRef).subscribe((res) => {
      this.updateWorkspaceXMLInCanvasTab(selectedCanvasTab, workspaceRef)
      this.searchSequence(this.searchText);
      const targetSequenceIndex = this.sequences.findIndex((seq: any) => seq.workspaceId == selectedCanvasTab.id);
      if (targetSequenceIndex >= 0) {
        this.sequences[targetSequenceIndex].seqName = selectedCanvasTab.name;
      }

      this.showToast('success', 'Workspace Renamed successfully');
      if (this.categoryMenu.selectedCategory.id == Category.DEVICE && this.canvasTabs.selectedCanvasTab?.id == selectedCanvasTab.id) {
        this.saveAllSequences()
      }
    }, (err) => {
      this.showToast('error', `${err.message}`);
    });
  }

  updateWorkspaceXMLInCanvasTab(selectedCanvasTab: any, workspaceRef: any) {
    let tempCanvasIndex = this.tempCanvasTabs.findIndex((tab: any) => tab.id == selectedCanvasTab.id);
    let tabIndex = this.canvasTabs.tabs.findIndex((tab: any) => tab.id == selectedCanvasTab.id);
    if (tempCanvasIndex > -1) {
      this.tempCanvasTabs[tempCanvasIndex] = selectedCanvasTab;
      this.tempCanvasTabs[tempCanvasIndex].workspaceXml = workspaceRef.workspaceXml;
    }
    if (tabIndex > -1) {
      this.canvasTabs.tabs[tabIndex] = selectedCanvasTab;
      this.canvasTabs.tabs[tabIndex].workspaceXml = workspaceRef.workspaceXml;
    }
  }

  /**
   * Deletes the canvas tab and hides the menu.
   * @param canvasTab - The canvas tab to be deleted.
   */
  deleteCanvas(canvasTab: any, event: MouseEvent) {
    event.stopPropagation();
    this.isLoading = true;
    this.siteSequencerService.getAllSequencesPerWorkspace(this.selectedSiteId, canvasTab.id)
      .subscribe((res) => {
        if (res) {
          this.isLoading = false;
          canvasTab.showMenu = false;
          const sequenceFunctionUsage: any = {
            "sequenceCount": res.length,
          };
          sequenceFunctionUsage['eventType'] = 'delete';
          const dialogRef = this.dialog.open(EditAndDeleteConfirmationModalComponent, {
            panelClass: 'fs-mat-dialog-container',
            minWidth: '400px',
            // Escape dismisses only this active confirmation dialog.
            disableClose: false
          });
          const title = `Are you sure you want to delete ${canvasTab.name}?`;
          const subTitle = 'this action cannot be undone';
          dialogRef.componentInstance.title = title;
          dialogRef.componentInstance.subTitle = subTitle;
          dialogRef.componentInstance.sequenceFunction = sequenceFunctionUsage;
          dialogRef.componentInstance.type = 'confirm';
          dialogRef.componentInstance.confirmBtnText = 'delete';
          dialogRef.componentInstance.showConfirmIcon = true;
          dialogRef.updatePosition({ top: '60px' });
          dialogRef.componentInstance.isCanvasAction = true;
          dialogRef.afterClosed().subscribe(result => {
            // On delete confirmation
            if (result && result == 'confirm') {
              this.isLoading = true;
              this.siteSequencerService.deleteWorkspace(this.selectedSiteId, canvasTab.id)
                .subscribe((result) => {
                  if (result && result.id === canvasTab.id) {
                    this.isSequenceTabSelected = false;
                    this.selectedSequenceTab = null;
                    this.resetSequenceLogs();
                    this.sequenceTabs = [];
                    this.deviceRunBlocksOnWorkspace = []; // Clearing the existing device run blocks on workspace
                    this.canvasTabs.tabs = this.canvasTabs.tabs.filter((tab: any) => tab.id !== canvasTab.id);
                    this.tempCanvasTabs = this.tempCanvasTabs.filter((tab: any) => tab.id !== canvasTab.id);
                    this.isLoading = false;
                    this.blocklyWorkSpace?.clear();
                    this.showToast('success', `Workspace ${canvasTab.name} deleted succesfully`);
                    if (this.canvasTabs.tabs.length > 0 && this.tempCanvasTabs.length > 0) {
                      const isInitWorkspace = false;
                      const isDeletingWorkspace = true;
                      this.switchToSelectedCanvasTab(this.canvasTabs.tabs[0], isInitWorkspace, isDeletingWorkspace);
                    } else {
                      const initWorkspace = true;
                      const categoryLevelTabConfig = { 'index': this.categoryMenu.activeTabIndex, 'tab': { "textLabel": this.categoryMenu.selectedCategory.label } };
                      this.toggleCategoryLevelTab(categoryLevelTabConfig, initWorkspace);
                    }
                  }
                }, (err: any) => {
                  this.isLoading = false;
                  this.showToast('error', err?.error && err?.error?.error ? err?.error?.error : `Something went wrong in deleting workspace ${canvasTab.name} , please click delete button again.`);
                })
            }
          });
        }

      }, (err: any) => {
        this.isLoading = false;
        this.showToast('error', err?.error && err?.error?.error ? err?.error?.error : `Something went wrong in deleting workspace ${canvasTab.name} , please click delete button again.`);
      });
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    this.clearOpenMenu();
  }

  /**
  * Appends ellipses to a text.
  * @param textToFormat - The text to append ellipses to.
  */
  appendEllipse(textToFormat: string) {
    if (textToFormat && textToFormat.length >= 5) {
      return textToFormat.slice(0, 5) + '...';
    } else {
      return textToFormat;
    }
  }


  downloadFile(data: any, filename: string) {
    const element = document.createElement('a');
    let url = '';
    if (filename.includes('.py')) {
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(data));
      element.setAttribute('download', filename);
      element.style.display = 'none';
    } else {
      url = window.URL.createObjectURL(data);
      element.href = url;
      element.download = filename;
    }
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
    window.URL.revokeObjectURL(url);
  }

  searchSequenceLogs(searchedValue: any) {
    this.searchedSequenceLogsValue = searchedValue;
  }

  pythonToMicropython(code: string) {
    // String which is inserted by Blockly to import the numbers module
    // This is not supported by Micropython and needs to be removed
    const PYTHON_IMPORT_NUMBERS_STRING = 'from numbers import Number';

    // Remove the import numbers statement
    code = code.replace(PYTHON_IMPORT_NUMBERS_STRING, '');

    // Number is not supported by Micropython, replace with int or float
    const isInstanceCode = "isinstance(myVariable, Number)";
    code = code.replace(/isinstance\((\w+), Number\)/g, 'isinstance($1, (int,float))');

    return code;
  }

  /**
   * Downloads the sequence code as a MicroPython file.
   * If the selected canvas tab has a name, it will be used as the filename.
   * Otherwise, an empty string will be used as the filename.
   * @returns {Promise<void>} A promise that resolves when the download is complete.
   */
  async downLoadSequence() {
    try {
      let filename = this.canvasTabs.selectedCanvasTab?.name || '';
      if (!this.code) {
        this.validateBlocklyLogic();
      }
      this.siteSequencerService.getMicroPythonConversion(this.code, filename).subscribe(async (res: any) => {
        let firmwareFile = await DFU.readBlobContent(res)
        if (firmwareFile.byteLength > 65536) {
          // Code to handle the case when firmwareFile byte length is greater than 64KB
          this.showToast('error', `The sequence size must be less than 64KB to upload to the device. Please reduce the size and try again.`);
          return;
        }
        this.webusbConnect(res);
      }, (err: any) => {
        console.log(err);
        this.showToast('error', `Something went wrong in downloading the sequence code, please try again.`);
      })

    } catch (error) {
      this.showToast('error', `Failed to connect to Device.`);
    }
  }

  async webusbConnect(blob: any) {
    try {
      let filters = [];

      filters.push({ 'vendorId': '0x0483' });
      navigator.usb.requestDevice({ 'filters': filters }).then(
        async (selectedDevice: any) => {
          let interfaces = DFU.findDeviceDfuInterfaces(selectedDevice);
          if (interfaces.length == 0) {
            this.showToast('error', `The selected device does not have any USB DFU interfaces`);

          } else {
            await DFU.fixInterfaceNames(selectedDevice, interfaces);
            let flashInterface: any = interfaces.find((x: any) => x.name?.includes('Internal Flash'));
            if (flashInterface) {
              selectedDevice = await DFU.connect(new Device(selectedDevice, flashInterface));
            } else {
              this.showToast('error', `The selected device does not have any USB DFU interfaces.`);
              return;
            }
            try {
              let metadata = await DFU.generateMetadata(blob, this.canvasTabs.selectedCanvasTab?.name || '')
              await DFU.upload(selectedDevice, blob, 1024, DFU.SEQUENCE_ADDERESS, false);
              await DFU.upload(selectedDevice, metadata, 1024, DFU.SEQUENCE_META_ADDERESS, true);
              this.showToast('success', `Sequence uploaded to the device successfully.`);
            } catch (error) {
              this.showToast('error', `Failed to upload the file to the device.`);
            }


          }
        }
      ).catch((error: any) => {
        this.showToast('error', `Failed to connect to Device.`);
        let filename = this.canvasTabs.selectedCanvasTab?.name || '';
        this.downloadFile(blob, filename + ".mpy")
      });
    } catch (error) {
      this.showToast('error', `Failed to connect to Device.`);
      console.error('Error connecting to micro:bit:', error);
    }
  }

  get ownerDetails() {
    if (this.hoveredFunctionBlock) {
      let firstName = this.hoveredFunctionBlock?.createdBy?.firstName != null ? this.hoveredFunctionBlock?.createdBy?.firstName : ""
      let lastName = this.hoveredFunctionBlock?.createdBy?.lastName != null ? this.hoveredFunctionBlock?.createdBy?.lastName : ""
      let ownerDetails = (firstName || lastName) ? (firstName + " " + lastName) : this.hoveredFunctionBlock?.createdBy?.userEmailId;
      ownerDetails = this.hoveredFunctionBlock?.createdBy?.userId && this.hoveredFunctionBlock?.createdBy?.userId === 'external' ? `${ownerDetails}(External)` : `${ownerDetails}`;
      return ownerDetails;
    }
  }

  // Function to generate a random string of length 10
  generateRandomString() {
    const length = 10;
    const createCharacterArray = () => {
      const charArray: any[] = [];
      const baseArray = [...Array(62)];
      baseArray.forEach((char, i) => {
        const charCode = i + (i < 10 ? 48 : (i < 36 ? 55 : 61));
        charArray.push(String.fromCharCode(charCode));
      });
      return charArray.join('');
    };

    const characters = createCharacterArray();
    let result = '';
    const baseArray = [...Array(length)];
    baseArray.forEach(() => {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    });
    return result;
  }

  getAIRecommendedItems(searchtext: string) {
    const requestId = ++this.aiSearchRequestId;
    if (this.selectedQuickFilters.length) {
      this.selectedQuickFilters = [];
      this.setUpdatedFunctionsBlockData();
    }
    this.recommendedAIItems = [];
    const selectedCategoryId = this.categoryMenu.selectedCategory.id;
    const category =
      selectedCategoryId === Category.SYSTEM
        ? SiteSequencerCategory.SYSTEM
        : selectedCategoryId === Category.DEVICE
          ? SiteSequencerCategory.DEVICE
          : SiteSequencerCategory.DEFAULT;

    this.isAISearchLoading = true;
    this.isAISearchActive = true;
    this.startLoadingAnimation();

    this.siteSequencerService.getitemsRecommendedByAISearch(searchtext, 'seq-functions', category).subscribe({
      next: (res: any) => {
        if (requestId !== this.aiSearchRequestId) {
          return;
        }
        const elementIds = res.map((item: any) => item.id);

        const createdByMeFunctions = this.duplicateFunctionBlock.createdByMeFunctions || [];
        const createdByOtherFunctions = this.duplicateFunctionBlock.createdByOtherFunctions || [];

        const allFunctions = [...createdByMeFunctions, ...createdByOtherFunctions];

        // Find matching elements and assign type
        this.recommendedAIItems = allFunctions
          .filter((functionItem: any) => elementIds.includes(functionItem.functionId))
          .map((functionItem: any) => ({
            ...functionItem,
            type: createdByMeFunctions.some((item: any) => item.functionId === functionItem.functionId) ? 'createdByMeFunctions' : 'createdByOtherFunctions'
          }));

        this.isAISearchLoading = false;
      },
      error: (err) => {
        if (requestId !== this.aiSearchRequestId) {
          return;
        }
        this.recommendedAIItems = [];
        this.isAISearchLoading = false;
        this.showToast('error', `Something went wrong in fetching AI Items`);

      }
    });
  }

  startLoadingAnimation() {
    if (this.loadingInterval) return; // Avoid duplicate intervals

    this.loadingInterval = setInterval(() => {
      if (!this.isAISearchLoading) {
        clearInterval(this.loadingInterval);
        this.loadingInterval = null;
        this.loadingText = 'Loading';
        return;
      }

      const dots = (this.loadingText.match(/\./g) || []).length;
      this.loadingText = 'Loading' + '.'.repeat((dots + 1) % 5);
    }, 200);
  }

  get createdByMeFunctions() {
    return this.dropdownFunctionsList.createdByMeFunctions.length;
  }

  get createdByOtherFunctions() {
    return this.dropdownFunctionsList.createdByOtherFunctions.length;
  }

  /**
   * Method to save all sequences and workspaceXML when switching tabs.
   */
  async saveSequenceOnTabChange() {
    if (!this.noChangesInWorkspace) {
      // If blocks are valid, switch the tab after saving workspace state.
      await this.saveWorkspaceXML();
      await this.saveAllSequences(true);
    }
  }

  openDebugInfoModal() {
    const dialogRef = this.dialog.open(DeliveryDebugInfoModalComponent, {
      panelClass: ['fs-mat-dialog-container', 'full-height', 'no-padding'],
      width: '800px',
      // Let the active delivery log dialog close on Escape.
      disableClose: false,
      autoFocus: false
    });
    dialogRef.componentInstance.sequenceId = this.sequences[0].seqId;
    dialogRef.componentInstance.sequenceName = this.sequences[0]?.seqName ?? '';
    dialogRef.componentInstance.siteId = this.selectedSiteId;
    dialogRef.componentInstance.isDeliveryLogsPopup = false;
    dialogRef.updatePosition({ top: '60px' });
  }


  /**
   * Method to hide specific fields in a block.
   * @param block - The block from which fields need to be hidden.
   * @param fieldNames - An array of field names to be hidden.
   */
  hideBlockFields(block: any, fieldNames: string[]) {
    fieldNames.forEach((fieldName: string) => {
      const field = block.getField(fieldName);
      if (field) {
        field.setVisible(false);
      }
    });
    this.blocklyWorkSpace.render();
  }
  /**Gets triggered once we have api response for subscription details
   sets billing admin details and checks if user has acccess to feature or not**/
  checkIfSiteIsSubscribed(subscriptionData: any) {
    this.featureAccessible = this.subscriptionManagementService.hasFeature(subscribedFeatures.SITE_SEQUENCER);
    this.billingAdminDetails = ObjectUtil.deepClone(subscriptionData);
    this.restrictionType = this.subscriptionManagementService.getRestrictionType(this.featureAccessible, subscriptionData, subscribedFeatures.SITE_SEQUENCER);
  }


  ngOnDestroy() {
    this.stopPythonExecution();
    this.detachCodeSnippetWindowListeners();
    clearTimeout(this.blocklyInitRetryTimer);
    this.blocklyInitRetryTimer = null;
    this.blocklyInitRetryCount = 0;
    this.pendingWorkspaceCreateAfterBlocklyReady = false;

    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }

    // Clear interval for sequence logs subscription
    if (this.sequenceLogsSubscription) {
      clearInterval(this.sequenceLogsSubscription);
    }
  }

  // Opens the comments panel with the selected sequencer data.
  openCommentsPanel(functionData: any) {
    this.commentsPanelView = true;
    this.activeCommentsPanelConfig.componentId = functionData.functionId;
    this.activeCommentsPanelConfig.componentName = functionData.seqFunctionName;
    this.activeCommentsPanelConfig.componentOwnerId = functionData?.createdBy?.userId || '';
    this.toggleFilterPanelStyles(true);
  }

  // Toggles the styles for the filter panel based on its comments open/close state.
  toggleFilterPanelStyles(open: boolean) {
    const listMenu = document.querySelector('.custom-blocks-menu');
    if (!listMenu) return;
    listMenu.classList.toggle('list-menu-comments-view', open);
  }


  // Closes the comments panel and updates the comments indicator status.
  closeCommentsPanel() {
    this.commentsPanelView = false;
    this.updateCommentsIndicatorStatus(this.dropdownFunctionsList.createdByMeFunctions, this.activeCommentsPanelConfig.componentId);
    this.updateCommentsIndicatorStatus(this.duplicateFunctionBlock.createdByMeFunctions, this.activeCommentsPanelConfig.componentId);
    this.activeCommentsPanelConfig.componentId = '';
    this.activeCommentsPanelConfig.componentName = '';
    this.activeCommentsPanelConfig.componentOwnerId = '';
    this.toggleFilterPanelStyles(false);
  }

  // Updating the new comment (Dot icon) status in the sequencer function list
  updateCommentsIndicatorStatus(list: any[], componentId: string) {
    const functionData = list.find(item => item.functionId === componentId);
    if (functionData) {
      functionData.unreadCommentsExist = false;
    }
  }

  // Updating view on closing the pool popover
  sequenceBlocksPoolClosed() {
    this.selectedQuickFilters = [];
    this.commentsPanelView = false;
  }

  closeOnlyTextEditor() {
    if (Blockly?.WidgetDiv?.isVisible()) {
      Blockly.WidgetDiv.hide();
    }
  }


  /*  This function is used to build virtual functions list (Combining personal and shared)
 into a single list with accordion sections to support virtual scrolling.
 */
  buildVirtualFunctionsList() {
    this.virtualFunctionsBlockList = this.commonService.buildVirtualAccordionList([
      {
        key: 'createdByMeFunctions',
        title: `Created by me (${this.createdByMeFunctions || 0})`,
        isOpen: this.isPersonalAccordionOpen,
        items: this.dropdownFunctionsList?.createdByMeFunctions
      },
      {
        key: 'createdByOtherFunctions',
        title: `Shared by others (${this.createdByOtherFunctions || 0})`,
        isOpen: this.isSharedAccordionOpen,
        items: this.dropdownFunctionsList?.createdByOtherFunctions
      }
    ]);
    this.updateViewportHeightDynamically();
  }

  // This function is used to toggle accordion sections
  toggleAccordion(type: string) {
    if (type === 'createdByMeFunctions') {
      this.isPersonalAccordionOpen = !this.isPersonalAccordionOpen;
    } else {
      this.isSharedAccordionOpen = !this.isSharedAccordionOpen;
    }
    this.buildVirtualFunctionsList();
  }

  // This function is used to update viewport height dynamically based on accordion state and list length
  updateViewportHeightDynamically() {
    this.viewportHeight.set(
      this.commonService.getVirtualViewportHeight(
        this.isPersonalAccordionOpen,
        this.isSharedAccordionOpen,
        this.virtualFunctionsBlockList.length
      )
    );
  }

  // TrackBy function 
  trackById(index: number, item: any) {
    return item.id;
  }

  async executePythonCode() {
    try {
      this.stopPythonExecution();
      const canProceed = await this.validateBeforeDeviceAction();
      if (!canProceed) {
        return;
      }
      await this.downLoadSequence();

    } catch (err) {
      console.error('Error executing Python code:', err);
      this.stopPythonExecution();
    }
  }

  private async validateBeforeDeviceAction(): Promise<boolean> {
    return await this.runPythonValidationsBeforeAction();
  }

  private async runPythonValidationsBeforeAction(): Promise<boolean> {
    this.isPythonExecutionLoading = true;
    try {
      const [pythonResult, microPythonWasmResult] = await Promise.all([
        this.pythonExecutorService.executeWithStaticAnalysis(this.code),
        this.pythonExecutorService.executeWithMicroPythonWasm(this.code)
      ]);

      const pythonRun = pythonResult.runs?.[0] || { runIndex: 0, success: false };
      const microPythonRun = microPythonWasmResult.runs?.[0] || { runIndex: 0, success: false };

      const mergedResult: PythonExecutionBatchResult = {
        success: pythonResult.success && microPythonWasmResult.success,
        staticIssues: [
          ...(pythonRun.staticIssues || []),
          ...(microPythonRun.staticIssues || [])
        ],
        runs: [
          {
            ...pythonRun,
            runIndex: 0,
            output: undefined,
            sectionTitle: 'Python'
          },
          {
            ...microPythonRun,
            runIndex: 1,
            output: undefined,
            sectionTitle: 'MicroPython WASM'
          }
        ]
      };

      const runs = mergedResult.runs || [];
      const hasExecutionFailure = runs.some((run: any) =>
        !run.success ||
        !!run.error ||
        !!run.stack ||
        (run.staticIssues || []).some((issue: any) => issue?.severity === 'error')
      );
      const hasWarnings = runs.some((run: any) =>
        (run.staticIssues || []).some((issue: any) => issue?.severity === 'warning')
      );

      if (hasExecutionFailure) {
        this.isPythonExecutionLoading = false;
        await this.showPythonExecutionResultPopup(
          mergedResult,
          'Execution Results',
          'Static analysis errors or runtime exceptions found.'
        );
        return false;
      }

      this.isPythonExecutionLoading = false;
      const continueResult = await this.showPythonExecutionResultPopup(
        mergedResult,
        hasWarnings ? 'Execution Results' : 'Code Level Execution Status: Successful',
        hasWarnings ? 'Static analysis warnings found.' : 'No runtime or validation issues detected.',
        { showContinueButton: true, continueBtnText: 'Push to devices' }
      );

      return continueResult;
    } catch (err) {
      console.error('Error executing Python validations:', err);
      return false;
    } finally {
      this.isPythonExecutionLoading = false;
    }
  }

  async showPythonExecutionResultPopup(
    result: PythonExecutionBatchResult,
    title: string = 'Python Execution Results',
    subTitle: string = 'Static analysis warnings/errors or runtime exceptions found.',
    options?: { showContinueButton?: boolean; continueBtnText?: string }
  ): Promise<boolean> {
    const dialogRef = this.dialog.open(SequenceValidationPopupComponent, {
      panelClass: 'fs-mat-dialog-container',
      minWidth: '640px',
      // Python execution results follow the same topmost-dialog Escape behavior.
      disableClose: false
    });

    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.subTitle = subTitle;
    dialogRef.componentInstance.htmlContent = result.runs || [];
    dialogRef.componentInstance.type = 'python_execution';
    dialogRef.componentInstance.showContinueButton = !!options?.showContinueButton;
    if (options?.continueBtnText) {
      dialogRef.componentInstance.continueBtnText = options.continueBtnText;
    }
    dialogRef.updatePosition({ top: '60px' });
    const dialogResult = await lastValueFrom(dialogRef.afterClosed());
    return dialogResult === true;
  }

  private stopPythonExecution() {
    if (this.pythonExecutionIntervalRef) {
      clearInterval(this.pythonExecutionIntervalRef);
      this.pythonExecutionIntervalRef = null;
    }
    this.isPythonCycleInProgress = false;
  }
}
